import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/esnext.global-this.js";
import t, { useReducer as n, useContext as e, useRef as r, useState as i, useEffect as o, createContext as a, createElement as s, Fragment as u, forwardRef as c, Component as l, useMemo as d, useCallback as f, cloneElement as h, Children as p, isValidElement as m } from "react";
import v from "prop-types";
import g from "react-dom";

function y(t) {
  return (y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(t);
}

function b(t, n, e, r, i, o, a) {
  try {
    var s = t[o](a),
        u = s.value;
  } catch (t) {
    return void e(t);
  }

  s.done ? n(u) : Promise.resolve(u).then(r, i);
}

function x(t) {
  return function () {
    var n = this,
        e = arguments;
    return new Promise(function (r, i) {
      var o = t.apply(n, e);

      function a(t) {
        b(o, r, i, a, s, "next", t);
      }

      function s(t) {
        b(o, r, i, a, s, "throw", t);
      }

      a(void 0);
    });
  };
}

function w(t, n, e) {
  return n in t ? Object.defineProperty(t, n, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = e, t;
}

function E() {
  return (E = Object.assign || function (t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function S(t, n) {
  var e = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    n && (r = r.filter(function (n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), e.push.apply(e, r);
  }

  return e;
}

function C(t) {
  for (var n = 1; n < arguments.length; n++) {
    var e = null != arguments[n] ? arguments[n] : {};
    n % 2 ? S(Object(e), !0).forEach(function (n) {
      w(t, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : S(Object(e)).forEach(function (n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }

  return t;
}

function T(t, n) {
  if (t !== n) throw new TypeError("Cannot instantiate an arrow function");
}

function k(t, n) {
  return n || (n = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(n)
    }
  }));
}

function L(t, n) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, n) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
    var e = [],
        r = !0,
        i = !1,
        o = void 0;

    try {
      for (var a, s = t[Symbol.iterator](); !(r = (a = s.next()).done) && (e.push(a.value), !n || e.length !== n); r = !0) {
        ;
      }
    } catch (t) {
      i = !0, o = t;
    } finally {
      try {
        r || null == s.return || s.return();
      } finally {
        if (i) throw o;
      }
    }

    return e;
  }(t, n) || A(t, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function P(t) {
  return function (t) {
    if (Array.isArray(t)) return O(t);
  }(t) || function (t) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
  }(t) || A(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function A(t, n) {
  if (t) {
    if ("string" == typeof t) return O(t, n);
    var e = Object.prototype.toString.call(t).slice(8, -1);
    return "Object" === e && t.constructor && (e = t.constructor.name), "Map" === e || "Set" === e ? Array.from(t) : "Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? O(t, n) : void 0;
  }
}

function O(t, n) {
  (null == n || n > t.length) && (n = t.length);

  for (var e = 0, r = new Array(n); e < n; e++) {
    r[e] = t[e];
  }

  return r;
}

var B = {
  elements: [],
  isOpened: !1,
  options: {
    buttons: {
      backgroundColor: "rgba(30,30,36,0.8)",
      iconColor: "rgba(255, 255, 255, 0.8)",
      iconPadding: "5px",
      showAutoplayButton: !0,
      showCloseButton: !0,
      showDownloadButton: !0,
      showFullscreenButton: !0,
      showNextButton: !0,
      showPrevButton: !0,
      size: "40px"
    },
    settings: {
      autoplaySpeed: 3e3,
      disableKeyboardControls: !1,
      disablePanzoom: !1,
      disableWheelControls: !1,
      hideControlsAfter: 3e3,
      lightboxTransitionSpeed: .3,
      lightboxTransitionTimingFunction: "linear",
      overlayColor: "rgba(0, 0, 0, 0.9)",
      slideAnimationType: "fade",
      slideSpringValues: [300, 200],
      slideTransitionSpeed: .6,
      slideTransitionTimingFunction: "linear"
    },
    caption: {
      captionAlignment: "start",
      captionColor: "#FFFFFF",
      captionFontFamily: "inherit",
      captionFontSize: "inherit",
      captionFontStyle: "inherit",
      captionFontWeight: "inherit",
      captionContainerPadding: "0",
      captionTextTransform: "inherit",
      showCaption: !0
    },
    thumbnails: {
      showThumbnails: !0,
      thumbnailsAlignment: "center",
      thumbnailsContainerPadding: "0",
      thumbnailsContainerBackgroundColor: "transparent",
      thumbnailsGap: "0 1px",
      thumbnailsPosition: "bottom",
      thumbnailsOpacity: .4,
      thumbnailsSize: ["100px", "80px"]
    },
    progressBar: {
      backgroundColor: "#f2f2f2",
      fillColor: "#000000",
      height: "3px",
      showProgressBar: !0
    },
    translations: {
      autoplayText: "Play",
      closeText: "Close",
      downloadText: "Download",
      fullscreenText: "Full screen",
      nextText: "Next",
      pauseText: "Pause",
      previousText: "Previous",
      thumbnailsText: "Hide thumbnails",
      zoomOutText: "Zoom Out"
    }
  },
  selectedElement: {
    caption: "",
    height: 0,
    id: 0,
    source: "",
    thumbnail: "",
    width: 0
  },
  callbacks: {
    onCountSlides: function () {
      T(this, undefined);
    }.bind(void 0),
    onSlideChange: function () {
      T(this, undefined);
    }.bind(void 0),
    onLightboxClosed: function () {
      T(this, undefined);
    }.bind(void 0),
    onLightboxOpened: function () {
      T(this, undefined);
    }.bind(void 0)
  },
  customCaptions: [{}]
},
    R = t.createContext(B),
    D = function (e) {
  var r = this;
  T(this, undefined);

  var i = function (t, n) {
    switch (T(this, r), n.type) {
      case "GRAB_SETTINGS":
        return C(C({}, t), n.mergedSettings);

      case "GRAB_ELEMENTS":
        return C(C({}, t), {}, {
          elements: n.elements
        });

      case "HANDLE_ELEMENT":
        return C(C({}, t), {}, {
          isOpened: !0,
          selectedElement: C({}, n.element)
        });

      case "OPEN_AT_INDEX":
        return C(C({}, t), {}, {
          isOpened: !0,
          selectedElement: C({}, t.elements[n.index])
        });

      case "CLOSE_LIGHTBOX":
        return C(C({}, t), {}, {
          isOpened: !1
        });

      default:
        return t;
    }
  }.bind(this),
      o = L(n(i, B), 2),
      a = o[0],
      s = o[1];

  return t.createElement(R.Provider, {
    value: C(C({}, a), {}, {
      dispatch: s
    })
  }, e.children);
}.bind(void 0);

D.propTypes = {
  children: v.oneOfType([v.arrayOf(v.node), v.node]).isRequired
};
var N = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function z(t, n, e) {
  return t(e = {
    path: n,
    exports: {},
    require: function require(t, n) {
      return function () {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
      }(null == n && e.path);
    }
  }, e.exports), e.exports;
}

var M = z(function (t) {
  !function (n, e) {
    t.exports ? t.exports = e() : n.EvEmitter = e();
  }("undefined" != typeof window ? window : N, function () {
    function t() {}

    var n = t.prototype;
    return n.on = function (t, n) {
      if (t && n) {
        var e = this._events = this._events || {},
            r = e[t] = e[t] || [];
        return -1 == r.indexOf(n) && r.push(n), this;
      }
    }, n.once = function (t, n) {
      if (t && n) {
        this.on(t, n);
        var e = this._onceEvents = this._onceEvents || {};
        return (e[t] = e[t] || {})[n] = !0, this;
      }
    }, n.off = function (t, n) {
      var e = this._events && this._events[t];

      if (e && e.length) {
        var r = e.indexOf(n);
        return -1 != r && e.splice(r, 1), this;
      }
    }, n.emitEvent = function (t, n) {
      var e = this._events && this._events[t];

      if (e && e.length) {
        e = e.slice(0), n = n || [];

        for (var r = this._onceEvents && this._onceEvents[t], i = 0; i < e.length; i++) {
          var o = e[i];
          r && r[o] && (this.off(t, o), delete r[o]), o.apply(this, n);
        }

        return this;
      }
    }, n.allOff = function () {
      delete this._events, delete this._onceEvents;
    }, t;
  });
}),
    I = z(function (t) {
  /*!
   * imagesLoaded v4.1.4
   * JavaScript is all like "You images are done yet or what?"
   * MIT License
   */
  !function (n, e) {
    t.exports ? t.exports = e(n, M) : n.imagesLoaded = e(n, n.EvEmitter);
  }("undefined" != typeof window ? window : N, function (t, n) {
    var e = t.jQuery,
        r = t.console;

    function i(t, n) {
      for (var e in n) {
        t[e] = n[e];
      }

      return t;
    }

    var o = Array.prototype.slice;

    function a(t, n, s) {
      if (!(this instanceof a)) return new a(t, n, s);
      var u,
          c = t;
      ("string" == typeof t && (c = document.querySelectorAll(t)), c) ? (this.elements = (u = c, Array.isArray(u) ? u : "object" == typeof u && "number" == typeof u.length ? o.call(u) : [u]), this.options = i({}, this.options), "function" == typeof n ? s = n : i(this.options, n), s && this.on("always", s), this.getImages(), e && (this.jqDeferred = new e.Deferred()), setTimeout(this.check.bind(this))) : r.error("Bad element for imagesLoaded " + (c || t));
    }

    a.prototype = Object.create(n.prototype), a.prototype.options = {}, a.prototype.getImages = function () {
      this.images = [], this.elements.forEach(this.addElementImages, this);
    }, a.prototype.addElementImages = function (t) {
      "IMG" == t.nodeName && this.addImage(t), !0 === this.options.background && this.addElementBackgroundImages(t);
      var n = t.nodeType;

      if (n && s[n]) {
        for (var e = t.querySelectorAll("img"), r = 0; r < e.length; r++) {
          var i = e[r];
          this.addImage(i);
        }

        if ("string" == typeof this.options.background) {
          var o = t.querySelectorAll(this.options.background);

          for (r = 0; r < o.length; r++) {
            var a = o[r];
            this.addElementBackgroundImages(a);
          }
        }
      }
    };
    var s = {
      1: !0,
      9: !0,
      11: !0
    };

    function u(t) {
      this.img = t;
    }

    function c(t, n) {
      this.url = t, this.element = n, this.img = new Image();
    }

    return a.prototype.addElementBackgroundImages = function (t) {
      var n = getComputedStyle(t);
      if (n) for (var e = /url\((['"])?(.*?)\1\)/gi, r = e.exec(n.backgroundImage); null !== r;) {
        var i = r && r[2];
        i && this.addBackground(i, t), r = e.exec(n.backgroundImage);
      }
    }, a.prototype.addImage = function (t) {
      var n = new u(t);
      this.images.push(n);
    }, a.prototype.addBackground = function (t, n) {
      var e = new c(t, n);
      this.images.push(e);
    }, a.prototype.check = function () {
      var t = this;

      function n(n, e, r) {
        setTimeout(function () {
          t.progress(n, e, r);
        });
      }

      this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? this.images.forEach(function (t) {
        t.once("progress", n), t.check();
      }) : this.complete();
    }, a.prototype.progress = function (t, n, e) {
      this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded, this.emitEvent("progress", [this, t, n]), this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t), this.progressedCount == this.images.length && this.complete(), this.options.debug && r && r.log("progress: " + e, t, n);
    }, a.prototype.complete = function () {
      var t = this.hasAnyBroken ? "fail" : "done";

      if (this.isComplete = !0, this.emitEvent(t, [this]), this.emitEvent("always", [this]), this.jqDeferred) {
        var n = this.hasAnyBroken ? "reject" : "resolve";
        this.jqDeferred[n](this);
      }
    }, u.prototype = Object.create(n.prototype), u.prototype.check = function () {
      this.getIsImageComplete() ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image(), this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.proxyImage.src = this.img.src);
    }, u.prototype.getIsImageComplete = function () {
      return this.img.complete && this.img.naturalWidth;
    }, u.prototype.confirm = function (t, n) {
      this.isLoaded = t, this.emitEvent("progress", [this, this.img, n]);
    }, u.prototype.handleEvent = function (t) {
      var n = "on" + t.type;
      this[n] && this[n](t);
    }, u.prototype.onload = function () {
      this.confirm(!0, "onload"), this.unbindEvents();
    }, u.prototype.onerror = function () {
      this.confirm(!1, "onerror"), this.unbindEvents();
    }, u.prototype.unbindEvents = function () {
      this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
    }, c.prototype = Object.create(u.prototype), c.prototype.check = function () {
      this.img.addEventListener("load", this), this.img.addEventListener("error", this), this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
    }, c.prototype.unbindEvents = function () {
      this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
    }, c.prototype.confirm = function (t, n) {
      this.isLoaded = t, this.emitEvent("progress", [this, this.element, n]);
    }, a.makeJQueryPlugin = function (n) {
      (n = n || t.jQuery) && ((e = n).fn.imagesLoaded = function (t, n) {
        return new a(this, t, n).jqDeferred.promise(e(this));
      });
    }, a.makeJQueryPlugin(), a;
  });
}),
    V = require("lodash/isEqual"),
    _ = require("lodash/isEmpty"),
    F = function (n) {
  var a = this;
  T(this, undefined);
  var s = n.options,
      u = n.callbacks,
      c = n.images,
      l = n.children,
      d = n.defaultOptions,
      f = n.defaultCallbacks,
      h = n.customCaptions,
      p = e(R),
      m = r(null),
      v = r(),
      g = L(i(!1), 2),
      y = g[0],
      b = g[1],
      x = L(i(!1), 2),
      w = x[0],
      E = x[1];
  return o(function () {
    var t = this;

    function n(t) {
      var n = this;
      if (E(!0), !w) return function (t) {
        V(t, p.elements) || p.dispatch({
          type: "GRAB_ELEMENTS",
          elements: t
        });
      }(t.filter(function (t) {
        return T(this, n), void 0 !== t;
      }.bind(this))), function (t, n, e) {
        var r = {},
            i = {};
        r = _(t) ? C(C({}, d), {}, {
          buttons: C({}, d.buttons),
          settings: C({}, d.settings),
          caption: C({}, d.caption),
          thumbnails: C({}, d.thumbnails),
          progressBar: C({}, d.progressBar),
          translations: C({}, d.translations)
        }) : C(C(C({}, d), t), {}, {
          buttons: C(C({}, d.buttons), t.buttons),
          settings: C(C({}, d.settings), t.settings),
          caption: C(C({}, d.caption), t.caption),
          thumbnails: C(C({}, d.thumbnails), t.thumbnails),
          progressBar: C(C({}, d.progressBar), t.progressBar),
          translations: C(C({}, d.translations), t.translations)
        }), i = _(n) ? C({}, f) : C(C({}, f), n);
        var o = {
          options: C({}, r),
          callbacks: C({}, i),
          customCaptions: P(e)
        };
        V(o.options, p.options) && V(o.callbacks, p.callbacks) || p.dispatch({
          type: "GRAB_SETTINGS",
          mergedSettings: o
        });
      }(s, u, h);
    }

    T(this, a), v.current = new MutationObserver(function () {
      i(m.current);
    }), v.current.observe(m.current, {
      childList: !0,
      subtree: !0,
      attributeFilter: ["href", "src"]
    });

    var e = function (n) {
      T(this, t), V(n, p.selectedElement) || p.dispatch({
        type: "HANDLE_ELEMENT",
        element: n
      });
    }.bind(this);

    function r(t) {
      y || function (t) {
        var n = this;
        Array.from(t).map(function (t) {
          var e = this;
          return T(this, n), t.addEventListener("click", function (t) {
            T(this, e), t.preventDefault();
          }.bind(this));
        }.bind(this));
      }(t), I(t, function (t) {
        if (t.isComplete) {
          var r = t.elements[0].nodeName;
          y || (b(!0), function (t, r) {
            var i = this;
            n(t.map(function (t, n) {
              var o = this;

              if (T(this, i), t.isLoaded) {
                var a;
                t.img.setAttribute("srl-slide_id", n);
                var s = /\.(gif|jpg|jpeg|tiff|png|webp)$/i.test(t.img.currentSrc || t.img.src || t.img.href),
                    u = t.img.src.includes("base64"),
                    c = null === (a = t.img.offsetParent) || void 0 === a ? void 0 : a.className.includes("gatsby-image-wrapper"),
                    l = "picture" !== t.img.parentNode.localName;
                if (c && u && l) return;
                var d = {
                  source: "IMG" === r ? t.img.currentSrc || t.img.src || t.img.href || null : t.img.parentElement.href || t.img.offsetParent.parentElement.href || null,
                  thumbnail: "IMG" === r ? t.img.currentSrc || t.img.src || t.img.href || null : t.img.currentSrc || t.img.parentElement.href || null,
                  caption: t.img.alt || t.img.textContent || null,
                  id: t.img.getAttribute("srl-slide_id") || null,
                  width: s ? t.img.naturalWidth || null : t.img.videoWidth || null,
                  height: s ? t.img.naturalHeight || null : t.img.videoHeight || null
                };
                return "A" === r ? t.img.parentElement.addEventListener("click", function (t) {
                  T(this, o), t.preventDefault(), e(d);
                }.bind(this)) : t.img.addEventListener("click", function (t) {
                  T(this, o), t.preventDefault(), e(d);
                }.bind(this)), d;
              }
            }.bind(this)));
          }(t.images, r));
        }
      });
    }

    function i(t) {
      var e = this,
          i = t.querySelectorAll("img"),
          o = Array.from(i).filter(function (t) {
        return T(this, e), "picture" !== t.parentNode.localName && !t.parentNode.offsetParent.className.includes("gatsby-image-wrapper");
      }.bind(this)),
          a = t.querySelectorAll("a[data-attribute='SRL']");
      0 !== o.length ? 0 === a.length ? r(i) : a.length > 0 && (r(a), a.length !== o.length && console.warn("HEY!. You have ".concat(a.length, " links and ").concat(o.length, ' images. You likely forgot to add the ** data-attribute="SRL" ** to one of your link wrapping your image!'))) : c && function (t) {
        var e = this;
        n(t.map(function (t, n) {
          return T(this, e), {
            source: t.src || null,
            thumbnail: t.thumbnail || t.src || null,
            caption: t.caption || null,
            id: "".concat(n),
            width: "auto",
            height: "auto"
          };
        }.bind(this)));
      }(c);
    }

    i(m.current);
  }.bind(this), [w, p, y, f, d, s, u, c, h]), t.createElement("div", {
    ref: m
  }, l);
}.bind(void 0);

F.propTypes = {
  defaultOptions: v.shape({
    settings: v.shape({
      autoplaySpeed: v.number,
      disableKeyboardControls: v.bool,
      disablePanzoom: v.bool,
      disableWheelControls: v.bool,
      hideControlsAfter: v.oneOfType([v.number, v.bool]),
      lightboxTransitionSpeed: v.number,
      lightboxTransitionTimingFunction: v.oneOfType([v.string, v.array]),
      overlayColor: v.string,
      slideAnimationType: v.string,
      slideSpringValues: v.array,
      slideTransitionSpeed: v.number,
      slideTransitionTimingFunction: v.oneOfType([v.string, v.array])
    }),
    buttons: v.shape({
      backgroundColor: v.string,
      iconColor: v.string,
      iconPadding: v.string,
      showAutoplayButton: v.bool,
      showCloseButton: v.bool,
      showDownloadButton: v.bool,
      showFullscreenButton: v.bool,
      showNextButton: v.bool,
      showPrevButton: v.bool,
      showThumbnailsButton: v.bool,
      size: v.string
    }),
    caption: v.shape({
      captionColor: v.string,
      captionAlignment: v.string,
      captionFontFamily: v.string,
      captionFontSize: v.string,
      captionFontStyle: v.string,
      captionFontWeight: v.oneOfType([v.number, v.string]),
      captionContainerPadding: v.string,
      captionTextTransform: v.string,
      showCaption: v.bool
    }),
    thumbnails: v.shape({
      showThumbnails: v.bool,
      thumbnailsAlignment: v.string,
      thumbnailsContainerPadding: v.string,
      thumbnailsContainerBackgroundColor: v.string,
      thumbnailsGap: v.string,
      thumbnailsOpacity: v.number,
      thumbnailsPosition: v.string,
      thumbnailsSize: v.array
    }),
    progressBar: v.shape({
      backgroundColor: v.string,
      fillColor: v.string,
      height: v.string,
      showProgressBar: v.bool
    }),
    translations: v.shape({
      autoplayText: v.string,
      closeText: v.string,
      downloadText: v.string,
      fullscreenText: v.string,
      nextText: v.string,
      pauseText: v.string,
      previousText: v.string,
      thumbnailsText: v.string,
      zoomOutText: v.string
    })
  }),
  defaultCallbacks: v.shape({
    onCountSlides: v.func,
    onLightboxClosed: v.func,
    onLightboxOpened: v.func,
    onSlideChange: v.func
  }),
  children: v.oneOfType([v.arrayOf(v.node), v.node]),
  options: v.object,
  callbacks: v.object,
  images: v.array,
  customCaptions: v.array
}, F.defaultProps = {
  defaultOptions: {
    settings: {
      autoplaySpeed: 3e3,
      disableKeyboardControls: !1,
      disablePanzoom: !1,
      disableWheelControls: !1,
      hideControlsAfter: 3e3,
      lightboxTransitionSpeed: .3,
      lightboxTransitionTimingFunction: "linear",
      overlayColor: "rgba(0, 0, 0, 0.9)",
      slideAnimationType: "fade",
      slideSpringValues: [300, 200],
      slideTransitionSpeed: .6,
      slideTransitionTimingFunction: "linear"
    },
    buttons: {
      backgroundColor: "rgba(30,30,36,0.8)",
      iconColor: "rgba(255, 255, 255, 0.8)",
      iconPadding: "5px",
      showAutoplayButton: !0,
      showCloseButton: !0,
      showDownloadButton: !0,
      showFullscreenButton: !0,
      showNextButton: !0,
      showPrevButton: !0,
      showThumbnailsButton: !0,
      size: "40px"
    },
    caption: {
      captionAlignment: "start",
      captionColor: "#FFFFFF",
      captionContainerPadding: "0",
      captionFontFamily: "inherit",
      captionFontSize: "inherit",
      captionFontStyle: "inherit",
      captionFontWeight: "inherit",
      captionTextTransform: "inherit",
      showCaption: !0
    },
    thumbnails: {
      showThumbnails: !0,
      thumbnailsAlignment: "center",
      thumbnailsContainerBackgroundColor: "transparent",
      thumbnailsContainerPadding: "0",
      thumbnailsGap: "0 1px",
      thumbnailsOpacity: .4,
      thumbnailsPosition: "bottom",
      thumbnailsSize: ["100px", "80px"]
    },
    progressBar: {
      backgroundColor: "#f2f2f2",
      fillColor: "#000000",
      height: "3px",
      showProgressBar: !0
    },
    translations: {
      autoplayText: "Play",
      closeText: "Close",
      downloadText: "Download",
      fullscreenText: "Full screen",
      nextText: "Next",
      pauseText: "Pause",
      previousText: "Previous",
      thumbnailsText: "Hide thumbnails",
      zoomOutText: "Zoom Out"
    }
  },
  defaultCallbacks: {
    onCountSlides: function () {
      T(this, undefined);
    }.bind(void 0),
    onSlideChange: function () {
      T(this, undefined);
    }.bind(void 0),
    onLightboxClosed: function () {
      T(this, undefined);
    }.bind(void 0),
    onLightboxOpened: function () {
      T(this, undefined);
    }.bind(void 0)
  },
  customCaptions: [{}]
};

var j = function j(t, n, e) {
  return n in t ? Object.defineProperty(t, n, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = e, t;
};

function H(t) {
  var n = {};
  return function (e) {
    return void 0 === n[e] && (n[e] = t(e)), n[e];
  };
}

var U = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
    W = H(function (t) {
  return U.test(t) || 111 === t.charCodeAt(0) && 110 === t.charCodeAt(1) && t.charCodeAt(2) < 91;
});

var q = function q(t, n) {
  t.prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n;
};

var Y = function () {
  function t(t) {
    this.isSpeedy = void 0 === t.speedy ? "production" === process.env.NODE_ENV : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.before = null;
  }

  var n = t.prototype;
  return n.insert = function (t) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) == 0) {
      var n,
          e = function (t) {
        var n = document.createElement("style");
        return n.setAttribute("data-emotion", t.key), void 0 !== t.nonce && n.setAttribute("nonce", t.nonce), n.appendChild(document.createTextNode("")), n;
      }(this);

      n = 0 === this.tags.length ? this.before : this.tags[this.tags.length - 1].nextSibling, this.container.insertBefore(e, n), this.tags.push(e);
    }

    var r = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var i = function (t) {
        if (t.sheet) return t.sheet;

        for (var n = 0; n < document.styleSheets.length; n++) {
          if (document.styleSheets[n].ownerNode === t) return document.styleSheets[n];
        }
      }(r);

      try {
        var o = 105 === t.charCodeAt(1) && 64 === t.charCodeAt(0);
        i.insertRule(t, o ? 0 : i.cssRules.length);
      } catch (n) {
        "production" !== process.env.NODE_ENV && console.warn('There was a problem inserting the following rule: "' + t + '"', n);
      }
    } else r.appendChild(document.createTextNode(t));

    this.ctr++;
  }, n.flush = function () {
    this.tags.forEach(function (t) {
      return t.parentNode.removeChild(t);
    }), this.tags = [], this.ctr = 0;
  }, t;
}();

function X(t) {
  function n(t, n, r) {
    var i = n.trim().split(p);
    n = i;
    var o = i.length,
        a = t.length;

    switch (a) {
      case 0:
      case 1:
        var s = 0;

        for (t = 0 === a ? "" : t[0] + " "; s < o; ++s) {
          n[s] = e(t, n[s], r).trim();
        }

        break;

      default:
        var u = s = 0;

        for (n = []; s < o; ++s) {
          for (var c = 0; c < a; ++c) {
            n[u++] = e(t[c] + " ", i[s], r).trim();
          }
        }

    }

    return n;
  }

  function e(t, n, e) {
    var r = n.charCodeAt(0);

    switch (33 > r && (r = (n = n.trim()).charCodeAt(0)), r) {
      case 38:
        return n.replace(m, "$1" + t.trim());

      case 58:
        return t.trim() + n.replace(m, "$1" + t.trim());

      default:
        if (0 < 1 * e && 0 < n.indexOf("\f")) return n.replace(m, (58 === t.charCodeAt(0) ? "" : "$1") + t.trim());
    }

    return t + n;
  }

  function r(t, n, e, o) {
    var a = t + ";",
        s = 2 * n + 3 * e + 4 * o;

    if (944 === s) {
      t = a.indexOf(":", 9) + 1;
      var u = a.substring(t, a.length - 1).trim();
      return u = a.substring(0, t).trim() + u + ";", 1 === A || 2 === A && i(u, 1) ? "-webkit-" + u + u : u;
    }

    if (0 === A || 2 === A && !i(a, 1)) return a;

    switch (s) {
      case 1015:
        return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return "-webkit-" + a + a;

      case 978:
        return "-webkit-" + a + "-moz-" + a + a;

      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11)) return a.replace(T, "$1-webkit-$2") + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;

          case 115:
            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;

          case 98:
            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
        }
        return "-webkit-" + a + "-ms-" + a + a;

      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        return "-webkit-box-pack" + (u = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + a + "-ms-flex-pack" + u + a;

      case 1005:
        return f.test(a) ? a.replace(d, ":-webkit-") + a.replace(d, ":-moz-") + a : a;

      case 1e3:
        switch (n = (u = a.substring(13).trim()).indexOf("-") + 1, u.charCodeAt(0) + u.charCodeAt(n)) {
          case 226:
            u = a.replace(b, "tb");
            break;

          case 232:
            u = a.replace(b, "tb-rl");
            break;

          case 220:
            u = a.replace(b, "lr");
            break;

          default:
            return a;
        }

        return "-webkit-" + a + "-ms-" + u + a;

      case 1017:
        if (-1 === a.indexOf("sticky", 9)) break;

      case 975:
        switch (n = (a = t).length - 10, s = (u = (33 === a.charCodeAt(n) ? a.substring(0, n) : a).substring(t.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | u.charCodeAt(7))) {
          case 203:
            if (111 > u.charCodeAt(8)) break;

          case 115:
            a = a.replace(u, "-webkit-" + u) + ";" + a;
            break;

          case 207:
          case 102:
            a = a.replace(u, "-webkit-" + (102 < s ? "inline-" : "") + "box") + ";" + a.replace(u, "-webkit-" + u) + ";" + a.replace(u, "-ms-" + u + "box") + ";" + a;
        }

        return a + ";";

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return u = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + u + "-ms-flex-" + u + a;

          case 115:
            return "-webkit-" + a + "-ms-flex-item-" + a.replace(E, "") + a;

          default:
            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(E, "") + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === C.test(t)) return 115 === (u = t.substring(t.indexOf(":") + 1)).charCodeAt(0) ? r(t.replace("stretch", "fill-available"), n, e, o).replace(":fill-available", ":stretch") : a.replace(u, "-webkit-" + u) + a.replace(u, "-moz-" + u.replace("fill-", "")) + a;
        break;

      case 962:
        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + o && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(h, "$1-webkit-$2") + a;
    }

    return a;
  }

  function i(t, n) {
    var e = t.indexOf(1 === n ? ":" : "{"),
        r = t.substring(0, 3 !== n ? e : 10);
    return e = t.substring(e + 1, t.length - 1), D(2 !== n ? r : r.replace(S, "$1"), e, n);
  }

  function o(t, n) {
    var e = r(n, n.charCodeAt(0), n.charCodeAt(1), n.charCodeAt(2));
    return e !== n + ";" ? e.replace(w, " or ($1)").substring(4) : "(" + n + ")";
  }

  function a(t, n, e, r, i, o, a, s, c, l) {
    for (var d, f = 0, h = n; f < R; ++f) {
      switch (d = B[f].call(u, t, h, e, r, i, o, a, s, c, l)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          h = d;
      }
    }

    if (h !== n) return h;
  }

  function s(t) {
    return void 0 !== (t = t.prefix) && (D = null, t ? "function" != typeof t ? A = 1 : (A = 2, D = t) : A = 0), s;
  }

  function u(t, e) {
    var s = t;

    if (33 > s.charCodeAt(0) && (s = s.trim()), s = [s], 0 < R) {
      var u = a(-1, e, s, s, L, k, 0, 0, 0, 0);
      void 0 !== u && "string" == typeof u && (e = u);
    }

    var d = function t(e, s, u, d, f) {
      for (var h, p, m, b, w, E = 0, S = 0, C = 0, T = 0, B = 0, D = 0, z = m = h = 0, M = 0, I = 0, V = 0, _ = 0, F = u.length, j = F - 1, H = "", U = "", W = "", q = ""; M < F;) {
        if (p = u.charCodeAt(M), M === j && 0 !== S + T + C + E && (0 !== S && (p = 47 === S ? 10 : 47), T = C = E = 0, F++, j++), 0 === S + T + C + E) {
          if (M === j && (0 < I && (H = H.replace(l, "")), 0 < H.trim().length)) {
            switch (p) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;

              default:
                H += u.charAt(M);
            }

            p = 59;
          }

          switch (p) {
            case 123:
              for (h = (H = H.trim()).charCodeAt(0), m = 1, _ = ++M; M < F;) {
                switch (p = u.charCodeAt(M)) {
                  case 123:
                    m++;
                    break;

                  case 125:
                    m--;
                    break;

                  case 47:
                    switch (p = u.charCodeAt(M + 1)) {
                      case 42:
                      case 47:
                        t: {
                          for (z = M + 1; z < j; ++z) {
                            switch (u.charCodeAt(z)) {
                              case 47:
                                if (42 === p && 42 === u.charCodeAt(z - 1) && M + 2 !== z) {
                                  M = z + 1;
                                  break t;
                                }

                                break;

                              case 10:
                                if (47 === p) {
                                  M = z + 1;
                                  break t;
                                }

                            }
                          }

                          M = z;
                        }

                    }

                    break;

                  case 91:
                    p++;

                  case 40:
                    p++;

                  case 34:
                  case 39:
                    for (; M++ < j && u.charCodeAt(M) !== p;) {
                      ;
                    }

                }

                if (0 === m) break;
                M++;
              }

              switch (m = u.substring(_, M), 0 === h && (h = (H = H.replace(c, "").trim()).charCodeAt(0)), h) {
                case 64:
                  switch (0 < I && (H = H.replace(l, "")), p = H.charCodeAt(1)) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      I = s;
                      break;

                    default:
                      I = O;
                  }

                  if (_ = (m = t(s, I, m, p, f + 1)).length, 0 < R && (w = a(3, m, I = n(O, H, V), s, L, k, _, p, f, d), H = I.join(""), void 0 !== w && 0 === (_ = (m = w.trim()).length) && (p = 0, m = "")), 0 < _) switch (p) {
                    case 115:
                      H = H.replace(x, o);

                    case 100:
                    case 109:
                    case 45:
                      m = H + "{" + m + "}";
                      break;

                    case 107:
                      m = (H = H.replace(v, "$1 $2")) + "{" + m + "}", m = 1 === A || 2 === A && i("@" + m, 3) ? "@-webkit-" + m + "@" + m : "@" + m;
                      break;

                    default:
                      m = H + m, 112 === d && (U += m, m = "");
                  } else m = "";
                  break;

                default:
                  m = t(s, n(s, H, V), m, d, f + 1);
              }

              W += m, m = V = I = z = h = 0, H = "", p = u.charCodeAt(++M);
              break;

            case 125:
            case 59:
              if (1 < (_ = (H = (0 < I ? H.replace(l, "") : H).trim()).length)) switch (0 === z && (h = H.charCodeAt(0), 45 === h || 96 < h && 123 > h) && (_ = (H = H.replace(" ", ":")).length), 0 < R && void 0 !== (w = a(1, H, s, e, L, k, U.length, d, f, d)) && 0 === (_ = (H = w.trim()).length) && (H = "\0\0"), h = H.charCodeAt(0), p = H.charCodeAt(1), h) {
                case 0:
                  break;

                case 64:
                  if (105 === p || 99 === p) {
                    q += H + u.charAt(M);
                    break;
                  }

                default:
                  58 !== H.charCodeAt(_ - 1) && (U += r(H, h, p, H.charCodeAt(2)));
              }
              V = I = z = h = 0, H = "", p = u.charCodeAt(++M);
          }
        }

        switch (p) {
          case 13:
          case 10:
            47 === S ? S = 0 : 0 === 1 + h && 107 !== d && 0 < H.length && (I = 1, H += "\0"), 0 < R * N && a(0, H, s, e, L, k, U.length, d, f, d), k = 1, L++;
            break;

          case 59:
          case 125:
            if (0 === S + T + C + E) {
              k++;
              break;
            }

          default:
            switch (k++, b = u.charAt(M), p) {
              case 9:
              case 32:
                if (0 === T + E + S) switch (B) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    b = "";
                    break;

                  default:
                    32 !== p && (b = " ");
                }
                break;

              case 0:
                b = "\\0";
                break;

              case 12:
                b = "\\f";
                break;

              case 11:
                b = "\\v";
                break;

              case 38:
                0 === T + S + E && (I = V = 1, b = "\f" + b);
                break;

              case 108:
                if (0 === T + S + E + P && 0 < z) switch (M - z) {
                  case 2:
                    112 === B && 58 === u.charCodeAt(M - 3) && (P = B);

                  case 8:
                    111 === D && (P = D);
                }
                break;

              case 58:
                0 === T + S + E && (z = M);
                break;

              case 44:
                0 === S + C + T + E && (I = 1, b += "\r");
                break;

              case 34:
              case 39:
                0 === S && (T = T === p ? 0 : 0 === T ? p : T);
                break;

              case 91:
                0 === T + S + C && E++;
                break;

              case 93:
                0 === T + S + C && E--;
                break;

              case 41:
                0 === T + S + E && C--;
                break;

              case 40:
                if (0 === T + S + E) {
                  if (0 === h) switch (2 * B + 3 * D) {
                    case 533:
                      break;

                    default:
                      h = 1;
                  }
                  C++;
                }

                break;

              case 64:
                0 === S + C + T + E + z + m && (m = 1);
                break;

              case 42:
              case 47:
                if (!(0 < T + E + C)) switch (S) {
                  case 0:
                    switch (2 * p + 3 * u.charCodeAt(M + 1)) {
                      case 235:
                        S = 47;
                        break;

                      case 220:
                        _ = M, S = 42;
                    }

                    break;

                  case 42:
                    47 === p && 42 === B && _ + 2 !== M && (33 === u.charCodeAt(_ + 2) && (U += u.substring(_, M + 1)), b = "", S = 0);
                }
            }

            0 === S && (H += b);
        }

        D = B, B = p, M++;
      }

      if (0 < (_ = U.length)) {
        if (I = s, 0 < R && void 0 !== (w = a(2, U, I, e, L, k, _, d, f, d)) && 0 === (U = w).length) return q + U + W;

        if (U = I.join(",") + "{" + U + "}", 0 != A * P) {
          switch (2 !== A || i(U, 2) || (P = 0), P) {
            case 111:
              U = U.replace(y, ":-moz-$1") + U;
              break;

            case 112:
              U = U.replace(g, "::-webkit-input-$1") + U.replace(g, "::-moz-$1") + U.replace(g, ":-ms-input-$1") + U;
          }

          P = 0;
        }
      }

      return q + U + W;
    }(O, s, e, 0, 0);

    return 0 < R && void 0 !== (u = a(-2, d, s, s, L, k, d.length, 0, 0, 0)) && (d = u), "", P = 0, k = L = 1, d;
  }

  var c = /^\0+/g,
      l = /[\0\r\f]/g,
      d = /: */g,
      f = /zoo|gra/,
      h = /([,: ])(transform)/g,
      p = /,\r+?/g,
      m = /([\t\r\n ])*\f?&/g,
      v = /@(k\w+)\s*(\S*)\s*/,
      g = /::(place)/g,
      y = /:(read-only)/g,
      b = /[svh]\w+-[tblr]{2}/,
      x = /\(\s*(.*)\s*\)/g,
      w = /([\s\S]*?);/g,
      E = /-self|flex-/g,
      S = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      C = /stretch|:\s*\w+\-(?:conte|avail)/,
      T = /([^-])(image-set\()/,
      k = 1,
      L = 1,
      P = 0,
      A = 1,
      O = [],
      B = [],
      R = 0,
      D = null,
      N = 0;
  return u.use = function t(n) {
    switch (n) {
      case void 0:
      case null:
        R = B.length = 0;
        break;

      default:
        if ("function" == typeof n) B[R++] = n;else if ("object" == typeof n) for (var e = 0, r = n.length; e < r; ++e) {
          t(n[e]);
        } else N = 0 | !!n;
    }

    return t;
  }, u.set = s, void 0 !== t && s(t), u;
}

var G = function G(t) {
  var n = new WeakMap();
  return function (e) {
    if (n.has(e)) return n.get(e);
    var r = t(e);
    return n.set(e, r), r;
  };
};

function Z(t) {
  t && $.current.insert(t + "}");
}

var $ = {
  current: null
},
    K = function K(t, n, e, r, i, o, a, s, u, c) {
  switch (t) {
    case 1:
      switch (n.charCodeAt(0)) {
        case 64:
          return $.current.insert(n + ";"), "";

        case 108:
          if (98 === n.charCodeAt(2)) return "";
      }

      break;

    case 2:
      if (0 === s) return n + "/*|*/";
      break;

    case 3:
      switch (s) {
        case 102:
        case 112:
          return $.current.insert(e[0] + n), "";

        default:
          return n + (0 === c ? "/*|*/" : "");
      }

    case -2:
      n.split("/*|*/}").forEach(Z);
  }
},
    J = function J(t, n) {
  if (1 === t && 108 === n.charCodeAt(0) && 98 === n.charCodeAt(2)) return "";
},
    Q = "undefined" != typeof document,
    tt = {},
    nt = Q ? void 0 : G(function () {
  var t = G(function () {
    return {};
  }),
      n = {},
      e = {};
  return function (r) {
    return void 0 === r || !0 === r ? n : !1 === r ? e : t(r);
  };
}),
    et = function et(t) {
  void 0 === t && (t = {});
  var n,
      e = t.key || "css";
  void 0 !== t.prefix && (n = {
    prefix: t.prefix
  });
  var r = new X(n);
  if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(e)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + e + '" was passed');
  var i,
      o,
      a = {};

  if (Q) {
    i = t.container || document.head;
    var s = document.querySelectorAll("style[data-emotion-" + e + "]");
    Array.prototype.forEach.call(s, function (t) {
      t.getAttribute("data-emotion-" + e).split(" ").forEach(function (t) {
        a[t] = !0;
      }), t.parentNode !== i && i.appendChild(t);
    });
  }

  if (Q) r.use(t.stylisPlugins)(K), o = function o(t, n, e, i) {
    var o = n.name;

    if ($.current = e, "production" !== process.env.NODE_ENV && void 0 !== n.map) {
      var a = n.map;
      $.current = {
        insert: function insert(t) {
          e.insert(t + a);
        }
      };
    }

    r(t, n.styles), i && (d.inserted[o] = !0);
  };else {
    r.use(J);
    var u = tt;
    (t.stylisPlugins || void 0 !== t.prefix) && (r.use(t.stylisPlugins), u = nt(t.stylisPlugins || tt)(t.prefix));

    o = function o(t, n, e, i) {
      var o = n.name,
          a = function (t, n) {
        var e = n.name;
        return void 0 === u[e] && (u[e] = r(t, n.styles)), u[e];
      }(t, n);

      return void 0 === d.compat ? (i && (d.inserted[o] = !0), "development" === process.env.NODE_ENV && void 0 !== n.map ? a + n.map : a) : i ? void (d.inserted[o] = a) : a;
    };
  }

  if ("production" !== process.env.NODE_ENV) {
    var c = /\/\*/g,
        l = /\*\//g;
    r.use(function (t, n) {
      switch (t) {
        case -1:
          for (; c.test(n);) {
            if (l.lastIndex = c.lastIndex, !l.test(n)) throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            c.lastIndex = l.lastIndex;
          }

          c.lastIndex = 0;
      }
    }), r.use(function (t, n, e) {
      switch (t) {
        case -1:
          var r = n.match(/(:first|:nth|:nth-last)-child/g);
          r && !0 !== d.compat && r.forEach(function (t) {
            var e = new RegExp(t + ".*\\/\\* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason \\*\\/").test(n);
            t && !e && console.error('The pseudo class "' + t + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + t.split("-child")[0] + '-of-type".');
          });
      }
    });
  }

  var d = {
    key: e,
    sheet: new Y({
      key: e,
      container: i,
      nonce: t.nonce,
      speedy: t.speedy
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: o
  };
  return d;
},
    rt = "undefined" != typeof document;

function it(t, n, e) {
  var r = "";
  return e.split(" ").forEach(function (e) {
    void 0 !== t[e] ? n.push(t[e]) : r += e + " ";
  }), r;
}

var ot = function ot(t, n, e) {
  var r = t.key + "-" + n.name;

  if ((!1 === e || !1 === rt && void 0 !== t.compat) && void 0 === t.registered[r] && (t.registered[r] = n.styles), void 0 === t.inserted[n.name]) {
    var i = "",
        o = n;

    do {
      var a = t.insert("." + r, o, t.sheet, !0);
      rt || void 0 === a || (i += a), o = o.next;
    } while (void 0 !== o);

    if (!rt && 0 !== i.length) return i;
  }
};

var at = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
},
    st = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    ut = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).",
    ct = /[A-Z]|^ms/g,
    lt = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
    dt = function dt(t) {
  return 45 === t.charCodeAt(1);
},
    ft = function ft(t) {
  return null != t && "boolean" != typeof t;
},
    ht = H(function (t) {
  return dt(t) ? t : t.replace(ct, "-$&").toLowerCase();
}),
    pt = function pt(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if ("string" == typeof n) return n.replace(lt, function (t, n, e) {
        return Ct = {
          name: n,
          styles: e,
          next: Ct
        }, n;
      });
  }

  return 1 === at[t] || dt(t) || "number" != typeof n || 0 === n ? n : n + "px";
};

if ("production" !== process.env.NODE_ENV) {
  var mt = /(attr|calc|counters?|url)\(/,
      vt = ["normal", "none", "counter", "open-quote", "close-quote", "no-open-quote", "no-close-quote", "initial", "inherit", "unset"],
      gt = pt,
      yt = /^-ms-/,
      bt = /-(.)/g,
      xt = {};

  pt = function pt(t, n) {
    "content" === t && ("string" != typeof n || -1 === vt.indexOf(n) && !mt.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || '"' !== n.charAt(0) && "'" !== n.charAt(0))) && console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var e = gt(t, n);
    return "" === e || dt(t) || -1 === t.indexOf("-") || void 0 !== xt[t] || (xt[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(yt, "ms-").replace(bt, function (t, n) {
      return n.toUpperCase();
    }) + "?")), e;
  };
}

var wt = !0;

function Et(t, n, e, r) {
  if (null == e) return "";

  if (void 0 !== e.__emotion_styles) {
    if ("production" !== process.env.NODE_ENV && "NO_COMPONENT_SELECTOR" === e.toString()) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
    return e;
  }

  switch (typeof e) {
    case "boolean":
      return "";

    case "object":
      if (1 === e.anim) return Ct = {
        name: e.name,
        styles: e.styles,
        next: Ct
      }, e.name;

      if (void 0 !== e.styles) {
        var i = e.next;
        if (void 0 !== i) for (; void 0 !== i;) {
          Ct = {
            name: i.name,
            styles: i.styles,
            next: Ct
          }, i = i.next;
        }
        var o = e.styles + ";";
        return "production" !== process.env.NODE_ENV && void 0 !== e.map && (o += e.map), o;
      }

      return function (t, n, e) {
        var r = "";
        if (Array.isArray(e)) for (var i = 0; i < e.length; i++) {
          r += Et(t, n, e[i], !1);
        } else for (var o in e) {
          var a = e[o];
          if ("object" != typeof a) null != n && void 0 !== n[a] ? r += o + "{" + n[a] + "}" : ft(a) && (r += ht(o) + ":" + pt(o, a) + ";");else {
            if ("NO_COMPONENT_SELECTOR" === o && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");

            if (!Array.isArray(a) || "string" != typeof a[0] || null != n && void 0 !== n[a[0]]) {
              var s = Et(t, n, a, !1);

              switch (o) {
                case "animation":
                case "animationName":
                  r += ht(o) + ":" + s + ";";
                  break;

                default:
                  "production" !== process.env.NODE_ENV && "undefined" === o && console.error(ut), r += o + "{" + s + "}";
              }
            } else for (var u = 0; u < a.length; u++) {
              ft(a[u]) && (r += ht(o) + ":" + pt(o, a[u]) + ";");
            }
          }
        }
        return r;
      }(t, n, e);

    case "function":
      if (void 0 !== t) {
        var a = Ct,
            s = e(t);
        return Ct = a, Et(t, n, s, r);
      }

      "production" !== process.env.NODE_ENV && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;

    case "string":
      if ("production" !== process.env.NODE_ENV) {
        var u = [],
            c = e.replace(lt, function (t, n, e) {
          var r = "animation" + u.length;
          return u.push("const " + r + " = keyframes`" + e.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + r + "}";
        });
        u.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(u, ["`" + c + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\ncss`" + c + "`");
      }

  }

  if (null == n) return e;
  var l = n[e];
  return "production" !== process.env.NODE_ENV && r && wt && void 0 !== l && (console.error("Interpolating a className from css`` is not recommended and will cause problems with composition.\nInterpolating a className from css`` will be completely unsupported in a future major version of Emotion"), wt = !1), void 0 === l || r ? e : l;
}

var St,
    Ct,
    Tt = /label:\s*([^\s;\n{]+)\s*;/g;
"production" !== process.env.NODE_ENV && (St = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//);

var kt = function kt(t, n, e) {
  if (1 === t.length && "object" == typeof t[0] && null !== t[0] && void 0 !== t[0].styles) return t[0];
  var r = !0,
      i = "";
  Ct = void 0;
  var o,
      a = t[0];
  null == a || void 0 === a.raw ? (r = !1, i += Et(e, n, a, !1)) : ("production" !== process.env.NODE_ENV && void 0 === a[0] && console.error(st), i += a[0]);

  for (var s = 1; s < t.length; s++) {
    i += Et(e, n, t[s], 46 === i.charCodeAt(i.length - 1)), r && ("production" !== process.env.NODE_ENV && void 0 === a[s] && console.error(st), i += a[s]);
  }

  "production" !== process.env.NODE_ENV && (i = i.replace(St, function (t) {
    return o = t, "";
  })), Tt.lastIndex = 0;

  for (var u, c = ""; null !== (u = Tt.exec(i));) {
    c += "-" + u[1];
  }

  var l = function (t) {
    for (var n, e = 0, r = 0, i = t.length; i >= 4; ++r, i -= 4) {
      n = 1540483477 * (65535 & (n = 255 & t.charCodeAt(r) | (255 & t.charCodeAt(++r)) << 8 | (255 & t.charCodeAt(++r)) << 16 | (255 & t.charCodeAt(++r)) << 24)) + (59797 * (n >>> 16) << 16), e = 1540483477 * (65535 & (n ^= n >>> 24)) + (59797 * (n >>> 16) << 16) ^ 1540483477 * (65535 & e) + (59797 * (e >>> 16) << 16);
    }

    switch (i) {
      case 3:
        e ^= (255 & t.charCodeAt(r + 2)) << 16;

      case 2:
        e ^= (255 & t.charCodeAt(r + 1)) << 8;

      case 1:
        e = 1540483477 * (65535 & (e ^= 255 & t.charCodeAt(r))) + (59797 * (e >>> 16) << 16);
    }

    return (((e = 1540483477 * (65535 & (e ^= e >>> 13)) + (59797 * (e >>> 16) << 16)) ^ e >>> 15) >>> 0).toString(36);
  }(i) + c;

  return "production" !== process.env.NODE_ENV ? {
    name: l,
    styles: i,
    map: o,
    next: Ct,
    toString: function toString() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: l,
    styles: i,
    next: Ct
  };
};

function Lt() {
  for (var t = arguments.length, n = new Array(t), e = 0; e < t; e++) {
    n[e] = arguments[e];
  }

  return kt(n);
}

var Pt = "undefined" != typeof document,
    At = a("undefined" != typeof HTMLElement ? et() : null),
    Ot = a({}),
    Bt = (At.Provider, function (t) {
  return c(function (n, e) {
    return s(At.Consumer, null, function (r) {
      return t(n, r, e);
    });
  });
});

if (!Pt) {
  var Rt = function (t) {
    function n(n, e, r) {
      var i;
      return (i = t.call(this, n, e, r) || this).state = {
        value: et()
      }, i;
    }

    return q(n, t), n.prototype.render = function () {
      return s(At.Provider, this.state, this.props.children(this.state.value));
    }, n;
  }(l);

  Bt = function Bt(t) {
    return function (n) {
      return s(At.Consumer, null, function (e) {
        return null === e ? s(Rt, null, function (e) {
          return t(n, e);
        }) : t(n, e);
      });
    };
  };
}

var Dt = Object.prototype.hasOwnProperty,
    Nt = function Nt(t, n, e, r) {
  var i = null === e ? n.css : n.css(e);
  "string" == typeof i && void 0 !== t.registered[i] && (i = t.registered[i]);
  var o = n.__EMOTION_TYPE_PLEASE_DO_NOT_USE__,
      a = [i],
      c = "";
  "string" == typeof n.className ? c = it(t.registered, a, n.className) : null != n.className && (c = n.className + " ");
  var l = kt(a);

  if ("production" !== process.env.NODE_ENV && -1 === l.name.indexOf("-")) {
    var d = n.__EMOTION_LABEL_PLEASE_DO_NOT_USE__;
    d && (l = kt([l, "label:" + d + ";"]));
  }

  var f = ot(t, l, "string" == typeof o);
  c += t.key + "-" + l.name;
  var h = {};

  for (var p in n) {
    !Dt.call(n, p) || "css" === p || "__EMOTION_TYPE_PLEASE_DO_NOT_USE__" === p || "production" !== process.env.NODE_ENV && "__EMOTION_LABEL_PLEASE_DO_NOT_USE__" === p || (h[p] = n[p]);
  }

  h.ref = r, h.className = c;
  var m = s(o, h);

  if (!Pt && void 0 !== f) {
    for (var v, g = l.name, y = l.next; void 0 !== y;) {
      g += " " + y.name, y = y.next;
    }

    return s(u, null, s("style", ((v = {})["data-emotion-" + t.key] = g, v.dangerouslySetInnerHTML = {
      __html: f
    }, v.nonce = t.sheet.nonce, v)), m);
  }

  return m;
},
    zt = Bt(function (t, n, e) {
  return "function" == typeof t.css ? s(Ot.Consumer, null, function (r) {
    return Nt(n, t, r, e);
  }) : Nt(n, t, null, e);
});

"production" !== process.env.NODE_ENV && (zt.displayName = "EmotionCssPropInternal");

var Mt = function t(n) {
  for (var e = n.length, r = 0, i = ""; r < e; r++) {
    var o = n[r];

    if (null != o) {
      var a = void 0;

      switch (typeof o) {
        case "boolean":
          break;

        case "object":
          if (Array.isArray(o)) a = t(o);else for (var s in a = "", o) {
            o[s] && s && (a && (a += " "), a += s);
          }
          break;

        default:
          a = o;
      }

      a && (i && (i += " "), i += a);
    }
  }

  return i;
};

function It(t, n, e) {
  var r = [],
      i = it(t, r, e);
  return r.length < 2 ? e : i + n(r);
}

Bt(function (t, n) {
  return s(Ot.Consumer, null, function (e) {
    var r,
        i = "",
        o = "",
        a = !1,
        c = function c() {
      if (a && "production" !== process.env.NODE_ENV) throw new Error("css can only be used during render");

      for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) {
        e[r] = arguments[r];
      }

      var s = kt(e, n.registered);
      if (Pt) ot(n, s, !1);else {
        var u = ot(n, s, !1);
        void 0 !== u && (i += u);
      }
      return Pt || (o += " " + s.name), n.key + "-" + s.name;
    },
        l = {
      css: c,
      cx: function cx() {
        if (a && "production" !== process.env.NODE_ENV) throw new Error("cx can only be used during render");

        for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) {
          e[r] = arguments[r];
        }

        return It(n.registered, c, Mt(e));
      },
      theme: e
    },
        d = t.children(l);

    return a = !0, Pt || 0 === i.length ? d : s(u, null, s("style", ((r = {})["data-emotion-" + n.key] = o.substring(1), r.dangerouslySetInnerHTML = {
      __html: i
    }, r.nonce = n.sheet.nonce, r)), d);
  });
});

var Vt = W,
    _t = function _t(t) {
  return "theme" !== t && "innerRef" !== t;
},
    Ft = function Ft(t) {
  return "string" == typeof t && t.charCodeAt(0) > 96 ? Vt : _t;
};

function jt(t, n) {
  var e = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    n && (r = r.filter(function (n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), e.push.apply(e, r);
  }

  return e;
}

function Ht(t) {
  for (var n = 1; n < arguments.length; n++) {
    var e = null != arguments[n] ? arguments[n] : {};
    n % 2 ? jt(e, !0).forEach(function (n) {
      j(t, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : jt(e).forEach(function (n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }

  return t;
}

var Ut = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    Wt = "undefined" != typeof document,
    qt = function t(n, e) {
  if ("production" !== process.env.NODE_ENV && void 0 === n) throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
  var r, i, o;
  void 0 !== e && (r = e.label, o = e.target, i = n.__emotion_forwardProp && e.shouldForwardProp ? function (t) {
    return n.__emotion_forwardProp(t) && e.shouldForwardProp(t);
  } : e.shouldForwardProp);
  var a = n.__emotion_real === n,
      c = a && n.__emotion_base || n;
  "function" != typeof i && a && (i = n.__emotion_forwardProp);
  var l = i || Ft(c),
      d = !l("as");
  return function () {
    var f = arguments,
        h = a && void 0 !== n.__emotion_styles ? n.__emotion_styles.slice(0) : [];
    if (void 0 !== r && h.push("label:" + r + ";"), null == f[0] || void 0 === f[0].raw) h.push.apply(h, f);else {
      "production" !== process.env.NODE_ENV && void 0 === f[0][0] && console.error(Ut), h.push(f[0][0]);

      for (var p = f.length, m = 1; m < p; m++) {
        "production" !== process.env.NODE_ENV && void 0 === f[0][m] && console.error(Ut), h.push(f[m], f[0][m]);
      }
    }
    var v = Bt(function (t, n, e) {
      return s(Ot.Consumer, null, function (a) {
        var f = d && t.as || c,
            p = "",
            m = [],
            v = t;

        if (null == t.theme) {
          for (var g in v = {}, t) {
            v[g] = t[g];
          }

          v.theme = a;
        }

        "string" == typeof t.className ? p = it(n.registered, m, t.className) : null != t.className && (p = t.className + " ");
        var y = kt(h.concat(m), n.registered, v),
            b = ot(n, y, "string" == typeof f);
        p += n.key + "-" + y.name, void 0 !== o && (p += " " + o);
        var x = d && void 0 === i ? Ft(f) : l,
            w = {};

        for (var E in t) {
          d && "as" === E || x(E) && (w[E] = t[E]);
        }

        w.className = p, w.ref = e || t.innerRef, "production" !== process.env.NODE_ENV && t.innerRef && console.error("`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead" + (void 0 === r ? "" : " in the usage of `" + r + "`"));
        var S = s(f, w);

        if (!Wt && void 0 !== b) {
          for (var C, T = y.name, k = y.next; void 0 !== k;) {
            T += " " + k.name, k = k.next;
          }

          return s(u, null, s("style", ((C = {})["data-emotion-" + n.key] = T, C.dangerouslySetInnerHTML = {
            __html: b
          }, C.nonce = n.sheet.nonce, C)), S);
        }

        return S;
      });
    });
    return v.displayName = void 0 !== r ? r : "Styled(" + ("string" == typeof c ? c : c.displayName || c.name || "Component") + ")", v.defaultProps = n.defaultProps, v.__emotion_real = v, v.__emotion_base = c, v.__emotion_styles = h, v.__emotion_forwardProp = i, Object.defineProperty(v, "toString", {
      value: function value() {
        return void 0 === o && "production" !== process.env.NODE_ENV ? "NO_COMPONENT_SELECTOR" : "." + o;
      }
    }), v.withComponent = function (n, r) {
      return t(n, void 0 !== r ? Ht({}, e || {}, {}, r) : e).apply(void 0, h);
    }, v;
  };
}.bind();

["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"].forEach(function (t) {
  qt[t] = qt(t);
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _Yt = function Yt(t, n) {
  return (_Yt = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (t, n) {
    t.__proto__ = n;
  } || function (t, n) {
    for (var e in n) {
      n.hasOwnProperty(e) && (t[e] = n[e]);
    }
  })(t, n);
};

function Xt(t, n) {
  function e() {
    this.constructor = t;
  }

  _Yt(t, n), t.prototype = null === n ? Object.create(n) : (e.prototype = n.prototype, new e());
}

var _Gt = function Gt() {
  return (_Gt = Object.assign || function (t) {
    for (var n, e = 1, r = arguments.length; e < r; e++) {
      for (var i in n = arguments[e]) {
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
      }
    }

    return t;
  }).apply(this, arguments);
};

function Zt(t, n) {
  var e = {};

  for (var r in t) {
    Object.prototype.hasOwnProperty.call(t, r) && n.indexOf(r) < 0 && (e[r] = t[r]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var i = 0;

    for (r = Object.getOwnPropertySymbols(t); i < r.length; i++) {
      n.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (e[r[i]] = t[r[i]]);
    }
  }

  return e;
}

function $t() {
  for (var t = 0, n = 0, e = arguments.length; n < e; n++) {
    t += arguments[n].length;
  }

  var r = Array(t),
      i = 0;

  for (n = 0; n < e; n++) {
    for (var o = arguments[n], a = 0, s = o.length; a < s; a++, i++) {
      r[i] = o[a];
    }
  }

  return r;
}

var Kt = function Kt() {},
    Jt = function Jt() {};

"production" !== process.env.NODE_ENV && (Kt = function Kt(t, n) {
  t || "undefined" == typeof console || console.warn(n);
}, Jt = function Jt(t, n) {
  if (!t) throw new Error(n);
});
var Qt,
    tn = 0,
    nn = "undefined" != typeof window && void 0 !== window.requestAnimationFrame ? function (t) {
  return window.requestAnimationFrame(t);
} : function (t) {
  var n = Date.now(),
      e = Math.max(0, 16.7 - (n - tn));
  tn = n + e, setTimeout(function () {
    return t(tn);
  }, e);
};
!function (t) {
  t.Read = "read", t.Update = "update", t.Render = "render", t.PostRender = "postRender", t.FixedUpdate = "fixedUpdate";
}(Qt || (Qt = {}));

var en = 1 / 60 * 1e3,
    rn = !0,
    on = !1,
    an = !1,
    sn = {
  delta: 0,
  timestamp: 0
},
    un = [Qt.Read, Qt.Update, Qt.Render, Qt.PostRender],
    cn = function cn(t) {
  return on = t;
},
    ln = un.reduce(function (t, n) {
  var e = function (t) {
    var n = [],
        e = [],
        r = 0,
        i = !1,
        o = 0,
        a = new WeakSet(),
        s = new WeakSet(),
        u = {
      cancel: function cancel(t) {
        var n = e.indexOf(t);
        a.add(t), -1 !== n && e.splice(n, 1);
      },
      process: function process(c) {
        var l, d;
        if (i = !0, n = (l = [e, n])[0], (e = l[1]).length = 0, r = n.length) for (o = 0; o < r; o++) {
          (d = n[o])(c), !0 !== s.has(d) || a.has(d) || (u.schedule(d), t(!0));
        }
        i = !1;
      },
      schedule: function schedule(t, o, u) {
        void 0 === o && (o = !1), void 0 === u && (u = !1), Jt("function" == typeof t, "Argument must be a function");
        var c = u && i,
            l = c ? n : e;
        a.delete(t), o && s.add(t), -1 === l.indexOf(t) && (l.push(t), c && (r = n.length));
      }
    };
    return u;
  }(cn);

  return t.sync[n] = function (t, n, r) {
    return void 0 === n && (n = !1), void 0 === r && (r = !1), on || vn(), e.schedule(t, n, r), t;
  }, t.cancelSync[n] = function (t) {
    return e.cancel(t);
  }, t.steps[n] = e, t;
}, {
  steps: {},
  sync: {},
  cancelSync: {}
}),
    dn = ln.steps,
    fn = ln.sync,
    hn = ln.cancelSync,
    pn = function pn(t) {
  return dn[t].process(sn);
},
    mn = function mn(t) {
  on = !1, sn.delta = rn ? en : Math.max(Math.min(t - sn.timestamp, 40), 1), rn || (en = sn.delta), sn.timestamp = t, an = !0, un.forEach(pn), an = !1, on && (rn = !1, nn(mn));
},
    vn = function vn() {
  on = !0, rn = !0, an || nn(mn);
},
    gn = function gn() {
  return sn;
},
    yn = function yn(t, n) {
  return function (e) {
    return Math.max(Math.min(e, n), t);
  };
},
    bn = function bn(t) {
  return t % 1 ? Number(t.toFixed(5)) : t;
},
    xn = /(-)?(\d[\d\.]*)/g,
    wn = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi,
    En = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i,
    Sn = {
  test: function test(t) {
    return "number" == typeof t;
  },
  parse: parseFloat,
  transform: function transform(t) {
    return t;
  }
},
    Cn = _Gt(_Gt({}, Sn), {
  transform: yn(0, 1)
}),
    Tn = _Gt(_Gt({}, Sn), {
  default: 1
}),
    kn = function kn(t) {
  return {
    test: function test(n) {
      return "string" == typeof n && n.endsWith(t) && 1 === n.split(" ").length;
    },
    parse: parseFloat,
    transform: function transform(n) {
      return "" + n + t;
    }
  };
},
    Ln = kn("deg"),
    Pn = kn("%"),
    An = kn("px"),
    On = kn("vh"),
    Bn = kn("vw"),
    Rn = _Gt(_Gt({}, Pn), {
  parse: function parse(t) {
    return Pn.parse(t) / 100;
  },
  transform: function transform(t) {
    return Pn.transform(100 * t);
  }
}),
    Dn = yn(0, 255),
    Nn = function Nn(t) {
  return void 0 !== t.red;
},
    zn = function zn(t) {
  return void 0 !== t.hue;
};

var Mn = function Mn(t) {
  return function (n) {
    if ("string" != typeof n) return n;

    for (var e = {}, r = function (t) {
      return t.substring(t.indexOf("(") + 1, t.lastIndexOf(")"));
    }(n).replace(/(,|\/)/g, " ").split(/ \s*/), i = 0; i < 4; i++) {
      e[t[i]] = void 0 !== r[i] ? parseFloat(r[i]) : 1;
    }

    return e;
  };
},
    In = _Gt(_Gt({}, Sn), {
  transform: function transform(t) {
    return Math.round(Dn(t));
  }
});

function Vn(t, n) {
  return t.startsWith(n) && En.test(t);
}

var _n = {
  test: function test(t) {
    return "string" == typeof t ? Vn(t, "rgb") : Nn(t);
  },
  parse: Mn(["red", "green", "blue", "alpha"]),
  transform: function transform(t) {
    var n = t.red,
        e = t.green,
        r = t.blue,
        i = t.alpha,
        o = void 0 === i ? 1 : i;
    return function (t) {
      var n = t.red,
          e = t.green,
          r = t.blue,
          i = t.alpha;
      return "rgba(" + n + ", " + e + ", " + r + ", " + (void 0 === i ? 1 : i) + ")";
    }({
      red: In.transform(n),
      green: In.transform(e),
      blue: In.transform(r),
      alpha: bn(Cn.transform(o))
    });
  }
},
    Fn = {
  test: function test(t) {
    return "string" == typeof t ? Vn(t, "hsl") : zn(t);
  },
  parse: Mn(["hue", "saturation", "lightness", "alpha"]),
  transform: function transform(t) {
    var n = t.hue,
        e = t.saturation,
        r = t.lightness,
        i = t.alpha,
        o = void 0 === i ? 1 : i;
    return function (t) {
      var n = t.hue,
          e = t.saturation,
          r = t.lightness,
          i = t.alpha;
      return "hsla(" + n + ", " + e + ", " + r + ", " + (void 0 === i ? 1 : i) + ")";
    }({
      hue: Math.round(n),
      saturation: Pn.transform(bn(e)),
      lightness: Pn.transform(bn(r)),
      alpha: bn(Cn.transform(o))
    });
  }
},
    jn = _Gt(_Gt({}, _n), {
  test: function test(t) {
    return "string" == typeof t && Vn(t, "#");
  },
  parse: function parse(t) {
    var n = "",
        e = "",
        r = "";
    return t.length > 4 ? (n = t.substr(1, 2), e = t.substr(3, 2), r = t.substr(5, 2)) : (n = t.substr(1, 1), e = t.substr(2, 1), r = t.substr(3, 1), n += n, e += e, r += r), {
      red: parseInt(n, 16),
      green: parseInt(e, 16),
      blue: parseInt(r, 16),
      alpha: 1
    };
  }
}),
    Hn = {
  test: function test(t) {
    return "string" == typeof t && En.test(t) || Nn(t) || zn(t);
  },
  parse: function parse(t) {
    return _n.test(t) ? _n.parse(t) : Fn.test(t) ? Fn.parse(t) : jn.test(t) ? jn.parse(t) : t;
  },
  transform: function transform(t) {
    return Nn(t) ? _n.transform(t) : zn(t) ? Fn.transform(t) : t;
  }
},
    Un = function Un(t) {
  return "number" == typeof t ? 0 : t;
},
    Wn = {
  test: function test(t) {
    if ("string" != typeof t || !isNaN(t)) return !1;
    var n = 0,
        e = t.match(xn),
        r = t.match(wn);
    return e && (n += e.length), r && (n += r.length), n > 0;
  },
  parse: function parse(t) {
    var n = t,
        e = [],
        r = n.match(wn);
    r && (n = n.replace(wn, "${c}"), e.push.apply(e, r.map(Hn.parse)));
    var i = n.match(xn);
    return i && e.push.apply(e, i.map(Sn.parse)), e;
  },
  createTransformer: function createTransformer(t) {
    var n = t,
        e = 0,
        r = t.match(wn),
        i = r ? r.length : 0;
    if (r) for (var o = 0; o < i; o++) {
      n = n.replace(r[o], "${c}"), e++;
    }
    var a = n.match(xn),
        s = a ? a.length : 0;
    if (a) for (o = 0; o < s; o++) {
      n = n.replace(a[o], "${n}"), e++;
    }
    return function (t) {
      for (var r = n, o = 0; o < e; o++) {
        r = r.replace(o < i ? "${c}" : "${n}", o < i ? Hn.transform(t[o]) : bn(t[o]));
      }

      return r;
    };
  },
  getAnimatableNone: function getAnimatableNone(t) {
    var n = Wn.parse(t);
    return Wn.createTransformer(t)(n.map(Un));
  }
},
    qn = function qn(t) {
  return function (n) {
    return 1 - t(1 - n);
  };
},
    Yn = function Yn(t) {
  return function (n) {
    return n <= .5 ? t(2 * n) / 2 : (2 - t(2 * (1 - n))) / 2;
  };
},
    Xn = qn,
    Gn = Yn,
    Zn = function Zn(t) {
  return function (n) {
    return Math.pow(n, t);
  };
},
    $n = function $n(t) {
  return function (n) {
    return n * n * ((t + 1) * n - t);
  };
},
    Kn = function Kn(t) {
  var n = $n(t);
  return function (t) {
    return (t *= 2) < 1 ? .5 * n(t) : .5 * (2 - Math.pow(2, -10 * (t - 1)));
  };
},
    Jn = function Jn(t) {
  return t;
},
    Qn = Zn(2),
    te = qn(Qn),
    ne = Yn(Qn),
    ee = function ee(t) {
  return 1 - Math.sin(Math.acos(t));
},
    re = qn(ee),
    ie = Yn(re),
    oe = $n(1.525),
    ae = qn(oe),
    se = Yn(oe),
    ue = Kn(1.525),
    ce = function ce(t) {
  var n = t * t;
  return t < .36363636363636365 ? 7.5625 * n : t < .7272727272727273 ? 9.075 * n - 9.9 * t + 3.4 : t < .9 ? 12.066481994459833 * n - 19.63545706371191 * t + 8.898060941828255 : 10.8 * t * t - 20.52 * t + 10.72;
},
    le = "undefined" != typeof Float32Array,
    de = function de(t, n) {
  return 1 - 3 * n + 3 * t;
},
    fe = function fe(t, n) {
  return 3 * n - 6 * t;
},
    he = function he(t) {
  return 3 * t;
},
    pe = function pe(t, n, e) {
  return 3 * de(n, e) * t * t + 2 * fe(n, e) * t + he(n);
},
    me = function me(t, n, e) {
  return ((de(n, e) * t + fe(n, e)) * t + he(n)) * t;
};

function ve(t, n, e, r) {
  var i = le ? new Float32Array(11) : new Array(11),
      o = function o(n) {
    for (var r, o, a, s = 0, u = 1; 10 !== u && i[u] <= n; ++u) {
      s += .1;
    }

    return --u, r = (n - i[u]) / (i[u + 1] - i[u]), (a = pe(o = s + .1 * r, t, e)) >= .001 ? function (n, r) {
      for (var i = 0, o = 0; i < 8; ++i) {
        if (0 === (o = pe(r, t, e))) return r;
        r -= (me(r, t, e) - n) / o;
      }

      return r;
    }(n, o) : 0 === a ? o : function (n, r, i) {
      var o,
          a,
          s = 0;

      do {
        (o = me(a = r + (i - r) / 2, t, e) - n) > 0 ? i = a : r = a;
      } while (Math.abs(o) > 1e-7 && ++s < 10);

      return a;
    }(n, s, s + .1);
  };

  !function () {
    for (var n = 0; n < 11; ++n) {
      i[n] = me(.1 * n, t, e);
    }
  }();
  return function (i) {
    return t === n && e === r ? i : 0 === i ? 0 : 1 === i ? 1 : me(o(i), n, r);
  };
}

var ge,
    ye = Object.freeze({
  __proto__: null,
  reversed: qn,
  mirrored: Yn,
  createReversedEasing: Xn,
  createMirroredEasing: Gn,
  createExpoIn: Zn,
  createBackIn: $n,
  createAnticipateEasing: Kn,
  linear: Jn,
  easeIn: Qn,
  easeOut: te,
  easeInOut: ne,
  circIn: ee,
  circOut: re,
  circInOut: ie,
  backIn: oe,
  backOut: ae,
  backInOut: se,
  anticipate: ue,
  bounceOut: ce,
  bounceIn: function bounceIn(t) {
    return 1 - ce(1 - t);
  },
  bounceInOut: function bounceInOut(t) {
    return t < .5 ? .5 * (1 - ce(1 - 2 * t)) : .5 * ce(2 * t - 1) + .5;
  },
  cubicBezier: ve
}),
    be = {
  x: 0,
  y: 0,
  z: 0
},
    xe = function xe(t) {
  return "number" == typeof t;
},
    we = (ge = function ge(t, n, e) {
  return Math.min(Math.max(e, t), n);
}, function (t, n, e) {
  return void 0 !== e ? ge(t, n, e) : function (e) {
    return ge(t, n, e);
  };
}),
    Ee = function Ee(t) {
  return t.hasOwnProperty("x") && t.hasOwnProperty("y");
},
    Se = function Se(t) {
  return Ee(t) && t.hasOwnProperty("z");
},
    Ce = function Ce(t, n) {
  return Math.abs(t - n);
},
    Te = function Te(t, n) {
  if (void 0 === n && (n = be), xe(t) && xe(n)) return Ce(t, n);

  if (Ee(t) && Ee(n)) {
    var e = Ce(t.x, n.x),
        r = Ce(t.y, n.y),
        i = Se(t) && Se(n) ? Ce(t.z, n.z) : 0;
    return Math.sqrt(Math.pow(e, 2) + Math.pow(r, 2) + Math.pow(i, 2));
  }

  return 0;
},
    ke = function ke(t, n, e) {
  var r = n - t;
  return 0 === r ? 1 : (e - t) / r;
},
    Le = function Le(t, n, e) {
  return -e * t + e * n + t;
},
    _Pe = function Pe() {
  return (_Pe = Object.assign || function (t) {
    for (var n, e = 1, r = arguments.length; e < r; e++) {
      for (var i in n = arguments[e]) {
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Ae = function Ae(t, n, e) {
  var r = t * t,
      i = n * n;
  return Math.sqrt(Math.max(0, e * (i - r) + r));
},
    Oe = [jn, _n, Fn],
    Be = function Be(t) {
  return Oe.find(function (n) {
    return n.test(t);
  });
},
    Re = function Re(t) {
  return "'" + t + "' is not an animatable color. Use the equivalent color code instead.";
},
    De = function De(t, n) {
  var e = Be(t),
      r = Be(n);
  Jt(!!e, Re(t)), Jt(!!r, Re(n)), Jt(e.transform === r.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");

  var i = e.parse(t),
      o = r.parse(n),
      a = _Pe({}, i),
      s = e === Fn ? Le : Ae;

  return function (t) {
    for (var n in a) {
      "alpha" !== n && (a[n] = s(i[n], o[n], t));
    }

    return a.alpha = Le(i.alpha, o.alpha, t), e.transform(a);
  };
},
    Ne = function Ne(t, n) {
  return function (e) {
    return n(t(e));
  };
},
    ze = function ze() {
  for (var t = [], n = 0; n < arguments.length; n++) {
    t[n] = arguments[n];
  }

  return t.reduce(Ne);
};

var Me = function Me(t, n) {
  var e = t.slice(),
      r = e.length,
      i = t.map(function (t, e) {
    return r = t, i = n[e], xe(r) ? function (t) {
      return Le(r, i, t);
    } : Hn.test(r) ? De(r, i) : Ve(r, i);
    var r, i;
  });
  return function (t) {
    for (var n = 0; n < r; n++) {
      e[n] = i[n](t);
    }

    return e;
  };
};

function Ie(t) {
  for (var n = Wn.parse(t), e = n.length, r = 0, i = 0, o = 0, a = 0; a < e; a++) {
    r || "number" == typeof n[a] ? r++ : void 0 !== n[a].hue ? o++ : i++;
  }

  return {
    parsed: n,
    numNumbers: r,
    numRGB: i,
    numHSL: o
  };
}

var Ve = function Ve(t, n) {
  var e = Wn.createTransformer(n),
      r = Ie(t),
      i = Ie(n);
  return Jt(r.numHSL === i.numHSL && r.numRGB === i.numRGB && r.numNumbers >= i.numNumbers, "Complex values '" + t + "' and '" + n + "' too different to mix. Ensure all colors are of the same type."), ze(Me(r.parsed, i.parsed), e);
},
    _e = function _e(t, n) {
  return n ? t * (1e3 / n) : 0;
},
    Fe = (we(0, 1), function () {
  return function (t, n) {
    var e = this,
        r = t.middleware,
        i = t.onComplete;
    this.isActive = !0, this.update = function (t) {
      e.observer.update && e.updateObserver(t);
    }, this.complete = function () {
      e.observer.complete && e.isActive && e.observer.complete(), e.onComplete && e.onComplete(), e.isActive = !1;
    }, this.error = function (t) {
      e.observer.error && e.isActive && e.observer.error(t), e.isActive = !1;
    }, this.observer = n, this.updateObserver = function (t) {
      return n.update(t);
    }, this.onComplete = i, n.update && r && r.length && r.forEach(function (t) {
      return e.updateObserver = t(e.updateObserver, e.complete);
    });
  };
}()),
    je = function () {
  function t(t) {
    void 0 === t && (t = {}), this.props = t;
  }

  return t.prototype.create = function (n) {
    return new t(n);
  }, t.prototype.start = function (t) {
    void 0 === t && (t = {});
    var n = !1,
        e = {
      stop: function stop() {}
    },
        r = this.props,
        i = (0, r.init)(function (t, n, e) {
      var r = n.middleware;
      return new Fe({
        middleware: r,
        onComplete: e
      }, "function" == typeof t ? {
        update: t
      } : t);
    }(t, Zt(r, ["init"]), function () {
      n = !0, e.stop();
    }));
    return e = i ? _Gt({}, e, i) : e, n && e.stop(), e;
  }, t.prototype.applyMiddleware = function (t) {
    return this.create(_Gt({}, this.props, {
      middleware: this.props.middleware ? [t].concat(this.props.middleware) : [t]
    }));
  }, t.prototype.pipe = function () {
    for (var t = [], n = 0; n < arguments.length; n++) {
      t[n] = arguments[n];
    }

    var e = 1 === t.length ? t[0] : ze.apply(void 0, t);
    return this.applyMiddleware(function (t) {
      return function (n) {
        return t(e(n));
      };
    });
  }, t;
}(),
    He = function He(t) {
  return new je({
    init: t
  });
},
    Ue = [An, Pn, Ln, On, Bn],
    We = function We(t) {
  return Ue.find(function (n) {
    return n.test(t);
  });
},
    qe = function qe(t, n) {
  return t(n);
},
    Ye = function Ye(t, n) {
  var e = n.from,
      r = n.to,
      i = Zt(n, ["from", "to"]),
      o = We(e) || We(r),
      a = o.transform,
      s = o.parse;
  return t(_Gt({}, i, {
    from: "string" == typeof e ? s(e) : e,
    to: "string" == typeof r ? s(r) : r
  })).pipe(a);
},
    Xe = function Xe(t) {
  return function (n, e) {
    var r = e.from,
        i = e.to,
        o = Zt(e, ["from", "to"]);
    return n(_Gt({}, o, {
      from: 0,
      to: 1
    })).pipe(t(r, i));
  };
},
    Ge = Xe(De),
    Ze = Xe(Ve),
    $e = function $e(t, n) {
  var e = function (t) {
    var n = Object.keys(t),
        e = function e(n, _e2) {
      return void 0 !== n && !t[_e2](n);
    };

    return {
      getVectorKeys: function getVectorKeys(t) {
        return n.reduce(function (n, r) {
          return e(t[r], r) && n.push(r), n;
        }, []);
      },
      testVectorProps: function testVectorProps(t) {
        return t && n.some(function (n) {
          return e(t[n], n);
        });
      }
    };
  }(n),
      r = e.testVectorProps,
      i = e.getVectorKeys;

  return function (n) {
    if (!r(n)) return t(n);
    var e = i(n),
        o = n[e[0]];
    return Ke(o)(t, n, e);
  };
},
    Ke = function Ke(t) {
  return "number" == typeof t ? qe : function (t) {
    return Boolean(We(t));
  }(t) ? Ye : Hn.test(t) ? Ge : Wn.test(t) ? Ze : qe;
},
    Je = $e(function (t) {
  return void 0 === t && (t = {}), He(function (n) {
    var e = n.complete,
        r = n.update,
        i = t.velocity,
        o = void 0 === i ? 0 : i,
        a = t.from,
        s = void 0 === a ? 0 : a,
        u = t.power,
        c = void 0 === u ? .8 : u,
        l = t.timeConstant,
        d = void 0 === l ? 350 : l,
        f = t.restDelta,
        h = void 0 === f ? .5 : f,
        p = t.modifyTarget,
        m = 0,
        v = c * o,
        g = Math.round(s + v),
        y = void 0 === p ? g : p(g),
        b = fn.update(function (t) {
      var n = t.delta;
      m += n;
      var i = -v * Math.exp(-m / d),
          o = i > h || i < -h;
      r(o ? y + i : y), o || (hn.update(b), e());
    }, !0);
    return {
      stop: function stop() {
        return hn.update(b);
      }
    };
  });
}, {
  from: Sn.test,
  modifyTarget: function modifyTarget(t) {
    return "function" == typeof t;
  },
  velocity: Sn.test
}),
    Qe = $e(function (t) {
  return void 0 === t && (t = {}), He(function (n) {
    var e = n.update,
        r = n.complete,
        i = t.velocity,
        o = void 0 === i ? 0 : i,
        a = t.from,
        s = void 0 === a ? 0 : a,
        u = t.to,
        c = void 0 === u ? 0 : u,
        l = t.stiffness,
        d = void 0 === l ? 100 : l,
        f = t.damping,
        h = void 0 === f ? 10 : f,
        p = t.mass,
        m = void 0 === p ? 1 : p,
        v = t.restSpeed,
        g = void 0 === v ? .01 : v,
        y = t.restDelta,
        b = void 0 === y ? .01 : y,
        x = o ? -o / 1e3 : 0,
        w = 0,
        E = c - s,
        S = s,
        C = S,
        T = fn.update(function (t) {
      var n = t.delta;
      w += n;
      var i = h / (2 * Math.sqrt(d * m)),
          a = Math.sqrt(d / m) / 1e3;

      if (C = S, i < 1) {
        var s = Math.exp(-i * a * w),
            u = a * Math.sqrt(1 - i * i);
        S = c - s * ((x + i * a * E) / u * Math.sin(u * w) + E * Math.cos(u * w));
      } else {
        s = Math.exp(-a * w);
        S = c - s * (E + (x + a * E) * w);
      }

      o = _e(S - C, n);
      var l = Math.abs(o) <= g,
          f = Math.abs(c - S) <= b;
      l && f ? (e(S = c), hn.update(T), r()) : e(S);
    }, !0);
    return {
      stop: function stop() {
        return hn.update(T);
      }
    };
  });
}, {
  from: Sn.test,
  to: Sn.test,
  stiffness: Sn.test,
  damping: Sn.test,
  mass: Sn.test,
  velocity: Sn.test
}),
    tr = $e(function (t) {
  var n = t.from,
      e = void 0 === n ? 0 : n,
      r = t.velocity,
      i = void 0 === r ? 0 : r,
      o = t.min,
      a = t.max,
      s = t.power,
      u = void 0 === s ? .8 : s,
      c = t.timeConstant,
      l = void 0 === c ? 700 : c,
      d = t.bounceStiffness,
      f = void 0 === d ? 500 : d,
      h = t.bounceDamping,
      p = void 0 === h ? 10 : h,
      m = t.restDelta,
      v = void 0 === m ? 1 : m,
      g = t.modifyTarget;
  return He(function (t) {
    var n,
        r = t.update,
        s = t.complete,
        c = e,
        d = e,
        h = !1,
        m = function m(t) {
      return void 0 !== o && t <= o;
    },
        y = function y(t) {
      return void 0 !== a && t >= a;
    },
        b = function b(t) {
      return m(t) || y(t);
    },
        x = function x(t) {
      r(t), c = d, i = _e((d = t) - c, gn().delta), n && !h && function (t, n) {
        return m(t) && n < 0 || y(t) && n > 0;
      }(t, i) && E({
        from: t,
        velocity: i
      });
    },
        w = function w(t, e) {
      n && n.stop(), n = t.start({
        update: x,
        complete: function complete() {
          e ? e() : s();
        }
      });
    },
        E = function E(t) {
      h = !0, w(Qe(_Gt({}, t, {
        to: m(t.from) ? o : a,
        stiffness: f,
        damping: p,
        restDelta: v
      })));
    };

    if (b(e)) E({
      from: e,
      velocity: i
    });else if (0 !== i) {
      var S = Je({
        from: e,
        velocity: i,
        timeConstant: l,
        power: u,
        restDelta: b(e) ? 20 : v,
        modifyTarget: g
      });
      w(S, function () {
        b(d) ? E({
          from: d,
          velocity: i
        }) : s();
      });
    } else s();
    return {
      stop: function stop() {
        return n && n.stop();
      }
    };
  });
}, {
  from: Sn.test,
  velocity: Sn.test,
  min: Sn.test,
  max: Sn.test,
  damping: Sn.test,
  stiffness: Sn.test,
  modifyTarget: function modifyTarget(t) {
    return "function" == typeof t;
  }
}),
    nr = $e(function (t) {
  var n = t.from,
      e = void 0 === n ? 0 : n,
      r = t.to,
      i = void 0 === r ? 1 : r,
      o = t.ease,
      a = void 0 === o ? Jn : o,
      s = t.reverseEase;
  return void 0 !== s && s && (a = Xn(a)), He(function (t) {
    var n = t.update;
    return {
      seek: function seek(t) {
        return n(t);
      }
    };
  }).pipe(a, function (t) {
    return Le(e, i, t);
  });
}, {
  ease: function ease(t) {
    return "function" == typeof t;
  },
  from: Sn.test,
  to: Sn.test
}),
    er = we(0, 1),
    rr = function rr(t) {
  return void 0 === t && (t = {}), He(function (n) {
    var e,
        r = n.update,
        i = n.complete,
        o = t.duration,
        a = void 0 === o ? 300 : o,
        s = t.ease,
        u = void 0 === s ? te : s,
        c = t.flip,
        l = void 0 === c ? 0 : c,
        d = t.loop,
        f = void 0 === d ? 0 : d,
        h = t.yoyo,
        p = void 0 === h ? 0 : h,
        m = t.repeatDelay,
        v = void 0 === m ? 0 : m,
        g = t.from,
        y = void 0 === g ? 0 : g,
        b = t.to,
        x = void 0 === b ? 1 : b,
        w = t.elapsed,
        E = void 0 === w ? 0 : w,
        S = t.flipCount,
        C = void 0 === S ? 0 : S,
        T = t.yoyoCount,
        k = void 0 === T ? 0 : T,
        L = t.loopCount,
        P = void 0 === L ? 0 : L,
        A = nr({
      from: y,
      to: x,
      ease: u
    }).start(r),
        O = 0,
        B = !1,
        R = function R(t) {
      var n;
      void 0 === t && (t = !1), A = nr({
        from: y = (n = [x, y])[0],
        to: x = n[1],
        ease: u,
        reverseEase: t
      }).start(r);
    },
        D = function D() {
      O = er(ke(0, a, E)), A.seek(O);
    },
        N = function N() {
      B = !0, e = fn.update(function (t) {
        var n,
            r = t.delta;
        E += r, D(), !(n = B && E > a + v) || (!n || f || l || p) && (E = E - a - v, f && P < f ? (P++, 1) : l && C < l ? (C++, R(), 1) : p && k < p && (k++, R(k % 2 != 0), 1)) || (hn.update(e), i && fn.update(i, !1, !0));
      }, !0);
    },
        z = function z() {
      B = !1, e && hn.update(e);
    };

    return N(), {
      isActive: function isActive() {
        return B;
      },
      getElapsed: function getElapsed() {
        return we(0, a, E);
      },
      getProgress: function getProgress() {
        return O;
      },
      stop: function stop() {
        z();
      },
      pause: function pause() {
        return z(), this;
      },
      resume: function resume() {
        return B || N(), this;
      },
      seek: function seek(t) {
        return E = Le(0, a, t), fn.update(D, !1, !0), this;
      },
      reverse: function reverse() {
        return R(), this;
      }
    };
  });
},
    ir = we(0, 1),
    or = function or(t, n, e) {
  return He(function (r) {
    var i = r.update,
        o = n.split(" ").map(function (n) {
      return t.addEventListener(n, i, e), n;
    });
    return {
      stop: function stop() {
        return o.forEach(function (n) {
          return t.removeEventListener(n, i, e);
        });
      }
    };
  });
},
    ar = function ar() {
  return {
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    x: 0,
    y: 0
  };
},
    sr = function sr(t, n) {
  return void 0 === n && (n = {
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    x: 0,
    y: 0
  }), n.clientX = n.x = t.clientX, n.clientY = n.y = t.clientY, n.pageX = t.pageX, n.pageY = t.pageY, n;
},
    ur = [ar()];

if ("undefined" != typeof document) {
  or(document, "touchstart touchmove", {
    passive: !0,
    capture: !0
  }).start(function (t) {
    var n = t.touches,
        e = n.length;
    ur.length = 0;

    for (var r = 0; r < e; r++) {
      var i = n[r];
      ur.push(sr(i));
    }
  });
}

var cr = ar();

if ("undefined" != typeof document) {
  or(document, "mousedown mousemove", !0).start(function (t) {
    sr(t, cr);
  });
}

var lr = function lr(t) {
  return He(function (n) {
    var e = n.complete,
        r = setTimeout(e, t);
    return {
      stop: function stop() {
        return clearTimeout(r);
      }
    };
  });
},
    dr = function dr(t) {
  return "object" == typeof t && t.hasOwnProperty("current");
},
    fr = function () {
  function t(t) {
    var n,
        e = this;
    this.timeDelta = 0, this.lastUpdated = 0, this.canTrackVelocity = !1, this.updateAndNotify = function (t, n) {
      void 0 === n && (n = !0), e.prev = e.current, e.current = t, e.updateSubscribers && e.prev !== e.current && e.updateSubscribers.forEach(e.notifySubscriber), n && e.renderSubscribers && e.renderSubscribers.forEach(e.notifySubscriber);
      var r = gn(),
          i = r.delta,
          o = r.timestamp;
      e.lastUpdated !== o && (e.timeDelta = i, e.lastUpdated = o, fn.postRender(e.scheduleVelocityCheck));
    }, this.notifySubscriber = function (t) {
      t(e.current);
    }, this.scheduleVelocityCheck = function () {
      return fn.postRender(e.velocityCheck);
    }, this.velocityCheck = function (t) {
      t.timestamp !== e.lastUpdated && (e.prev = e.current);
    }, this.set(t, !1), this.canTrackVelocity = (n = this.current, !isNaN(parseFloat(n)));
  }

  return t.prototype.subscribeTo = function (t, n) {
    var e = this,
        r = function r() {
      return n(e.current);
    };

    return t.add(r), function () {
      return t.delete(r);
    };
  }, t.prototype.onChange = function (t) {
    return this.updateSubscribers || (this.updateSubscribers = new Set()), this.subscribeTo(this.updateSubscribers, t);
  }, t.prototype.clearListeners = function () {
    var t;
    null === (t = this.updateSubscribers) || void 0 === t || t.clear();
  }, t.prototype.onRenderRequest = function (t) {
    return this.renderSubscribers || (this.renderSubscribers = new Set()), this.notifySubscriber(t), this.subscribeTo(this.renderSubscribers, t);
  }, t.prototype.attach = function (t) {
    this.passiveEffect = t;
  }, t.prototype.set = function (t, n) {
    void 0 === n && (n = !0), n && this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t, n);
  }, t.prototype.get = function () {
    return this.current;
  }, t.prototype.getPrevious = function () {
    return this.prev;
  }, t.prototype.getVelocity = function () {
    return this.canTrackVelocity ? _e(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
  }, t.prototype.start = function (t) {
    var n = this;
    return this.stop(), new Promise(function (e) {
      n.stopAnimation = t(e);
    }).then(function () {
      return n.clearAnimation();
    });
  }, t.prototype.stop = function () {
    this.stopAnimation && this.stopAnimation(), this.clearAnimation();
  }, t.prototype.isAnimating = function () {
    return !!this.stopAnimation;
  }, t.prototype.clearAnimation = function () {
    this.stopAnimation = null;
  }, t.prototype.destroy = function () {
    this.updateSubscribers && this.updateSubscribers.clear(), this.renderSubscribers && this.renderSubscribers.clear(), this.stop();
  }, t;
}();

function hr(t) {
  return new fr(t);
}

var pr = function () {
  function t(t, n) {
    var e = this;
    this.children = new Set(), this.latest = {}, this.values = new Map(), this.valueSubscriptions = new Map(), this.config = {}, this.update = function () {
      return e.config.onUpdate(e.latest);
    }, this.triggerRender = function () {
      return e.render();
    }, this.scheduleRender = function () {
      return fn.render(e.triggerRender, !1, !0);
    }, this.ref = function (t) {
      t ? e.mount(t) : e.unmount(), e.externalRef && ("function" == typeof e.externalRef ? e.externalRef(t) : dr(e.externalRef) && (e.externalRef.current = t));
    }, this.parent = t, this.rootParent = t ? t.rootParent : this, this.treePath = t ? $t(t.treePath, [t]) : [], this.depth = t ? t.depth + 1 : 0, this.externalRef = n;
  }

  return t.prototype.subscribe = function (t) {
    var n = this;
    return this.children.add(t), function () {
      return n.children.delete(t);
    };
  }, t.prototype.hasValue = function (t) {
    return this.values.has(t);
  }, t.prototype.addValue = function (t, n) {
    this.hasValue(t) && this.removeValue(t), this.values.set(t, n), this.latest[t] = n.get(), this.element && this.subscribeToValue(t, n);
  }, t.prototype.removeValue = function (t) {
    var n = this.valueSubscriptions.get(t);
    n && n(), this.values.delete(t), delete this.latest[t], this.valueSubscriptions.delete(t);
  }, t.prototype.getValue = function (t, n) {
    var e = this.values.get(t);
    return void 0 === e && void 0 !== n && (e = new fr(n), this.addValue(t, e)), e;
  }, t.prototype.forEachValue = function (t) {
    this.values.forEach(t);
  }, t.prototype.getInstance = function () {
    return this.element;
  }, t.prototype.updateConfig = function (t) {
    void 0 === t && (t = {}), this.config = _Gt({}, t);
  }, t.prototype.setSingleStaticValue = function (t, n) {
    this.latest[t] = n;
  }, t.prototype.setStaticValues = function (t, n) {
    if ("string" == typeof t) this.setSingleStaticValue(t, n);else for (var e in t) {
      this.setSingleStaticValue(e, t[e]);
    }
  }, t.prototype.scheduleUpdateLayoutDelta = function () {
    fn.update(this.rootParent.updateLayoutDelta, !1, !0);
  }, t.prototype.subscribeToValue = function (t, n) {
    var e = this,
        r = n.onChange(function (n) {
      e.setSingleStaticValue(t, n), e.latest[t] = n, e.config.onUpdate && fn.update(e.update, !1, !0);
    }),
        i = n.onRenderRequest(this.scheduleRender);
    this.valueSubscriptions.set(t, function () {
      r(), i();
    });
  }, t.prototype.mount = function (t) {
    var n = this;
    Jt(!!t, "No ref found. Ensure components created with motion.custom forward refs using React.forwardRef"), this.parent && (this.removeFromParent = this.parent.subscribe(this)), this.element = this.current = t, this.forEachValue(function (t, e) {
      return n.subscribeToValue(e, t);
    });
  }, t.prototype.unmount = function () {
    var t = this;
    this.forEachValue(function (n, e) {
      return t.removeValue(e);
    }), hn.update(this.update), hn.render(this.render), this.removeFromParent && this.removeFromParent();
  }, t;
}();

function mr(t) {
  return t;
}

function vr(t) {
  var n = t.top;
  return {
    x: {
      min: t.left,
      max: t.right
    },
    y: {
      min: n,
      max: t.bottom
    }
  };
}

function gr(t) {
  return {
    x: _Gt({}, t.x),
    y: _Gt({}, t.y)
  };
}

var yr = {
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
};

function br() {
  return {
    x: _Gt({}, yr),
    y: _Gt({}, yr)
  };
}

var xr = _Gt(_Gt({}, Sn), {
  transform: Math.round
}),
    wr = {
  color: Hn,
  backgroundColor: Hn,
  outlineColor: Hn,
  fill: Hn,
  stroke: Hn,
  borderColor: Hn,
  borderTopColor: Hn,
  borderRightColor: Hn,
  borderBottomColor: Hn,
  borderLeftColor: Hn,
  borderWidth: An,
  borderTopWidth: An,
  borderRightWidth: An,
  borderBottomWidth: An,
  borderLeftWidth: An,
  borderRadius: An,
  radius: An,
  borderTopLeftRadius: An,
  borderTopRightRadius: An,
  borderBottomRightRadius: An,
  borderBottomLeftRadius: An,
  width: An,
  maxWidth: An,
  height: An,
  maxHeight: An,
  size: An,
  top: An,
  right: An,
  bottom: An,
  left: An,
  padding: An,
  paddingTop: An,
  paddingRight: An,
  paddingBottom: An,
  paddingLeft: An,
  margin: An,
  marginTop: An,
  marginRight: An,
  marginBottom: An,
  marginLeft: An,
  rotate: Ln,
  rotateX: Ln,
  rotateY: Ln,
  rotateZ: Ln,
  scale: Tn,
  scaleX: Tn,
  scaleY: Tn,
  scaleZ: Tn,
  skew: Ln,
  skewX: Ln,
  skewY: Ln,
  distance: An,
  translateX: An,
  translateY: An,
  translateZ: An,
  x: An,
  y: An,
  z: An,
  perspective: An,
  opacity: Cn,
  originX: Rn,
  originY: Rn,
  originZ: An,
  zIndex: xr,
  fillOpacity: Cn,
  strokeOpacity: Cn,
  numOctaves: xr
},
    Er = [Sn, An, Pn, Ln, Bn, On, {
  test: function test(t) {
    return "auto" === t;
  },
  parse: function parse(t) {
    return t;
  }
}],
    Sr = function Sr(t) {
  return function (n) {
    return n.test(t);
  };
},
    Cr = function Cr(t) {
  return Er.find(Sr(t));
},
    Tr = $t(Er, [Hn, Wn]),
    kr = function kr(t) {
  return Tr.find(Sr(t));
},
    Lr = function Lr(t) {
  return wr[t];
},
    Pr = function Pr(t, n) {
  return n && "number" == typeof t ? n.transform(t) : t;
},
    Ar = ["", "X", "Y", "Z"],
    Or = ["x", "y", "z"];

function Br(t, n) {
  return Or.indexOf(t) - Or.indexOf(n);
}

["translate", "scale", "rotate", "skew", "transformPerspective"].forEach(function (t) {
  Ar.forEach(function (n) {
    return Or.push(t + n);
  });
});
var Rr = new Set(Or);

function Dr(t) {
  return Rr.has(t);
}

var Nr = new Set(["originX", "originY", "originZ"]);

function zr(t) {
  return Nr.has(t);
}

var Mr = {
  x: "translateX",
  y: "translateY",
  z: "translateZ"
};

function Ir(t) {
  return t.startsWith("--");
}

function Vr(t, n) {
  return t / (n.max - n.min) * 100;
}

var _r = {
  process: function process(t, n) {
    return "number" != typeof t ? t : Vr(t, n.x) + "% " + Vr(t, n.y) + "%";
  }
},
    Fr = {
  borderRadius: _Gt(_Gt({}, _r), {
    applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
  }),
  borderTopLeftRadius: _r,
  borderTopRightRadius: _r,
  borderBottomLeftRadius: _r,
  borderBottomRightRadius: _r,
  boxShadow: {
    process: function process(t, n, e, r) {
      var i = Wn.parse(t),
          o = Wn.createTransformer(t),
          a = e.x.scale * r.x,
          s = e.y.scale * r.y;
      i[1] /= a, i[2] /= s;
      var u = Le(a, s, .5);
      return "number" == typeof i[3] && (i[3] /= u), "number" == typeof i[4] && (i[4] /= u), o(i);
    }
  }
};

function jr(t, n) {
  return "translate3d(" + t.x.translate / n.x + "px, " + t.y.translate / n.y + "px, 0) scale(" + t.x.scale + ", " + t.y.scale + ")";
}

function Hr(t, n, e, r, i, o, a, s, u, c, l, d) {
  var f = a.enableHardwareAcceleration,
      h = a.transformTemplate,
      p = a.allowTransformNone;
  o.length = 0;
  var m = !!s,
      v = !!s,
      g = !0;

  for (var y in t) {
    var b = t[y],
        x = Lr(y),
        w = Pr(b, x);

    if (Dr(y)) {
      if (m = !0, r[y] = w, o.push(y), !g) continue;
      b !== (void 0 !== x.default ? x.default : 0) && (g = !1);
    } else if (zr(y)) i[y] = w, v = !0;else if ("transform" !== y || "function" != typeof b) {
      var E = Ir(y) ? e : n;

      if (s && Fr[y]) {
        var S = Fr[y].process(b, d, u, l),
            C = Fr[y].applyTo;
        if (C) for (var T = C.length, k = 0; k < T; k++) {
          E[C[k]] = S;
        } else E[y] = S;
      } else E[y] = w;
    }
  }

  if ((m || h) && (s ? (n.transform = jr(c, l), h && (n.transform = h(r, n.transform))) : n.transform = function (t, n, e, r, i, o) {
    void 0 === i && (i = !0), void 0 === o && (o = !0);
    var a = "",
        s = !1;
    n.sort(Br);

    for (var u = n.length, c = 0; c < u; c++) {
      var l = n[c];
      a += (Mr[l] || l) + "(" + t[l] + ") ", "z" === l && (s = !0);
    }

    return !s && i ? a += "translateZ(0)" : a = a.trim(), e ? a = e(t, r ? "" : a) : o && r && (a = "none"), a;
  }(r, o, h, g, f, p)), v) {
    var L = s ? 100 * c.x.origin + "%" : i.originX || "50%",
        P = s ? 100 * c.y.origin + "%" : i.originY || "50%",
        A = i.originZ || "0";
    n.transformOrigin = L + " " + P + " " + A;
  }
}

function Ur(t, n) {
  t.min = n.min, t.max = n.max;
}

function Wr(t, n, e) {
  return e + n * (t - e);
}

function qr(t, n, e, r, i) {
  return void 0 !== i && (t = Wr(t, i, r)), Wr(t, e, r) + n;
}

function Yr(t, n, e, r, i) {
  void 0 === n && (n = 0), void 0 === e && (e = 1), t.min = qr(t.min, n, e, r, i), t.max = qr(t.max, n, e, r, i);
}

function Xr(t, n) {
  var e = n.x,
      r = n.y;
  Yr(t.x, e.translate, e.scale, e.originPoint), Yr(t.y, r.translate, r.scale, r.originPoint);
}

function Gr(t, n, e, r) {
  var i = r[0],
      o = r[1],
      a = r[2];
  t.min = n.min, t.max = n.max;
  var s = Le(n.min, n.max, e[a] || .5);
  Yr(t, e[i], e[o], s, e.scale);
}

var Zr = ["x", "scaleX", "originX"],
    $r = ["y", "scaleY", "originY"];

function Kr(t, n, e, r, i) {
  return t = Wr(t -= n, 1 / e, r), void 0 !== i && (t = Wr(t, 1 / i, r)), t;
}

function Jr(t, n, e) {
  var r = e[0],
      i = e[1],
      o = e[2];
  !function (t, n, e, r, i) {
    void 0 === n && (n = 0), void 0 === e && (e = 1), void 0 === r && (r = .5);
    var o = Le(t.min, t.max, r) - n;
    t.min = Kr(t.min, n, e, o, i), t.max = Kr(t.max, n, e, o, i);
  }(t, n[r], n[i], n[o], n.scale);
}

var Qr = we(0, 1);

function ti(t, n, e) {
  return void 0 === n && (n = 0), void 0 === e && (e = .01), Te(t, n) < e;
}

function ni(t, n) {
  var e = .5,
      r = t.max - t.min,
      i = n.max - n.min;
  return i > r ? e = ke(n.min, n.max - r, t.min) : r > i && (e = ke(t.min, t.max - i, n.min)), Qr(e);
}

function ei(t, n, e, r) {
  var i = n.max - n.min,
      o = e.max - e.min;
  t.origin = void 0 === r ? ni(n, e) : r, t.originPoint = Le(n.min, n.max, t.origin), t.scale = o / i, ti(t.scale, 1, 1e-4) && (t.scale = 1), t.translate = function (t, n, e) {
    var r = Le(t.min, t.max, e);
    return Le(n.min, n.max, e) - r;
  }(n, e, t.origin), ti(t.translate) && (t.translate = 0);
}

function ri(t, n, e, r) {
  ei(t.x, n.x, e.x, r), ei(t.y, n.y, e.y, r);
}

function ii(t) {
  return [t("x"), t("y")];
}

var oi = function oi(t) {
  return Array.isArray(t);
},
    ai = function ai() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restDelta: .5,
    restSpeed: 10
  };
},
    si = function si(t) {
  return {
    type: "spring",
    stiffness: 700,
    damping: 0 === t ? 100 : 35
  };
},
    ui = function ui() {
  return {
    ease: "linear",
    duration: .3
  };
},
    ci = function ci(t) {
  return {
    type: "keyframes",
    duration: .8,
    values: t
  };
},
    li = {
  x: ai,
  y: ai,
  z: ai,
  rotate: ai,
  rotateX: ai,
  rotateY: ai,
  rotateZ: ai,
  scaleX: si,
  scaleY: si,
  scale: si,
  opacity: ui,
  backgroundColor: ui,
  color: ui,
  default: si
},
    di = function di(t) {
  var n = t.to,
      e = t.duration;
  return He(function (t) {
    var r = t.update,
        i = t.complete;
    r(n), e ? lr(e).start({
      complete: i
    }) : i();
  });
},
    fi = function fi(t) {
  return Array.isArray(t) ? (Jt(4 === t.length, "Cubic bezier arrays must contain four numerical values."), ve(t[0], t[1], t[2], t[3])) : "string" == typeof t ? (Jt(void 0 !== ye[t], "Invalid easing type '" + t + "'"), ye[t]) : t;
},
    hi = function hi(t) {
  return Array.isArray(t) && "number" != typeof t[0];
},
    pi = function pi(t, n) {
  return "zIndex" !== t && (!("number" != typeof n && !Array.isArray(n)) || !("string" != typeof n || !Wn.test(n) || n.startsWith("url(")));
},
    mi = function mi(t) {
  return 1e3 * t;
},
    vi = {
  tween: rr,
  spring: Qe,
  keyframes: function keyframes(t) {
    var n = t.easings,
        e = t.ease,
        r = void 0 === e ? Jn : e,
        i = t.times,
        o = t.values,
        a = Zt(t, ["easings", "ease", "times", "values"]);
    n = Array.isArray(n) ? n : function (t, n) {
      return t.map(function () {
        return n || te;
      }).splice(0, t.length - 1);
    }(o, n), i = i || function (t) {
      var n = t.length;
      return t.map(function (t, e) {
        return 0 !== e ? e / (n - 1) : 0;
      });
    }(o);
    var s = n.map(function (t, n) {
      return nr({
        from: o[n],
        to: o[n + 1],
        ease: t
      });
    });
    return rr(_Gt({}, a, {
      ease: r
    })).applyMiddleware(function (t) {
      return function (t, n, e) {
        var r = t.length,
            i = r - 1,
            o = i - 1,
            a = n.map(function (t) {
          return t.start(e);
        });
        return function (n) {
          n <= t[0] && a[0].seek(0), n >= t[i] && a[o].seek(1);

          for (var e = 1; e < r && !(t[e] > n || e === i); e++) {
            ;
          }

          var s = ke(t[e - 1], t[e], n);
          a[e - 1].seek(ir(s));
        };
      }(i, s, t);
    });
  },
  inertia: tr,
  just: di
},
    gi = {
  tween: function tween(t) {
    if (t.ease) {
      var n = hi(t.ease) ? t.ease[0] : t.ease;
      t.ease = fi(n);
    }

    return t;
  },
  keyframes: function keyframes(t) {
    var n = t.from,
        e = (t.to, t.velocity, Zt(t, ["from", "to", "velocity"]));

    if (e.values && null === e.values[0]) {
      var r = $t(e.values);
      r[0] = n, e.values = r;
    }

    return e.ease && (e.easings = hi(e.ease) ? e.ease.map(fi) : fi(e.ease)), e.ease = Jn, e;
  }
},
    yi = function yi(t, n, e) {
  var r = e ? e.delay : 0;
  if (void 0 === e || !function (t) {
    t.when, t.delay, t.delayChildren, t.staggerChildren, t.staggerDirection;
    var n = Zt(t, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection"]);
    return Object.keys(n).length;
  }(e)) return _Gt({
    delay: r
  }, function (t, n) {
    var e;
    return e = oi(n) ? ci : li[t] || li.default, _Gt({
      to: n
    }, e(n));
  }(t, n));
  var i = e[t] || e.default || e;
  return !1 === i.type ? {
    delay: i.hasOwnProperty("delay") ? i.delay : r,
    to: oi(n) ? n[n.length - 1] : n,
    type: "just"
  } : oi(n) ? _Gt(_Gt({
    values: n,
    duration: .8,
    delay: r,
    ease: "linear"
  }, i), {
    type: "keyframes"
  }) : _Gt({
    type: "tween",
    to: n,
    delay: r
  }, i);
},
    bi = function bi(t, n, e, r) {
  var i = n.get(),
      o = pi(t, i),
      a = pi(t, e);
  Kt(o === a, "You are trying to animate " + t + ' from "' + i + '" to "' + e + '". ' + i + " is not an animatable value - to enable this animation set " + i + " to a value animatable to " + e + " via the `style` property.");

  var s,
      u = yi(t, e, r),
      c = u.type,
      l = void 0 === c ? "tween" : c,
      d = Zt(u, ["type"]),
      f = o && a ? vi[l] : di,
      h = function (t, n) {
    return gi[t] ? gi[t](n) : n;
  }(l, _Gt({
    from: i,
    velocity: n.getVelocity()
  }, d));

  return ((s = h).hasOwnProperty("duration") || s.hasOwnProperty("repeatDelay")) && (h.duration && (h.duration = mi(h.duration)), h.repeatDelay && (h.repeatDelay = mi(h.repeatDelay))), [f, h];
};

function xi(t, n, e, r) {
  void 0 === r && (r = {});
  var i = r.delay,
      o = void 0 === i ? 0 : i,
      a = Zt(r, ["delay"]);
  return n.start(function (r) {
    var i,
        s = bi(t, n, e, a),
        u = s[0],
        c = s[1],
        l = c.delay,
        d = Zt(c, ["delay"]);
    void 0 !== l && (o = l);

    var f = function f() {
      var t = u(d);
      i = t.start({
        update: function update(t) {
          return n.set(t);
        },
        complete: r
      });
    };

    return o ? i = lr(mi(o)).start({
      complete: f
    }) : f(), function () {
      i && i.stop();
    };
  });
}

function wi(t, n) {
  return vr(function (t, n) {
    var e = t.top,
        r = t.left,
        i = t.bottom,
        o = t.right;
    void 0 === n && (n = mr);
    var a = n({
      x: r,
      y: e
    }),
        s = n({
      x: o,
      y: i
    });
    return {
      top: a.y,
      left: a.x,
      bottom: s.y,
      right: s.x
    };
  }(t.getBoundingClientRect(), n));
}

var Ei = function (t) {
  function n() {
    var n = null !== t && t.apply(this, arguments) || this;
    return n.defaultConfig = {
      enableHardwareAcceleration: !0,
      allowTransformNone: !0
    }, n.style = {}, n.reactStyle = {}, n.vars = {}, n.transform = {}, n.transformOrigin = {}, n.transformKeys = [], n.config = n.defaultConfig, n.isLayoutProjectionEnabled = !1, n.layoutUpdateListeners = new Set(), n.hasViewportBoxUpdated = !1, n.targetBoxFinal = {
      x: {
        min: 0,
        max: 1
      },
      y: {
        min: 0,
        max: 1
      }
    }, n.treeScale = {
      x: 1,
      y: 1
    }, n.delta = br(), n.deltaFinal = br(), n.stopLayoutAxisAnimation = {
      x: function x() {},
      y: function y() {}
    }, n.isTargetBoxLocked = !1, n.axisProgress = {
      x: hr(0),
      y: hr(0)
    }, n.updateLayoutDelta = function () {
      n.isLayoutProjectionEnabled && n.box && n.updateLayoutDeltas(), n.children.forEach(Si);
    }, n;
  }

  return Xt(n, t), n.prototype.removeValue = function (n) {
    t.prototype.removeValue.call(this, n), delete this.vars[n], delete this.style[n];
  }, n.prototype.clean = function () {
    this.style = {}, this.vars = {}, this.transform = {};
  }, n.prototype.updateConfig = function (t) {
    void 0 === t && (t = {}), this.config = _Gt(_Gt({}, this.defaultConfig), t);
  }, n.prototype.read = function (t) {
    return this.getComputedStyle()[t] || 0;
  }, n.prototype.readNativeValue = function (t) {
    if (Dr(t)) {
      var n = Lr(t);
      return n && n.default || 0;
    }

    return this.read(t);
  }, n.prototype.enableLayoutProjection = function () {
    this.isLayoutProjectionEnabled = !0;
  }, n.prototype.hide = function () {
    !1 !== this.isVisible && (this.isVisible = !1, this.scheduleRender());
  }, n.prototype.show = function () {
    !0 !== this.isVisible && (this.isVisible = !0, this.scheduleRender());
  }, n.prototype.onLayoutUpdate = function (t) {
    var n = this;
    return this.layoutUpdateListeners.add(t), function () {
      return n.layoutUpdateListeners.delete(t);
    };
  }, n.prototype.layoutReady = function (t) {
    var n = this;
    this.layoutUpdateListeners.forEach(function (e) {
      e(n.box, n.prevViewportBox || n.box, t);
    });
  }, n.prototype.getBoundingBox = function () {
    var t = this.config.transformPagePoint;
    return wi(this.element, t);
  }, n.prototype.getBoundingBoxWithoutTransforms = function () {
    var t,
        n,
        e = this.getBoundingBox();
    return t = e, n = this.latest, Jr(t.x, n, Zr), Jr(t.y, n, $r), e;
  }, n.prototype.getComputedStyle = function () {
    return window.getComputedStyle(this.element);
  }, n.prototype.snapshotBoundingBox = function () {
    this.prevViewportBox = this.getBoundingBoxWithoutTransforms();
    var t = this.axisProgress,
        n = t.x,
        e = t.y;
    this.isTargetBoxLocked || n.isAnimating() || e.isAnimating() || (this.targetBox = gr(this.prevViewportBox));
  }, n.prototype.measureLayout = function () {
    this.box = this.getBoundingBox(), this.boxCorrected = gr(this.box), this.targetBox || (this.targetBox = gr(this.box));
  }, n.prototype.refreshTargetBox = function () {
    this.targetBox = this.getBoundingBoxWithoutTransforms();
  }, n.prototype.lockTargetBox = function () {
    this.isTargetBoxLocked = !0;
  }, n.prototype.unlockTargetBox = function () {
    this.stopLayoutAnimation(), this.isTargetBoxLocked = !1;
  }, n.prototype.resetTransform = function () {
    var t = this.config.transformTemplate;
    this.element.style.transform = t ? t({}, "") : "none", this.scheduleRender();
  }, n.prototype.setAxisTarget = function (t, n, e) {
    var r = this.targetBox[t];
    r.min = n, r.max = e, this.hasViewportBoxUpdated = !0, this.rootParent.scheduleUpdateLayoutDelta();
  }, n.prototype.startLayoutAxisAnimation = function (t, n) {
    var e = this,
        r = this.axisProgress[t],
        i = this.targetBox[t],
        o = i.min,
        a = i.max - o;
    return r.clearListeners(), r.set(o), r.set(o), r.onChange(function (n) {
      return e.setAxisTarget(t, n, n + a);
    }), xi(t, r, 0, n);
  }, n.prototype.stopLayoutAnimation = function () {
    var t = this;
    ii(function (n) {
      return t.axisProgress[n].stop();
    });
  }, n.prototype.updateLayoutDeltas = function () {
    var t, n, e, r, i, o, a;
    e = this.boxCorrected, r = this.box, Ur(e.x, r.x), Ur(e.y, r.y), this.parent && (i = this.treeScale, o = this.parent.treeScale, a = this.parent.delta, i.x = o.x * a.x.scale, i.y = o.y * a.y.scale), function (t, n) {
      for (var e = n.length, r = 0; r < e; r++) {
        Xr(t, n[r].delta);
      }
    }(this.boxCorrected, this.treePath), ri(this.delta, this.boxCorrected, this.targetBox), this.hasViewportBoxUpdated && (null === (n = (t = this.config).onViewportBoxUpdate) || void 0 === n || n.call(t, this.targetBox, this.delta)), this.hasViewportBoxUpdated = !1;
    var s = jr(this.delta, this.treeScale);
    s !== this.deltaTransform && this.scheduleRender(), this.deltaTransform = s;
  }, n.prototype.updateTransformDeltas = function () {
    var t, n, e;
    this.isLayoutProjectionEnabled && this.box && (t = this.targetBoxFinal, n = this.targetBox, e = this.latest, Gr(t.x, n.x, e, Zr), Gr(t.y, n.y, e, $r), ri(this.deltaFinal, this.boxCorrected, this.targetBoxFinal));
  }, n.prototype.build = function () {
    this.updateTransformDeltas(), void 0 !== this.isVisible && (this.style.visibility = this.isVisible ? "visible" : "hidden"), Hr(this.latest, this.style, this.vars, this.transform, this.transformOrigin, this.transformKeys, this.config, this.isLayoutProjectionEnabled && !!this.box, this.delta, this.deltaFinal, this.treeScale, this.targetBoxFinal);
  }, n.prototype.render = function () {
    for (var t in this.build(), Object.assign(this.element.style, this.style), this.vars) {
      this.element.style.setProperty(t, this.vars[t]);
    }
  }, n;
}(pr),
    Si = function Si(t) {
  return t.updateLayoutDelta();
};

function Ci(t) {
  var n = r(null);
  return null === n.current && (n.current = t()), n.current;
}

function Ti(t, n, e) {
  return "string" == typeof t ? t : An.transform(n + e * t);
}

var ki = function ki(t, n) {
  return An.transform(t * n);
},
    Li = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
},
    Pi = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};

var Ai = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};

function Oi(t, n, e, r, i, o, a, s, u, c, l, d, f, h, p) {
  var m = t.attrX,
      v = t.attrY,
      g = t.originX,
      y = t.originY,
      b = t.pathLength,
      x = t.pathSpacing,
      w = void 0 === x ? 1 : x,
      E = t.pathOffset,
      S = void 0 === E ? 0 : E;
  return Hr(Zt(t, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]), r, e, i, o, a, s, l, d, f, h, p), r.transform && (n.transform = r.transform, delete r.transform), (void 0 !== g || void 0 !== y || n.transform) && (n.transformOrigin = function (t, n, e) {
    return Ti(n, t.x, t.width) + " " + Ti(e, t.y, t.height);
  }(u || Ai, void 0 !== g ? g : .5, void 0 !== y ? y : .5)), void 0 !== m && (r.x = m), void 0 !== v && (r.y = v), void 0 !== c && void 0 !== b && function (t, n, e, r, i, o) {
    void 0 === r && (r = 1), void 0 === i && (i = 0), void 0 === o && (o = !0);
    var a = o ? Li : Pi;
    t[a.offset] = ki(-i, n);
    var s = ki(e, n),
        u = ki(r, n);
    t[a.array] = s + " " + u;
  }(r, c, b, w, S, !1), r;
}

var Bi = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues"]),
    Ri = /([a-z])([A-Z])/g,
    Di = function Di(t) {
  return t.replace(Ri, "$1-$2").toLowerCase();
},
    Ni = function (t) {
  function n() {
    var n = null !== t && t.apply(this, arguments) || this;
    return n.attrs = {}, n.defaultConfig = {
      enableHardwareAcceleration: !1
    }, n.config = n.defaultConfig, n;
  }

  return Xt(n, t), n.prototype.mount = function (n) {
    t.prototype.mount.call(this, n), this.measure();
  }, n.prototype.measure = function () {
    try {
      this.dimensions = "function" == typeof this.element.getBBox ? this.element.getBBox() : this.element.getBoundingClientRect();
    } catch (t) {
      this.dimensions = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    }

    "path" === this.element.tagName && (this.totalPathLength = this.element.getTotalLength());
  }, n.prototype.clean = function () {
    t.prototype.clean.call(this), this.attrs = {};
  }, n.prototype.read = function (t) {
    return t = Bi.has(t) ? t : Di(t), this.element.getAttribute(t);
  }, n.prototype.build = function () {
    this.updateTransformDeltas(), Oi(this.latest, this.style, this.vars, this.attrs, this.transform, this.transformOrigin, this.transformKeys, this.config, this.dimensions, this.totalPathLength, this.isLayoutProjectionEnabled && !!this.box, this.delta, this.deltaFinal, this.treeScale, this.targetBoxFinal);
  }, n.prototype.render = function () {
    for (var n in t.prototype.render.call(this), this.attrs) {
      this.element.setAttribute(Di(n), this.attrs[n]);
    }
  }, n;
}(Ei);

var zi = new Set(["animate", "circle", "clipPath", "defs", "desc", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use", "view"]);

function Mi(t) {
  return "string" == typeof t && zi.has(t);
}

var Ii = a(null);

function Vi() {
  var t = e(Ii);
  if (null === t) return [!0, null];
  var n = t.isPresent,
      r = t.onExitComplete,
      i = t.register,
      a = ji();
  o(function () {
    return i(a);
  }, []);
  return !n && r ? [!1, function () {
    return null == r ? void 0 : r(a);
  }] : [!0];
}

var _i = 0,
    Fi = function Fi() {
  return _i++;
},
    ji = function ji() {
  return Ci(Fi);
},
    Hi = function Hi(t, n, r, i, o) {
  var a = Ci(function () {
    return new (Mi(t) ? Ni : Ei)(r, o);
  });
  a.updateConfig(_Gt({
    enableHardwareAcceleration: !i
  }, n)), a.layoutId = n.layoutId;
  var s,
      u = null === (s = e(Ii)) || s.isPresent;
  return a.isPresent = void 0 !== n.isPresent ? n.isPresent : u, a;
},
    Ui = new Set(["initial", "animate", "exit", "style", "variants", "transition", "transformTemplate", "transformValues", "custom", "inherit", "static", "layout", "layoutId", "onLayoutAnimationComplete", "onViewportBoxUpdate", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "drag", "dragControls", "dragListener", "dragConstraints", "dragDirectionLock", "dragElastic", "dragMomentum", "dragPropagation", "dragTransition", "onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "whileHover", "whileTap", "onHoverEnd", "onHoverStart"]);

function Wi(t) {
  return Ui.has(t);
}

var qi = function qi(t) {
  return !Wi(t);
};

try {
  var Yi = require("@emotion/is-prop-valid").default;

  qi = function qi(t) {
    return t.startsWith("on") ? !Wi(t) : Yi(t);
  };
} catch (ln) {}

function Xi(t, n, e) {
  var r = "string" == typeof t ? function (t) {
    var n = {};

    for (var e in t) {
      qi(e) && (n[e] = t[e]);
    }

    return n;
  }(n) : n;
  e.clean(), e.build();
  var i = Mi(t) ? function (t) {
    return _Gt(_Gt({}, t.attrs), {
      style: _Gt({}, t.reactStyle)
    });
  }(e) : function (t, n) {
    var e = n.drag,
        r = {
      style: _Gt(_Gt(_Gt({}, t.reactStyle), t.style), t.vars)
    };
    return e && (r.style.userSelect = "none", r.draggable = !1), r;
  }(e, n);
  return s(t, _Gt(_Gt(_Gt({}, r), {
    ref: e.ref
  }), i));
}

function Gi(t) {
  return "string" == typeof t && t.startsWith("var(--");
}

var Zi = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

function $i(t, n, e) {
  void 0 === e && (e = 1), Jt(e <= 4, 'Max CSS variable fallback depth detected in property "' + t + '". This may indicate a circular fallback dependency.');

  var r = function (t) {
    var n = Zi.exec(t);
    return n ? [n[1], n[2]] : [,];
  }(t),
      i = r[0],
      o = r[1];

  if (i) {
    var a = window.getComputedStyle(n).getPropertyValue(i);
    return a || (Gi(o) ? $i(o, n, e + 1) : o);
  }
}

var Ki,
    Ji = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y"]),
    Qi = function Qi(t) {
  return Ji.has(t);
},
    to = function to(t, n) {
  t.set(n, !1), t.set(n);
},
    no = function no(t) {
  return t === Sn || t === An;
};

!function (t) {
  t.width = "width", t.height = "height", t.left = "left", t.right = "right", t.top = "top", t.bottom = "bottom";
}(Ki || (Ki = {}));

var eo = function eo(t, n) {
  return parseFloat(t.split(", ")[n]);
},
    ro = function ro(t, n) {
  return function (e, r) {
    var i = r.transform;
    if ("none" === i || !i) return 0;
    var o = i.match(/^matrix3d\((.+)\)$/);
    if (o) return eo(o[1], n);
    var a = i.match(/^matrix\((.+)\)$/);
    return a ? eo(a[1], t) : 0;
  };
},
    io = new Set(["x", "y", "z"]),
    oo = Or.filter(function (t) {
  return !io.has(t);
});

var ao = {
  width: function width(t) {
    var n = t.x;
    return n.max - n.min;
  },
  height: function height(t) {
    var n = t.y;
    return n.max - n.min;
  },
  top: function top(t, n) {
    var e = n.top;
    return parseFloat(e);
  },
  left: function left(t, n) {
    var e = n.left;
    return parseFloat(e);
  },
  bottom: function bottom(t, n) {
    var e = t.y,
        r = n.top;
    return parseFloat(r) + (e.max - e.min);
  },
  right: function right(t, n) {
    var e = t.x,
        r = n.left;
    return parseFloat(r) + (e.max - e.min);
  },
  x: ro(4, 13),
  y: ro(5, 14)
},
    so = function so(t, n, e, r) {
  void 0 === e && (e = {}), void 0 === r && (r = {}), n = _Gt({}, n), r = _Gt({}, r);
  var i = Object.keys(n).filter(Qi),
      o = [],
      a = !1,
      s = [];

  if (i.forEach(function (i) {
    var u = t.getValue(i);

    if (t.hasValue(i)) {
      var c,
          l = e[i],
          d = n[i],
          f = Cr(l);
      if (oi(d)) for (var h = d.length, p = null === d[0] ? 1 : 0; p < h; p++) {
        c ? Jt(Cr(d[p]) === c, "All keyframes must be of the same type") : (c = Cr(d[p]), Jt(c === f || no(f) && no(c), "Keyframes must be of the same dimension as the current value"));
      } else c = Cr(d);
      if (f !== c) if (no(f) && no(c)) {
        var m = u.get();
        "string" == typeof m && u.set(parseFloat(m)), "string" == typeof d ? n[i] = parseFloat(d) : Array.isArray(d) && c === An && (n[i] = d.map(parseFloat));
      } else a || (o = function (t) {
        var n = [];
        return oo.forEach(function (e) {
          var r = t.getValue(e);
          void 0 !== r && (n.push([e, r.get()]), r.set(e.startsWith("scale") ? 1 : 0));
        }), n.length && t.render(), n;
      }(t), a = !0), s.push(i), r[i] = void 0 !== r[i] ? r[i] : n[i], to(u, d);
    }
  }), s.length) {
    var u = function (t, n, e) {
      var r = n.getBoundingBox(),
          i = n.getComputedStyle(),
          o = i.display,
          a = {
        top: i.top,
        left: i.left,
        bottom: i.bottom,
        right: i.right,
        transform: i.transform
      };
      "none" === o && n.setStaticValues("display", t.display || "block"), n.render();
      var s = n.getBoundingBox();
      return e.forEach(function (e) {
        var o = n.getValue(e);
        to(o, ao[e](r, a)), t[e] = ao[e](s, i);
      }), t;
    }(n, t, s);

    return o.length && o.forEach(function (n) {
      var e = n[0],
          r = n[1];
      t.getValue(e).set(r);
    }), t.render(), {
      target: u,
      transitionEnd: r
    };
  }

  return {
    target: n,
    transitionEnd: r
  };
};

function uo(t, n, e, r) {
  return function (t) {
    return Object.keys(t).some(Qi);
  }(n) ? so(t, n, e, r) : {
    target: n,
    transitionEnd: r
  };
}

var co = function co(t, n, e, r) {
  var i = function (t, n, e) {
    var r = Zt(n, []),
        i = t.getInstance();
    if (!(i instanceof HTMLElement)) return {
      target: r,
      transitionEnd: e
    };

    for (var o in e && (e = _Gt({}, e)), t.forEachValue(function (t) {
      var n = t.get();

      if (Gi(n)) {
        var e = $i(n, i);
        e && t.set(e);
      }
    }), r) {
      var a = r[o];

      if (Gi(a)) {
        var s = $i(a, i);
        s && (r[o] = s, e && void 0 === e[o] && (e[o] = a));
      }
    }

    return {
      target: r,
      transitionEnd: e
    };
  }(t, n, r);

  return uo(t, n = i.target, e, r = i.transitionEnd);
};

var lo = function () {
  function t() {
    this.hasMounted = !1, this.pendingAnimations = [], this.componentControls = new Set();
  }

  return t.prototype.setVariants = function (t) {
    this.variants = t, this.componentControls.forEach(function (n) {
      return n.setVariants(t);
    });
  }, t.prototype.setDefaultTransition = function (t) {
    this.defaultTransition = t, this.componentControls.forEach(function (n) {
      return n.setDefaultTransition(t);
    });
  }, t.prototype.subscribe = function (t) {
    var n = this;
    return this.componentControls.add(t), this.variants && t.setVariants(this.variants), this.defaultTransition && t.setDefaultTransition(this.defaultTransition), function () {
      return n.componentControls.delete(t);
    };
  }, t.prototype.start = function (t, n) {
    var e = this;

    if (this.hasMounted) {
      var r = [];
      return this.componentControls.forEach(function (e) {
        var i = e.start(t, {
          transitionOverride: n
        });
        r.push(i);
      }), Promise.all(r);
    }

    return new Promise(function (r) {
      e.pendingAnimations.push({
        animation: [t, n],
        resolve: r
      });
    });
  }, t.prototype.set = function (t) {
    return Jt(this.hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook."), this.componentControls.forEach(function (n) {
      return n.apply(t);
    });
  }, t.prototype.stop = function () {
    this.componentControls.forEach(function (t) {
      return t.stop();
    });
  }, t.prototype.mount = function () {
    var t = this;
    this.hasMounted = !0, this.pendingAnimations.forEach(function (n) {
      var e = n.animation,
          r = n.resolve;
      return t.start.apply(t, e).then(r);
    });
  }, t.prototype.unmount = function () {
    this.hasMounted = !1, this.stop();
  }, t;
}(),
    fo = a({
  static: !1
}),
    ho = function ho(t) {
  return "string" == typeof t || Array.isArray(t);
},
    po = function po(t) {
  return t instanceof lo;
},
    mo = function mo(t, n, i, a, s) {
  void 0 === a && (a = !1);
  var u,
      c = s.initial,
      l = s.animate,
      f = s.variants,
      h = s.whileTap,
      p = s.whileHover,
      m = s.layoutId,
      v = e(Ii),
      g = null == v ? void 0 : v.id;
  i.isPresenceRoot = t.presenceId !== g, void 0 !== (null == v ? void 0 : v.initial) && (c = v.initial), !1 !== c || po(l) ? "boolean" != typeof c && (u = c) : u = l;
  var y = r(!1),
      b = f || ho(l) || ho(h) || ho(p) || po(l),
      x = ho(u) ? u : t.initial,
      w = ho(l) ? l : t.animate,
      E = a ? x : null,
      S = b && ho(w) ? w : null,
      C = d(function () {
    return {
      controls: b ? n : t.controls,
      initial: x,
      animate: w,
      visualElement: i,
      hasMounted: y,
      isReducedMotion: t.isReducedMotion,
      presenceId: g
    };
  }, [E, S, t.isReducedMotion, l, m, g]);
  return C.static = a, function (t, n) {
    void 0 === n && (n = !1);
    var e = r(!0);
    (!n || n && e.current) && t(), e.current = !1;
  }(function () {
    var e = u || t.initial;
    e && n.apply(e);
  }, !a), o(function () {
    y.current = !0;
  }, []), C;
},
    vo = function vo(t) {
  var n = t.animate,
      e = t.variants,
      r = t.inherit;
  return (void 0 === r || r) && !!e && (!n || n instanceof lo);
},
    go = function go(t) {
  return t instanceof fr;
};

function yo(t, n, e, r) {
  for (var i in void 0 === r && (r = !1), r && (t.reactStyle = {}), e) {
    var o = e[i],
        a = !1;
    if (go(o)) bo.has(i) || (t.addValue(i, o), a = !0);else if (Dr(i) || zr(i)) {
      if (t.hasValue(i)) {
        if (o !== n[i]) {
          t.getValue(i).set(o);
        }
      } else t.addValue(i, hr(o));

      a = !0;
    } else r && (t.reactStyle[i] = o);
    a && (n[i] = o);
  }
}

var bo = new Set([]),
    xo = function xo() {
  return {};
},
    wo = function wo(t) {
  return oi(t) ? t[t.length - 1] || 0 : t;
},
    Eo = function () {
  function t(t, n) {
    var e = this,
        r = n.makeTargetAnimatable;
    this.props = {}, this.variants = {}, this.baseTarget = {}, this.overrides = [], this.resolvedOverrides = [], this.activeOverrides = new Set(), this.isAnimating = new Set(), this.hasValue = function (t) {
      return !e.visualElement.hasValue(t);
    }, this.visualElement = t, this.makeTargetAnimatable = r, this.visualElement.forEachValue(function (t, n) {
      return e.baseTarget[n] = t.get();
    });
  }

  return t.prototype.setProps = function (t) {
    this.props = t;
  }, t.prototype.setVariants = function (t) {
    t && (this.variants = t);
  }, t.prototype.setDefaultTransition = function (t) {
    t && (this.defaultTransition = t);
  }, t.prototype.setValues = function (t, n) {
    var e = void 0 === n ? {} : n,
        r = e.isActive,
        i = void 0 === r ? new Set() : r,
        o = e.priority,
        a = this.resolveVariant(t),
        s = a.target,
        u = a.transitionEnd;

    for (var c in s = this.transformValues(_Gt(_Gt({}, s), u))) {
      if (i.has(c)) return;

      if (i.add(c), s) {
        var l = wo(s[c]);

        if (this.visualElement.hasValue(c)) {
          var d = this.visualElement.getValue(c);
          d && d.set(l);
        } else this.visualElement.addValue(c, hr(l));

        o || (this.baseTarget[c] = l);
      }
    }
  }, t.prototype.transformValues = function (t) {
    var n = this.props.transformValues;
    return n ? n(t) : t;
  }, t.prototype.checkForNewValues = function (t) {
    var n = Object.keys(t).filter(this.hasValue),
        e = n.length;
    if (e) for (var r = 0; r < e; r++) {
      var i = n[r],
          o = t[i],
          a = null;

      if (Array.isArray(o) && (a = o[0]), null === a) {
        var s = this.visualElement.readNativeValue(i);
        a = void 0 !== s ? s : t[i], Jt(null !== a, 'No initial value for "' + i + '" can be inferred. Ensure an initial value for "' + i + '" is defined on the component.');
      }

      "string" == typeof a && /^\-?\d*\.?\d+$/.test(a) ? a = parseFloat(a) : !kr(a) && Wn.test(o) && (a = Wn.getAnimatableNone(o)), this.visualElement.addValue(i, hr(a)), this.baseTarget[i] = a;
    }
  }, t.prototype.resolveVariant = function (t) {
    if (!t) return {
      target: void 0,
      transition: void 0,
      transitionEnd: void 0
    };
    var n, e;
    "function" == typeof t && (t = t(this.props.custom, (n = this.visualElement, e = {}, n.forEachValue(function (t, n) {
      return e[n] = t.get();
    }), e), function (t) {
      var n = {};
      return t.forEachValue(function (t, e) {
        return n[e] = t.getVelocity();
      }), n;
    }(this.visualElement)));
    var r = t.transition;
    return {
      transition: void 0 === r ? this.defaultTransition : r,
      transitionEnd: t.transitionEnd,
      target: Zt(t, ["transition", "transitionEnd"])
    };
  }, t.prototype.getHighestPriority = function () {
    return this.activeOverrides.size ? Math.max.apply(Math, Array.from(this.activeOverrides)) : 0;
  }, t.prototype.setOverride = function (t, n) {
    this.overrides[n] = t, this.children && this.children.forEach(function (e) {
      return e.setOverride(t, n);
    });
  }, t.prototype.startOverride = function (t) {
    var n = this.overrides[t];
    if (n) return this.start(n, {
      priority: t
    });
  }, t.prototype.clearOverride = function (t) {
    var n = this;

    if (this.children && this.children.forEach(function (n) {
      return n.clearOverride(t);
    }), this.overrides[t]) {
      this.activeOverrides.delete(t);
      var e = this.getHighestPriority();
      if (this.resetIsAnimating(), e) this.overrides[e] && this.startOverride(e);
      var r = this.resolvedOverrides[t];

      if (r) {
        var i = {};

        for (var o in this.baseTarget) {
          void 0 !== r[o] && (i[o] = this.baseTarget[o]);
        }

        this.onStart(), this.animate(i).then(function () {
          return n.onComplete();
        });
      }
    }
  }, t.prototype.apply = function (t) {
    return Array.isArray(t) ? this.applyVariantLabels(t) : "string" == typeof t ? this.applyVariantLabels([t]) : void this.setValues(t);
  }, t.prototype.applyVariantLabels = function (t) {
    var n = this,
        e = new Set();
    $t(t).reverse().forEach(function (r) {
      var i = n.resolveVariant(n.variants[r]),
          o = i.target,
          a = i.transitionEnd;
      a && n.setValues(a, {
        isActive: e
      }), o && n.setValues(o, {
        isActive: e
      }), n.children && n.children.size && n.children.forEach(function (n) {
        return n.applyVariantLabels(t);
      });
    });
  }, t.prototype.start = function (t, n) {
    var e,
        r,
        i = this;
    return void 0 === n && (n = {}), n.priority && this.activeOverrides.add(n.priority), this.resetIsAnimating(n.priority), r = t, e = Array.isArray(r) ? this.animateVariantLabels(t, n) : "string" == typeof t ? this.animateVariant(t, n) : this.animate(t, n), this.onStart(), e.then(function () {
      return i.onComplete();
    });
  }, t.prototype.animate = function (t, n) {
    var e = this,
        r = void 0 === n ? {} : n,
        i = r.delay,
        o = void 0 === i ? 0 : i,
        a = r.priority,
        s = void 0 === a ? 0 : a,
        u = r.transitionOverride,
        c = this.resolveVariant(t),
        l = c.target,
        d = c.transition,
        f = c.transitionEnd;
    if (u && (d = u), !l) return Promise.resolve();
    l = this.transformValues(l), f && (f = this.transformValues(f)), this.checkForNewValues(l);
    var h = this.transformValues(function (t, n, e) {
      var r,
          i,
          o = {};

      for (var a in t) {
        o[a] = null !== (r = So(a, n)) && void 0 !== r ? r : null === (i = e.getValue(a)) || void 0 === i ? void 0 : i.get();
      }

      return o;
    }(l, d, this.visualElement));

    if (this.makeTargetAnimatable) {
      var p = this.makeTargetAnimatable(this.visualElement, l, h, f);
      l = p.target, f = p.transitionEnd;
    }

    s && (this.resolvedOverrides[s] = l), this.checkForNewValues(l);
    var m = [];

    for (var v in l) {
      var g = this.visualElement.getValue(v);

      if (g && l && void 0 !== l[v]) {
        var y = l[v];
        s || (this.baseTarget[v] = wo(y)), this.isAnimating.has(v) || (this.isAnimating.add(v), m.push(xi(v, g, y, _Gt({
          delay: o
        }, d))));
      }
    }

    var b = Promise.all(m);
    return f ? b.then(function () {
      e.setValues(f, {
        priority: s
      });
    }) : b;
  }, t.prototype.animateVariantLabels = function (t, n) {
    var e = this,
        r = $t(t).reverse().map(function (t) {
      return e.animateVariant(t, n);
    });
    return Promise.all(r);
  }, t.prototype.animateVariant = function (t, n) {
    var e = this,
        r = !1,
        i = 0,
        o = 0,
        a = 1,
        s = n && n.priority || 0,
        u = this.variants[t],
        c = u ? function () {
      return e.animate(u, n);
    } : function () {
      return Promise.resolve();
    },
        l = this.children ? function () {
      return e.animateChildren(t, i, o, a, s);
    } : function () {
      return Promise.resolve();
    };

    if (u && this.children) {
      var d = this.resolveVariant(u).transition;
      d && (r = d.when || r, i = d.delayChildren || i, o = d.staggerChildren || o, a = d.staggerDirection || a);
    }

    if (r) {
      var f = "beforeChildren" === r ? [c, l] : [l, c],
          h = f[1];
      return (0, f[0])().then(h);
    }

    return Promise.all([c(), l()]);
  }, t.prototype.animateChildren = function (t, n, e, r, i) {
    if (void 0 === n && (n = 0), void 0 === e && (e = 0), void 0 === r && (r = 1), void 0 === i && (i = 0), !this.children) return Promise.resolve();
    var o = [],
        a = (this.children.size - 1) * e,
        s = 1 === r ? function (t) {
      return t * e;
    } : function (t) {
      return a - t * e;
    };
    return Array.from(this.children).forEach(function (e, r) {
      var a = e.animateVariant(t, {
        priority: i,
        delay: n + s(r)
      });
      o.push(a);
    }), Promise.all(o);
  }, t.prototype.onStart = function () {
    var t = this.props.onAnimationStart;
    t && t();
  }, t.prototype.onComplete = function () {
    var t = this.props.onAnimationComplete;
    t && t();
  }, t.prototype.checkOverrideIsAnimating = function (t) {
    for (var n = this.overrides.length, e = t + 1; e < n; e++) {
      var r = this.resolvedOverrides[e];
      if (r) for (var i in r) {
        this.isAnimating.add(i);
      }
    }
  }, t.prototype.resetIsAnimating = function (t) {
    void 0 === t && (t = 0), this.isAnimating.clear(), t < this.getHighestPriority() && this.checkOverrideIsAnimating(t), this.children && this.children.forEach(function (n) {
      return n.resetIsAnimating(t);
    });
  }, t.prototype.stop = function () {
    this.visualElement.forEachValue(function (t) {
      return t.stop();
    });
  }, t.prototype.addChild = function (t) {
    this.children || (this.children = new Set()), this.children.add(t), this.overrides.forEach(function (n, e) {
      n && t.setOverride(n, e);
    });
  }, t.prototype.removeChild = function (t) {
    this.children && this.children.delete(t);
  }, t.prototype.resetChildren = function () {
    this.children && this.children.clear();
  }, t;
}();

function So(t, n) {
  if (n) return (n[t] || n.default || n).from;
}

var Co,
    To,
    ko = a({
  transformPagePoint: function transformPagePoint(t) {
    return t;
  },
  features: []
});
!function (t) {
  t[t.Entering = 0] = "Entering", t[t.Present = 1] = "Present", t[t.Exiting = 2] = "Exiting";
}(Co || (Co = {})), function (t) {
  t[t.Hide = 0] = "Hide", t[t.Show = 1] = "Show";
}(To || (To = {}));

var Lo = {
  measureLayout: function measureLayout(t) {
    return t.measureLayout();
  },
  layoutReady: function layoutReady(t) {
    return t.layoutReady();
  }
},
    Po = function Po(t, n) {
  return t.depth - n.depth;
};

function Ao() {
  var t = new Set();
  return {
    add: function add(n) {
      return t.add(n);
    },
    flush: function flush(n) {
      var e = void 0 === n ? Lo : n,
          r = e.measureLayout,
          i = e.layoutReady,
          o = Array.from(t).sort(Po);
      o.forEach(function (t) {
        return t.resetTransform();
      }), o.forEach(r), o.forEach(i), o.forEach(function (t) {
        t.isPresent && (t.presence = Co.Present);
      }), t.clear();
    }
  };
}

function Oo(t) {
  return !!t.forceUpdate;
}

var Bo = a(Ao());

function Ro(t) {
  return o(function () {
    return function () {
      return t();
    };
  }, []);
}

function Do(t, n) {
  var r = n.defaultFeatures,
      i = n.useVisualElement,
      a = n.render,
      l = n.animationControlsConfig;
  return c(function (n, c) {
    var d = e(fo),
        f = vo(n),
        h = d.static || n.static || !1,
        p = i(t, n, d.visualElement, h, c);
    !function (t, n) {
      var e = Ci(xo);

      for (var r in e) {
        var i = Dr(r) || zr(r),
            o = n[r],
            a = n.style && n.style[r],
            s = o && go(n[r]),
            u = a && go(n.style[r]);
        (i && !o && !a || !i && !s && !u) && (t.removeValue(r), delete e[r]);
      }

      yo(t, e, n), n.style && yo(t, e, n.style, !0), n.transformValues && (t.reactStyle = n.transformValues(t.reactStyle));
    }(p, n);

    var m = function (t, n, r) {
      var i = vo(n),
          a = n.variants,
          s = n.transition,
          u = e(fo).controls,
          c = e(Ii),
          l = Ci(function () {
        return new Eo(t, r);
      });
      return c && !c.isPresent || (l.resetChildren(), l.setProps(n), l.setVariants(a), l.setDefaultTransition(s)), o(function () {
        i && u && u.addChild(l);
      }), o(function () {
        return function () {
          n.onAnimationComplete;
          var t = Zt(n, ["onAnimationComplete"]);
          l.setProps(t), u && u.removeChild(l);
        };
      }, []), l;
    }(p, n, l),
        v = mo(d, m, p, h, n),
        g = function (t, n, r, i, o, a, u, c) {
      var l = e(ko);
      if (n || "undefined" == typeof window) return null;

      for (var d = $t(t, l.features), f = d.length, h = [], p = 0; p < f; p++) {
        var m = d[p],
            v = m.shouldRender,
            g = m.key,
            y = m.getComponent;

        if (v(o, u)) {
          var b = y(o);
          b && h.push(s(b, _Gt({
            key: g
          }, o, {
            localContext: a,
            parentContext: u,
            visualElement: r,
            controls: i,
            inherit: c
          })));
        }
      }

      return h;
    }(r, h, p, m, n, v, d, f),
        y = a(t, n, p);

    return function (t) {
      var n = e(Bo);
      Ro(function () {
        Oo(n) && n.remove(t);
      });
    }(p), s(u, null, s(fo.Provider, {
      value: v
    }, y), g);
  });
}

function No(t) {
  var n = null;
  return function () {
    return null === n && (n = t, function () {
      n = null;
    });
  };
}

var zo = No("dragHorizontal"),
    Mo = No("dragVertical");

function Io(t) {
  var n = !1;
  if ("y" === t) n = Mo();else if ("x" === t) n = zo();else {
    var e = zo(),
        r = Mo();
    e && r ? n = function n() {
      e(), r();
    } : (e && e(), r && r());
  }
  return n;
}

var Vo = !1;
"undefined" != typeof window && document.addEventListener("touchmove", function (t) {
  Vo && t.preventDefault();
}, {
  passive: !1
});

var _o = function _o() {
  return Vo = !1;
};

function Fo(t, n, e, r) {
  if (e) return t.addEventListener(n, e, r), function () {
    return t.removeEventListener(n, e, r);
  };
}

function jo(t) {
  return "undefined" != typeof PointerEvent && t instanceof PointerEvent ? !("mouse" !== t.pointerType) : t instanceof MouseEvent;
}

function Ho(t) {
  return !!t.touches;
}

var Uo = {
  pageX: 0,
  pageY: 0
};

function Wo(t, n) {
  void 0 === n && (n = "page");
  var e = t.touches[0] || t.changedTouches[0] || Uo;
  return {
    x: e[n + "X"],
    y: e[n + "Y"]
  };
}

function qo(t, n) {
  return void 0 === n && (n = "page"), {
    x: t[n + "X"],
    y: t[n + "Y"]
  };
}

function Yo(t, n) {
  return void 0 === n && (n = "page"), {
    point: Ho(t) ? Wo(t, n) : qo(t, n)
  };
}

function Xo(t) {
  return Yo(t, "client");
}

var Go,
    Zo = function Zo(t, n) {
  if (void 0 === n && (n = !1), t) {
    var e = function e(n) {
      return t(n, Yo(n));
    };

    return n ? function (t) {
      if (t) return function (n) {
        var e = n instanceof MouseEvent;
        (!e || e && 0 === n.button) && t(n);
      };
    }(e) : e;
  }
},
    $o = "undefined" != typeof window,
    Ko = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
},
    Jo = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};

function Qo(t) {
  return $o && null === window.onpointerdown ? t : $o && null === window.ontouchstart ? Jo[t] : $o && null === window.onmousedown ? Ko[t] : t;
}

function ta(t, n, e, r) {
  return Fo(t, Qo(n), Zo(e, "pointerdown" === n), r);
}

function na(t, n, e, r) {
  return function (t, n, e, r) {
    o(function () {
      var i = t.current;
      if (e && i) return Fo(i, n, e, r);
    }, [t, n, e, r]);
  }(t, Qo(n), Zo(e, "pointerdown" === n), r);
}

!function (t) {
  t.subtract = function (t, n) {
    return {
      x: t.x - n.x,
      y: t.y - n.y
    };
  }, t.relativeTo = function (t) {
    var n;
    return function (e) {
      var r = e.x,
          i = e.y,
          o = void 0 !== n ? n : n = "string" == typeof t ? document.getElementById(t) : t;

      if (o) {
        var a = o.getBoundingClientRect();
        return {
          x: r - a.left - window.scrollX,
          y: i - a.top - window.scrollY
        };
      }
    };
  };
}(Go || (Go = {}));

var ea = function () {
  function t(t, n, e) {
    var r = this,
        i = (void 0 === e ? {} : e).transformPagePoint;

    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function () {
      if (r.lastMoveEvent && r.lastMoveEventInfo) {
        var t = ia(r.lastMoveEventInfo, r.history),
            n = null !== r.startEvent,
            e = Te(t.offset, {
          x: 0,
          y: 0
        }) >= 3;

        if (n || e) {
          var i = t.point,
              o = gn().timestamp;
          r.history.push(_Gt(_Gt({}, i), {
            timestamp: o
          }));
          var a = r.handlers,
              s = a.onStart,
              u = a.onMove;
          n || (s && s(r.lastMoveEvent, t), r.startEvent = r.lastMoveEvent), u && u(r.lastMoveEvent, t);
        }
      }
    }, !(Ho(t) && t.touches.length > 1)) {
      this.handlers = n, this.transformPagePoint = i;
      var o = ra(Yo(t), this.transformPagePoint),
          a = o.point,
          s = gn().timestamp;
      this.history = [_Gt(_Gt({}, a), {
        timestamp: s
      })];
      var u = n.onSessionStart;
      u && u(t, ia(o, this.history));
      var c = ta(window, "pointermove", function (t, n) {
        return r.handlePointerMove(t, n);
      }),
          l = ta(window, "pointerup", function (t, n) {
        return r.handlePointerUp(t, n);
      });

      this.removeListeners = function () {
        c && c(), l && l();
      };
    }
  }

  return t.prototype.handlePointerMove = function (t, n) {
    this.lastMoveEvent = t, this.lastMoveEventInfo = ra(n, this.transformPagePoint), jo(t) && 0 === t.buttons ? this.handlePointerUp(t, n) : fn.update(this.updatePoint, !0);
  }, t.prototype.handlePointerUp = function (t, n) {
    this.end();
    var e = this.handlers.onEnd;

    if (e) {
      var r = ia(ra(n, this.transformPagePoint), this.history);
      e && e(t, r);
    }
  }, t.prototype.updateHandlers = function (t) {
    this.handlers = t;
  }, t.prototype.end = function () {
    this.removeListeners && this.removeListeners(), hn.update(this.updatePoint), _o();
  }, t;
}();

function ra(t, n) {
  return n ? {
    point: n(t.point)
  } : t;
}

function ia(t, n) {
  var e = t.point;
  return {
    point: e,
    delta: Go.subtract(e, aa(n)),
    offset: Go.subtract(e, oa(n)),
    velocity: sa(n, .1)
  };
}

function oa(t) {
  return t[0];
}

function aa(t) {
  return t[t.length - 1];
}

function sa(t, n) {
  if (t.length < 2) return {
    x: 0,
    y: 0
  };

  for (var e = t.length - 1, r = null, i = aa(t); e >= 0 && (r = t[e], !(i.timestamp - r.timestamp > mi(n)));) {
    e--;
  }

  if (!r) return {
    x: 0,
    y: 0
  };
  var o = (i.timestamp - r.timestamp) / 1e3;
  if (0 === o) return {
    x: 0,
    y: 0
  };
  var a = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}

function ua(t, n, e, r, i) {
  var o = t - n * e;
  return r ? function (t, n, e) {
    var r = n.min,
        i = n.max;
    return void 0 !== r && t < r ? t = e ? Le(r, t, e) : Math.max(t, r) : void 0 !== i && t > i && (t = e ? Le(i, t, e) : Math.min(t, i)), t;
  }(o, r, i) : o;
}

function ca(t, n, e) {
  var r = {},
      i = t.max - t.min;
  return void 0 !== n && (r.min = t.min + n), void 0 !== e && (r.max = Math.max(t.min + e - i, t.min)), r;
}

function la(t, n) {
  var e,
      r = n.min - t.min,
      i = n.max - t.max;
  return n.max - n.min < t.max - t.min && (r = (e = [i, r])[0], i = e[1]), {
    min: t.min + r,
    max: t.min + i
  };
}

var da,
    fa = new WeakMap(),
    ha = function () {
  function t(t) {
    var n = t.visualElement;
    this.isDragging = !1, this.currentDirection = null, this.constraints = !1, this.props = {}, this.cursorProgress = {
      x: .5,
      y: .5
    }, this.openGlobalLock = null, this.panSession = null, this.visualElement = n, this.visualElement.enableLayoutProjection(), fa.set(n, this);
  }

  return t.prototype.start = function (t, n) {
    var e = this,
        r = void 0 === n ? {} : n,
        i = r.snapToCursor,
        o = void 0 !== i && i,
        a = r.cursorProgress;
    o && this.snapToCursor(t);
    var s = this.props.transformPagePoint;
    this.panSession = new ea(t, {
      onSessionStart: function onSessionStart() {
        Vo = !0, e.stopMotion();
      },
      onStart: function onStart(t, n) {
        var r,
            i,
            o = e.props,
            s = o.drag,
            u = o.dragPropagation;

        if (!s || u || (e.openGlobalLock && e.openGlobalLock(), e.openGlobalLock = Io(s), e.openGlobalLock)) {
          e.prepareBoundingBox(), e.visualElement.lockTargetBox(), e.resolveDragConstraints();
          var c = Xo(t).point;
          ii(function (t) {
            var n = e.visualElement.targetBox[t],
                r = n.min,
                i = n.max;
            e.cursorProgress[t] = a ? a[t] : ke(r, i, c[t]);
          }), e.isDragging = !0, e.currentDirection = null, null === (i = (r = e.props).onDragStart) || void 0 === i || i.call(r, t, n);
        }
      },
      onMove: function onMove(t, n) {
        var r,
            i,
            o,
            a,
            s = e.props,
            u = s.dragPropagation,
            c = s.dragDirectionLock;

        if (u || e.openGlobalLock) {
          var l = n.offset;
          if (c && null === e.currentDirection) return e.currentDirection = function (t, n) {
            void 0 === n && (n = 10);
            var e = null;
            Math.abs(t.y) > n ? e = "y" : Math.abs(t.x) > n && (e = "x");
            return e;
          }(l), void (null !== e.currentDirection && (null === (i = (r = e.props).onDirectionLock) || void 0 === i || i.call(r, e.currentDirection)));
          e.updateAxis("x", t), e.updateAxis("y", t), null === (a = (o = e.props).onDrag) || void 0 === a || a.call(o, t, n), da = t;
        }
      },
      onEnd: function onEnd(t, n) {
        return e.stop(t, n);
      }
    }, {
      transformPagePoint: s
    });
  }, t.prototype.prepareBoundingBox = function () {
    var t = this.visualElement.getInstance(),
        n = t.style.transform;
    this.visualElement.resetTransform(), this.visualElement.measureLayout(), t.style.transform = n, this.visualElement.refreshTargetBox();
  }, t.prototype.resolveDragConstraints = function () {
    var t = this.props.dragConstraints;
    this.constraints = !!t && (dr(t) ? this.resolveRefConstraints(this.visualElement.box, t) : function (t, n) {
      var e = n.top,
          r = n.left,
          i = n.bottom,
          o = n.right;
      return {
        x: ca(t.x, r, o),
        y: ca(t.y, e, i)
      };
    }(this.visualElement.box, t));
  }, t.prototype.resolveRefConstraints = function (t, n) {
    var e = this.props,
        r = e.onMeasureDragConstraints,
        i = e.transformPagePoint,
        o = n.current;
    Jt(null !== o, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop."), this.constraintsBox = wi(o, i);

    var a = function (t, n) {
      return {
        x: la(t.x, n.x),
        y: la(t.y, n.y)
      };
    }(t, this.constraintsBox);

    if (r) {
      var s = r(function (t) {
        var n = t.x,
            e = t.y;
        return {
          top: e.min,
          bottom: e.max,
          left: n.min,
          right: n.max
        };
      }(a));
      s && (a = vr(s));
    }

    return a;
  }, t.prototype.cancelDrag = function () {
    _o(), this.isDragging = !1, this.panSession && this.panSession.end(), this.panSession = null, !this.props.dragPropagation && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null);
  }, t.prototype.stop = function (t, n) {
    var e;
    this.visualElement.unlockTargetBox(), null === (e = this.panSession) || void 0 === e || e.end(), this.panSession = null;
    var r = this.isDragging;

    if (this.cancelDrag(), r) {
      var i = this.props,
          o = i.dragMomentum,
          a = i.dragElastic,
          s = i.onDragEnd;

      if (o || a) {
        var u = n.velocity;
        this.animateDragEnd(u);
      }

      null == s || s(t, n);
    }
  }, t.prototype.snapToCursor = function (t) {
    this.prepareBoundingBox(), this.cursorProgress.x = .5, this.cursorProgress.y = .5, this.updateAxis("x", t), this.updateAxis("y", t);
  }, t.prototype.updateAxis = function (t, n) {
    var e,
        r = this.props,
        i = r.drag,
        o = r.dragElastic;

    if (pa(t, i, this.currentDirection)) {
      var a = this.visualElement.box[t],
          s = a.max - a.min,
          u = this.cursorProgress[t],
          c = ua(Xo(n).point[t], s, u, null === (e = this.constraints) || void 0 === e ? void 0 : e[t], o);
      this.visualElement.setAxisTarget(t, c, c + s);
    }
  }, t.prototype.updateProps = function (t) {
    var n = t.drag,
        e = void 0 !== n && n,
        r = t.dragDirectionLock,
        i = void 0 !== r && r,
        o = t.dragPropagation,
        a = void 0 !== o && o,
        s = t.dragConstraints,
        u = void 0 !== s && s,
        c = t.dragElastic,
        l = void 0 === c ? .35 : c,
        d = t.dragMomentum,
        f = void 0 === d || d,
        h = Zt(t, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
    this.props = _Gt({
      drag: e,
      dragDirectionLock: i,
      dragPropagation: a,
      dragConstraints: u,
      dragElastic: l,
      dragMomentum: f
    }, h);
  }, t.prototype.animateDragEnd = function (t) {
    var n = this,
        e = this.props,
        r = e.drag,
        i = e.dragMomentum,
        o = e.dragElastic,
        a = e.dragTransition,
        s = ii(function (e) {
      if (pa(e, r, n.currentDirection)) {
        var s = n.constraints ? n.constraints[e] : {},
            u = o ? 200 : 1e6,
            c = o ? 40 : 1e7,
            l = _Gt(_Gt({
          type: "inertia",
          velocity: i ? t[e] : 0,
          bounceStiffness: u,
          bounceDamping: c,
          timeConstant: 750,
          restDelta: 1,
          restSpeed: 10
        }, a), s);

        return n.visualElement.startLayoutAxisAnimation(e, l);
      }
    });
    return Promise.all(s).then(function () {
      var t, e;
      null === (e = (t = n.props).onDragTransitionEnd) || void 0 === e || e.call(t);
    });
  }, t.prototype.stopMotion = function () {
    this.visualElement.stopLayoutAnimation();
  }, t.prototype.scalePoint = function () {
    var t = this,
        n = this.props,
        e = n.drag,
        r = n.dragConstraints;

    if (dr(r) && this.constraintsBox) {
      this.stopMotion();
      var i = {
        x: 0,
        y: 0
      };
      ii(function (n) {
        i[n] = ni(t.visualElement.targetBox[n], t.constraintsBox[n]);
      }), this.prepareBoundingBox(), this.resolveDragConstraints(), ii(function (n) {
        if (pa(n, e, null)) {
          var r = function (t, n, e) {
            var r = t.max - t.min,
                i = Le(n.min, n.max - r, e);
            return {
              min: i,
              max: i + r
            };
          }(t.visualElement.targetBox[n], t.constraintsBox[n], i[n]),
              o = r.min,
              a = r.max;

          t.visualElement.setAxisTarget(n, o, a);
        }
      });
    }
  }, t.prototype.mount = function (t) {
    var n = this,
        e = ta(t.getInstance(), "pointerdown", function (t) {
      var e = n.props,
          r = e.drag,
          i = e.dragListener;
      r && (void 0 === i || i) && n.start(t);
    }),
        r = Fo(window, "resize", function () {
      n.scalePoint();
    }),
        i = t.onLayoutUpdate(function () {
      n.isDragging && n.resolveDragConstraints();
    }),
        o = t.prevSnapshot;
    return (null == o ? void 0 : o.isDragging) && this.start(da, {
      cursorProgress: o.cursorProgress
    }), function () {
      null == e || e(), null == r || r(), null == i || i(), n.cancelDrag();
    };
  }, t;
}();

function pa(t, n, e) {
  return !(!0 !== n && n !== t || null !== e && e !== t);
}

var ma = function ma(t) {
  return function (n) {
    return t(n), null;
  };
},
    va = ma(function (t) {
  var n = t.visualElement;
  return function (t, n) {
    var r = t.dragControls,
        i = e(ko).transformPagePoint,
        a = Ci(function () {
      return new ha({
        visualElement: n
      });
    });
    a.updateProps(_Gt(_Gt({}, t), {
      transformPagePoint: i
    })), o(function () {
      return r && r.subscribe(a);
    }, [a]), o(function () {
      return a.mount(n);
    }, []);
  }(Zt(t, ["visualElement"]), n);
}),
    ga = {
  key: "drag",
  shouldRender: function shouldRender(t) {
    return !!t.drag;
  },
  getComponent: function getComponent() {
    return va;
  }
};

var ya = function ya(t, n) {
  return !!n && (t === n || ya(t, n.parentElement));
},
    ba = ["whileHover", "whileTap", "whileDrag"],
    xa = function xa(t) {
  return ba.indexOf(t) + 1;
},
    wa = xa("whileTap");

var Ea = xa("whileHover"),
    Sa = function Sa(t) {
  return function (n, e) {
    jo(n) && t(n, e);
  };
};

function Ca(t, n) {
  !function (t, n) {
    var i = t.onPan,
        a = t.onPanStart,
        s = t.onPanEnd,
        u = t.onPanSessionStart,
        c = i || a || s || u,
        l = r(null),
        d = e(ko).transformPagePoint,
        f = {
      onSessionStart: u,
      onStart: a,
      onMove: i,
      onEnd: function onEnd(t, n) {
        l.current = null, s && s(t, n);
      }
    };
    o(function () {
      null !== l.current && l.current.updateHandlers(f);
    }), na(n, "pointerdown", c && function (t) {
      l.current = new ea(t, f, {
        transformPagePoint: d
      });
    }), Ro(function () {
      return l.current && l.current.end();
    });
  }(t, n), function (t, n) {
    var e = t.onTap,
        i = t.onTapStart,
        o = t.onTapCancel,
        a = t.whileTap,
        s = t.controls,
        u = e || i || o || a,
        c = r(!1),
        l = r(null);

    function d() {
      l.current && l.current(), l.current = null;
    }

    a && s && s.setOverride(a, wa);
    var f = r(null);
    f.current = function (t, r) {
      var i = n.current;

      if (d(), c.current && i) {
        c.current = !1, s && a && s.clearOverride(wa);
        var u = Io(!0);
        u && (u(), ya(i, t.target) ? e && e(t, r) : o && o(t, r));
      }
    }, na(n, "pointerdown", u ? function (t, e) {
      d(), l.current = ta(window, "pointerup", function (t, n) {
        return f.current(t, n);
      }), n.current && !c.current && (c.current = !0, i && i(t, e), s && a && s.startOverride(wa));
    } : void 0), Ro(d);
  }(t, n), function (t, n) {
    var e = t.whileHover,
        r = t.onHoverStart,
        i = t.onHoverEnd,
        o = t.controls;
    e && o && o.setOverride(e, Ea), na(n, "pointerenter", Sa(function (t, n) {
      r && r(t, n), e && o && o.startOverride(Ea);
    })), na(n, "pointerleave", Sa(function (t, n) {
      i && i(t, n), e && o && o.clearOverride(Ea);
    }));
  }(t, n);
}

var Ta,
    ka = ["onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "whileTap", "whileHover", "onHoverStart", "onHoverEnd"],
    La = ma(function (t) {
  var n = t.visualElement;
  Ca(Zt(t, ["visualElement"]), n);
}),
    Pa = {
  key: "gestures",
  shouldRender: function shouldRender(t) {
    return ka.some(function (n) {
      return t.hasOwnProperty(n);
    });
  },
  getComponent: function getComponent() {
    return La;
  }
},
    Aa = ma(function (t) {
  var n = t.animate,
      i = t.controls,
      a = t.exit,
      s = Vi(),
      u = s[0],
      c = s[1],
      l = e(Ii),
      d = r(!1),
      f = void 0 !== (null == l ? void 0 : l.custom) ? l.custom : t.custom;
  o(function () {
    u ? !d.current || !n || "boolean" == typeof n || n instanceof lo || i.start(n) : (!d.current && a && (i.setProps(_Gt(_Gt({}, t), {
      custom: f
    })), i.start(a).then(c)), d.current = !0), u && (d.current = !1);
  }, [n, i, f, a, u, c, t]);
}),
    Oa = {
  key: "exit",
  shouldRender: function shouldRender(t) {
    return !!t.exit && !vo(t);
  },
  getComponent: function getComponent() {
    return Aa;
  }
};
!function (t) {
  t.Target = "Target", t.VariantLabel = "VariantLabel", t.AnimationSubscription = "AnimationSubscription";
}(Ta || (Ta = {}));

function Ba(t, n) {
  void 0 === n && (n = !1);
  t.transition;
  var e = t.transitionEnd,
      r = Zt(t, ["transition", "transitionEnd"]);
  return n ? _Gt(_Gt({}, r), e) : r;
}

var Ra,
    Da,
    Na = function Na(t) {
  var n,
      e = t instanceof fr ? t.get() : t;
  return Array.from(new Set((n = e) ? Array.isArray(n) ? n : [n] : []));
};

var za = ((Ra = {})[Ta.Target] = ma(function (t) {
  return function (t, n, e, i) {
    var a = r(!0),
        s = r(null);
    s.current || (s.current = Ba(t, !0)), o(function () {
      var r,
          o,
          u = {},
          c = Ba(t),
          l = Ba(t, !0);

      for (var d in c) {
        var f = a.current && (!e.hasValue(d) || e.getValue(d).get() !== l[d]),
            h = null !== l[d],
            p = (r = s.current[d], void 0 !== (o = l[d]) && (Array.isArray(r) && Array.isArray(o) ? !function (t, n) {
          if (null === n) return !1;
          var e = n.length;
          if (e !== t.length) return !1;

          for (var r = 0; r < e; r++) {
            if (n[r] !== t[r]) return !1;
          }

          return !0;
        }(o, r) : r !== o));
        h && (p || f) && (u[d] = c[d]);
      }

      a.current = !1, s.current = _Gt(_Gt({}, s.current), l), Object.keys(u).length && n.start(_Gt(_Gt({}, u), {
        transition: t.transition || i,
        transitionEnd: t.transitionEnd
      }));
    }, [t]);
  }(t.animate, t.controls, t.visualElement, t.transition);
}), Ra[Ta.VariantLabel] = ma(function (t) {
  var n = t.animate,
      i = t.inherit,
      a = void 0 === i || i,
      s = t.controls;
  return function (t, n, i, a) {
    var s = Na(n),
        u = e(fo),
        c = u.hasMounted && u.hasMounted.current,
        l = r(!1);
    o(function () {
      var n,
          e,
          r = !1;
      i ? (r = !!c, s = Na(u.animate)) : r = l.current || (n = Na(t), e = s, n.join(",") !== e.join(",")), r && a.start(s), l.current = !0;
    }, [s.join(",")]);
  }(t.initial, n, a, s);
}), Ra[Ta.AnimationSubscription] = ma(function (t) {
  return function (t, n) {
    var e = d(function () {
      return t.subscribe(n);
    }, [t]);
    o(function () {
      return function () {
        e && e();
      };
    }, [e]);
  }(t.animate, t.controls);
}), Ra),
    Ma = function Ma(t) {
  return t.animate instanceof lo;
},
    Ia = ["initial", "animate", "whileTap", "whileHover"],
    Va = ((Da = {})[Ta.Target] = function (t) {
  return !(void 0 === t.animate || (n = t.animate, Array.isArray(n) || "string" == typeof n) || Ma(t));
  var n;
}, Da[Ta.VariantLabel] = function (t) {
  return void 0 !== t.variants || Ia.some(function (n) {
    return "string" == typeof t[n];
  });
}, Da[Ta.AnimationSubscription] = Ma, Da),
    _a = {
  key: "animation",
  shouldRender: function shouldRender() {
    return !0;
  },
  getComponent: function getComponent(t) {
    var n = void 0;

    for (var e in Ta) {
      Va[e](t) && (n = e);
    }

    return n ? za[n] : void 0;
  }
};

var Fa = function (t) {
  function n() {
    var n = null !== t && t.apply(this, arguments) || this;
    return n.frameTarget = {
      x: {
        min: 0,
        max: 0
      },
      y: {
        min: 0,
        max: 0
      }
    }, n.stopAxisAnimation = {
      x: void 0,
      y: void 0
    }, n.animate = function (t, e, r) {
      void 0 === r && (r = {});
      var i = r.originBox,
          o = r.targetBox,
          a = r.visibilityAction,
          s = Zt(r, ["originBox", "targetBox", "visibilityAction"]),
          u = n.props,
          c = u.visualElement,
          l = u.layout,
          d = Ha(e = i || e, t = o || t),
          f = ii(function (r) {
        if ("position" === l) {
          var i = t[r].max - t[r].min;
          e[r].max = e[r].min + i;
        }

        if (!c.isTargetBoxLocked) return void 0 === a ? d ? n.animateAxis(r, t[r], e[r], s) : c.setAxisTarget(r, t[r].min, t[r].max) : void (a === To.Hide ? c.hide() : c.show());
      });
      return c.render(), Promise.all(f).then(function () {
        var t, e;
        null === (e = (t = n.props).onLayoutAnimationComplete) || void 0 === e || e.call(t), c.isPresent ? c.presence = Co.Present : n.safeToRemove();
      });
    }, n;
  }

  return Xt(n, t), n.prototype.componentDidMount = function () {
    var t = this.props.visualElement;
    t.enableLayoutProjection(), this.unsubLayoutReady = t.onLayoutUpdate(this.animate);
  }, n.prototype.componentWillUnmount = function () {
    var t = this;
    this.unsubLayoutReady(), ii(function (n) {
      var e, r;
      return null === (r = (e = t.stopAxisAnimation)[n]) || void 0 === r ? void 0 : r.call(e);
    });
  }, n.prototype.animateAxis = function (t, n, e, r) {
    var i,
        o,
        a = void 0 === r ? {} : r,
        s = a.transition,
        u = a.crossfadeOpacity;
    null === (o = (i = this.stopAxisAnimation)[t]) || void 0 === o || o.call(i);
    var c = this.props.visualElement,
        l = this.frameTarget[t],
        d = c.axisProgress[t];
    d.clearListeners(), d.set(0), d.set(0);

    var f = u && this.createCrossfadeAnimation(u),
        h = function h() {
      var r = d.get() / 1e3;
      !function (t, n, e, r) {
        t.min = Le(n.min, e.min, r), t.max = Le(n.max, e.max, r);
      }(l, e, n, r), c.setAxisTarget(t, l.min, l.max), null == f || f(r);
    };

    h();
    var p = xi("x" === t ? "layoutX" : "layoutY", d, 1e3, s || this.props.transition || Wa),
        m = d.onChange(h);
    return this.stopAxisAnimation[t] = function () {
      d.stop(), m();
    }, p;
  }, n.prototype.createCrossfadeAnimation = function (t) {
    var n = this.props.visualElement.getValue("opacity", 0);
    return function (e) {
      n.set(Ya(Le(0, 1, e))), t.set(Xa(Le(1, 0, e)));
    };
  }, n.prototype.safeToRemove = function () {
    var t, n;
    null === (n = (t = this.props).safeToRemove) || void 0 === n || n.call(t);
  }, n.prototype.render = function () {
    return null;
  }, n;
}(l);

function ja(t) {
  var n = Vi()[1];
  return s(Fa, _Gt({}, t, {
    safeToRemove: n
  }));
}

function Ha(t, n) {
  return Ua(t.x, n.x) || Ua(t.y, n.y);
}

function Ua(t, n) {
  return t.min !== n.min || t.max !== n.max;
}

var Wa = {
  duration: .45,
  ease: [.4, 0, .1, 1]
};

function qa(t, n, e) {
  return function (r) {
    return r < t ? 0 : r > n ? 1 : e(ke(t, n, r));
  };
}

var Ya = qa(0, .5, re),
    Xa = qa(.5, .95, Jn),
    Ga = {
  key: "animate-layout",
  shouldRender: function shouldRender(t) {
    return !!t.layout || !!t.layoutId;
  },
  getComponent: function getComponent() {
    return ja;
  }
},
    Za = function (t) {
  function n(n) {
    var e = t.call(this, n) || this,
        r = n.syncLayout;
    return Oo(r) || (e.componentDidUpdate = function () {
      return r.flush();
    }), e;
  }

  return Xt(n, t), n.prototype.componentDidMount = function () {
    var t = this.props,
        n = t.syncLayout,
        e = t.visualElement;
    Oo(n) && n.register(e);
  }, n.prototype.getSnapshotBeforeUpdate = function () {
    var t = this.props,
        n = t.syncLayout,
        e = t.visualElement;
    return Oo(n) ? n.syncUpdate() : (e.snapshotBoundingBox(), n.add(e)), null;
  }, n.prototype.componentDidUpdate = function () {}, n.prototype.render = function () {
    return null;
  }, n;
}(t.Component);

function $a(n) {
  var r = e(Bo);
  return t.createElement(Za, _Gt({}, n, {
    syncLayout: r
  }));
}

function Ka(t) {
  var n = {
    defaultFeatures: t,
    useVisualElement: Hi,
    render: Xi,
    animationControlsConfig: {
      makeTargetAnimatable: co
    }
  };
  var e = new Map();
  return new Proxy({
    custom: function custom(t) {
      return Do(t, n);
    }
  }, {
    get: function get(t, r) {
      return "custom" === r ? t.custom : (e.has(r) || e.set(r, Do(r, n)), e.get(r));
    }
  });
}

var Ja = Ka([{
  key: "measure-layout",
  shouldRender: function shouldRender(t) {
    return !!t.drag || !!t.layout || !!t.layoutId;
  },
  getComponent: function getComponent() {
    return $a;
  }
}, _a, ga, Pa, Oa, Ga]);
var Qa = 0;

function ts() {
  var t = Qa;
  return Qa++, t;
}

var ns = function ns(t) {
  var n = t.children,
      e = t.initial,
      r = t.isPresent,
      i = t.onExitComplete,
      o = t.custom,
      a = Ci(es),
      u = {
    id: Ci(ts),
    initial: e,
    isPresent: r,
    custom: o,
    onExitComplete: function onExitComplete(t) {
      a.set(t, !0);
      var n = !0;
      a.forEach(function (t) {
        t || (n = !1);
      }), n && (null == i || i());
    },
    register: function register(t) {
      return a.set(t, !1), function () {
        return a.delete(t);
      };
    }
  };
  return d(function () {
    a.forEach(function (t, n) {
      return a.set(n, !1);
    });
  }, [r]), s(Ii.Provider, {
    value: u
  }, n);
};

function es() {
  return new Map();
}

function rs(t) {
  return t.key || "";
}

var is = function is(t) {
  var n = t.children,
      o = t.custom,
      a = t.initial,
      c = void 0 === a || a,
      l = t.onExitComplete,
      d = t.exitBeforeEnter,
      v = function () {
    var t = i(0),
        n = t[0],
        e = t[1];
    return f(function () {
      return e(n + 1);
    }, [n]);
  }(),
      g = e(Bo);

  Oo(g) && (v = g.forceUpdate);

  var y = r(!0),
      b = function (t) {
    var n = [];
    return p.forEach(t, function (t) {
      m(t) && n.push(t);
    }), n;
  }(n),
      x = r(b),
      w = r(new Map()).current,
      E = r(new Set()).current;

  if (function (t, n) {
    var e = "production" !== process.env.NODE_ENV ? new Set() : null;
    t.forEach(function (t) {
      var r = rs(t);
      "production" !== process.env.NODE_ENV && e && (e.has(r) && console.warn('Children of AnimatePresence require unique keys. "' + r + '" is a duplicate.'), e.add(r)), n.set(r, t);
    });
  }(b, w), y.current) return y.current = !1, s(u, null, b.map(function (t) {
    return s(ns, {
      key: rs(t),
      isPresent: !0,
      initial: !!c && void 0
    }, t);
  }));

  for (var S = $t(b), C = x.current.map(rs), T = b.map(rs), k = C.length, L = 0; L < k; L++) {
    var P = C[L];
    -1 === T.indexOf(P) ? E.add(P) : E.delete(P);
  }

  return d && E.size && (S = []), E.forEach(function (t) {
    if (-1 === T.indexOf(t)) {
      var n = w.get(t);

      if (n) {
        var e = C.indexOf(t);
        S.splice(e, 0, s(ns, {
          key: rs(n),
          isPresent: !1,
          onExitComplete: function onExitComplete() {
            w.delete(t), E.delete(t);
            var n = x.current.findIndex(function (n) {
              return n.key === t;
            });
            x.current.splice(n, 1), E.size || (x.current = b, v(), l && l());
          },
          custom: o
        }, n));
      }
    }
  }), S = S.map(function (t) {
    var n = t.key;
    return E.has(n) ? t : s(ns, {
      key: rs(t),
      isPresent: !0
    }, t);
  }), x.current = S, "production" !== process.env.NODE_ENV && d && S.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), s(u, null, E.size ? S : S.map(function (t) {
    return h(t);
  }));
};

function os(t, n) {
  return n && t !== n.lead ? {
    visibilityAction: To.Hide
  } : n && t.presence !== Co.Entering && t === n.lead && n.lead !== n.prevLead ? {
    visibilityAction: To.Show
  } : (t.presence === Co.Entering ? e = null == n ? void 0 : n.getFollowOrigin() : t.presence === Co.Exiting && (r = null == n ? void 0 : n.getFollowTarget()), {
    originBox: e,
    targetBox: r
  });
  var e, r;
}

function as(t, n) {
  var e,
      r,
      i,
      o = {},
      a = n && n.lead,
      s = null == a ? void 0 : a.presence;
  return n && t === a ? t.presence === Co.Entering ? o.originBox = n.getFollowOrigin() : t.presence === Co.Exiting && (o.targetBox = n.getFollowTarget()) : n && t === n.follow && (o.transition = n.getLeadTransition(), s === Co.Entering ? o.targetBox = n.getLeadTarget() : s === Co.Exiting && (o.originBox = n.getLeadOrigin())), (null === (e = null == n ? void 0 : n.follow) || void 0 === e ? void 0 : e.isPresenceRoot) || (null == a ? void 0 : a.isPresenceRoot) ? (n && t !== a ? n && t === n.follow ? a && s !== Co.Entering && s === Co.Exiting && (o.crossfadeOpacity = null === (i = null == n ? void 0 : n.lead) || void 0 === i ? void 0 : i.getValue("opacity", 1)) : o.visibilityAction = To.Hide : t.presence === Co.Entering && (o.crossfadeOpacity = null === (r = null == n ? void 0 : n.follow) || void 0 === r ? void 0 : r.getValue("opacity", 0)), o) : o;
}

var ss = function () {
  function t() {
    this.order = [], this.hasChildren = !1;
  }

  return t.prototype.add = function (t) {
    var n,
        e = t.config.layoutOrder;
    if (void 0 === e) this.order.push(t);else {
      var r = this.order.findIndex(function (t) {
        return e <= (t.config.layoutOrder || 0);
      });
      -1 === r && (t.presence = this.hasChildren ? Co.Entering : Co.Present, r = this.order.length), this.order.splice(r, 0, t);
    }

    if (this.snapshot) {
      t.prevSnapshot = this.snapshot, t.prevViewportBox = this.snapshot.boundingBox;
      var i = this.snapshot.latestMotionValues;

      for (var o in i) {
        t.hasValue(o) ? null === (n = t.getValue(o)) || void 0 === n || n.set(i[o]) : t.addValue(o, hr(i[o]));
      }
    }

    this.hasChildren = !0;
  }, t.prototype.remove = function (t) {
    var n = this.order.findIndex(function (n) {
      return t === n;
    });
    -1 !== n && this.order.splice(n, 1);
  }, t.prototype.updateLeadAndFollow = function () {
    this.prevLead = this.lead, this.prevFollow = this.follow;

    var t = function (t, n) {
      for (var e = n[0], r = n[1], i = void 0, o = 0, a = void 0, s = t.length, u = !1, c = s - 1; c >= 0; c--) {
        var l = t[c];
        if (c === s - 1 && (u = l.isPresent), u) i = l;else {
          var d = t[c - 1];
          d && d.isPresent && (i = l);
        }

        if (i) {
          o = c;
          break;
        }
      }

      if (i || (i = t[0]), a = t[o - 1], i) for (c = o - 1; c >= 0; c--) {
        if ((l = t[c]).isPresent) {
          a = l;
          break;
        }
      }
      return i !== e && !u && a === r && t.find(function (t) {
        return t === e;
      }) && (i = e), [i, a];
    }(this.order, [this.lead, this.follow]),
        n = t[0],
        e = t[1];

    this.lead = n, this.follow = e;
  }, t.prototype.updateSnapshot = function () {
    if (this.lead) {
      var t = {
        boundingBox: this.lead.prevViewportBox,
        latestMotionValues: {}
      };
      this.lead.forEachValue(function (n, e) {
        var r = n.get();
        Dr(r) || (t.latestMotionValues[e] = r);
      });
      var n = fa.get(this.lead);
      n && n.isDragging && (t.isDragging = !0, t.cursorProgress = n.cursorProgress), this.snapshot = t;
    }
  }, t.prototype.isLeadPresent = function () {
    var t;
    return this.lead && (null === (t = this.lead) || void 0 === t ? void 0 : t.presence) !== Co.Exiting;
  }, t.prototype.shouldStackAnimate = function () {
    return !0;
  }, t.prototype.getFollowOrigin = function () {
    var t;
    return this.follow ? this.follow.prevViewportBox : null === (t = this.snapshot) || void 0 === t ? void 0 : t.boundingBox;
  }, t.prototype.getFollowTarget = function () {
    var t;
    return null === (t = this.follow) || void 0 === t ? void 0 : t.box;
  }, t.prototype.getLeadOrigin = function () {
    var t;
    return null === (t = this.lead) || void 0 === t ? void 0 : t.prevViewportBox;
  }, t.prototype.getLeadTarget = function () {
    var t;
    return null === (t = this.lead) || void 0 === t ? void 0 : t.box;
  }, t.prototype.getLeadTransition = function () {
    var t;
    return null === (t = this.lead) || void 0 === t ? void 0 : t.config.transition;
  }, t;
}();

!function (t) {
  function n() {
    var n = null !== t && t.apply(this, arguments) || this;
    return n.children = new Set(), n.stacks = new Map(), n.hasMounted = !1, n.updateScheduled = !1, n.renderScheduled = !1, n.syncContext = _Gt(_Gt({}, Ao()), {
      syncUpdate: function syncUpdate(t) {
        return n.scheduleUpdate(t);
      },
      forceUpdate: function forceUpdate() {
        n.syncContext = _Gt({}, n.syncContext), n.scheduleUpdate(!0);
      },
      register: function register(t) {
        return n.addChild(t);
      },
      remove: function remove(t) {
        return n.removeChild(t);
      }
    }), n;
  }

  Xt(n, t), n.prototype.componentDidMount = function () {
    this.hasMounted = !0, this.updateStacks();
  }, n.prototype.componentDidUpdate = function () {
    this.startLayoutAnimation();
  }, n.prototype.shouldComponentUpdate = function () {
    return this.renderScheduled = !0, !0;
  }, n.prototype.startLayoutAnimation = function () {
    var t = this;
    this.renderScheduled = this.updateScheduled = !1;
    var n = this.props.type;
    this.children.forEach(function (t) {
      t.isPresent ? t.presence !== Co.Entering && (t.presence = t.presence === Co.Exiting ? Co.Entering : Co.Present) : t.presence = Co.Exiting;
    }), this.updateStacks();
    var e = "crossfade" === n ? as : os,
        r = {
      measureLayout: function measureLayout(t) {
        return t.measureLayout();
      },
      layoutReady: function layoutReady(n) {
        var r = n.layoutId;
        n.layoutReady(e(n, t.getStack(r)));
      }
    };
    this.children.forEach(function (n) {
      return t.syncContext.add(n);
    }), this.syncContext.flush(r), this.stacks.forEach(function (t) {
      return t.snapshot = void 0;
    });
  }, n.prototype.updateStacks = function () {
    this.stacks.forEach(function (t) {
      return t.updateLeadAndFollow();
    });
  }, n.prototype.scheduleUpdate = function (t) {
    void 0 === t && (t = !1), !t && this.updateScheduled || (this.updateScheduled = !0, this.children.forEach(function (t) {
      return t.snapshotBoundingBox();
    }), this.stacks.forEach(function (t) {
      return t.updateSnapshot();
    }), !t && this.renderScheduled || (this.renderScheduled = !0, this.forceUpdate()));
  }, n.prototype.addChild = function (t) {
    this.children.add(t), this.addToStack(t), t.presence = this.hasMounted ? Co.Entering : Co.Present;
  }, n.prototype.removeChild = function (t) {
    this.scheduleUpdate(), this.children.delete(t), this.removeFromStack(t);
  }, n.prototype.addToStack = function (t) {
    var n = this.getStack(t.layoutId);
    null == n || n.add(t);
  }, n.prototype.removeFromStack = function (t) {
    var n = this.getStack(t.layoutId);
    null == n || n.remove(t);
  }, n.prototype.getStack = function (t) {
    if (void 0 !== t) return !this.stacks.has(t) && this.stacks.set(t, new ss()), this.stacks.get(t);
  }, n.prototype.render = function () {
    return s(Bo.Provider, {
      value: this.syncContext
    }, this.props.children);
  };
}(l);
hr(0), hr(0), hr(0), hr(0);
var us = hr(null);
if ("undefined" != typeof window) if (window.matchMedia) {
  var cs = window.matchMedia("(prefers-reduced-motion)"),
      ls = function ls() {
    return us.set(cs.matches);
  };

  cs.addListener(ls), ls();
} else us.set(!1);
!function (t) {
  function n() {
    var n = null !== t && t.apply(this, arguments) || this;
    return n.initialState = {}, n;
  }

  Xt(n, t), n.prototype.updateLayoutDelta = function () {}, n.prototype.build = function () {}, n.prototype.clean = function () {}, n.prototype.getBoundingBox = function () {
    return {
      x: {
        min: 0,
        max: 0
      },
      y: {
        min: 0,
        max: 0
      }
    };
  }, n.prototype.readNativeValue = function (t) {
    return this.initialState[t] || 0;
  }, n.prototype.render = function () {
    this.build();
  };
}(pr);

function ds() {
  var t = k(["\n  background-color: ", ";\n  position: fixed;\n  width: 100%;\n  height: 100vh;\n  height: calc(var(--vh, 1vh) * 100);\n  top: 0;\n  left: 0;\n  z-index: 9999;\n"]);
  return ds = function ds() {
    return t;
  }, t;
}

var fs = qt(Ja.div)(ds(), function (t) {
  return T(this, undefined), t.overlayColor;
}.bind(void 0)),
    hs = {
  visible: {
    opacity: 1
  },
  hidden: {
    opacity: 0
  }
},
    ps = function (n) {
  T(this, undefined);
  var r = n.isOpened,
      i = n.children,
      o = n.className,
      a = e(R).options,
      s = t.createElement(fs, {
    id: "SRLLightbox",
    initial: "hidden",
    animate: "visible",
    exit: "hidden",
    variants: hs,
    overlayColor: a.settings.overlayColor,
    transition: {
      duration: a.settings.lightboxTransitionSpeed,
      ease: a.settings.lightboxTransitionTimingFunction
    },
    className: o
  }, i);
  return r && "undefined" != typeof window ? g.createPortal(s, document.body) : null;
}.bind(void 0);

ps.propTypes = {
  selector: v.string,
  isOpened: v.bool,
  children: v.oneOfType([v.arrayOf(v.node), v.node]).isRequired
};

function ms() {
  var t = k(["\n  width: ", ";\n  height: ", ";\n  background-repeat: no-repeat;\n  background-size: cover;\n  margin: ", ";\n  opacity: ", ";\n  transition: 0.3s ease;\n  will-change: opacity;\n  display: block;\n  cursor: draggable;\n  flex: 0 0 auto;\n\n  &.SRLThumbnailSelected {\n    opacity: 1;\n  }\n\n  @media (max-width: 768px) {\n    height: 60px;\n    width: 80px;\n  }\n"]);
  return ms = function ms() {
    return t;
  }, t;
}

function vs() {
  var t = k(["\n      justify-content: space-evenly;\n    "]);
  return vs = function vs() {
    return t;
  }, t;
}

function gs() {
  var t = k(["\n      justify-content: space-between;\n    "]);
  return gs = function gs() {
    return t;
  }, t;
}

function ys() {
  var t = k(["\n      justify-content: flex-end;\n    "]);
  return ys = function ys() {
    return t;
  }, t;
}

function bs() {
  var t = k(["\n      justify-content: flex-start;\n    "]);
  return bs = function bs() {
    return t;
  }, t;
}

function xs() {
  var t = k(["\n  display: flex;\n  color: white;\n  height: auto;\n  width: 100vw;\n  justify-content: center;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  opacity: 1;\n  transition: 0.3s ease;\n  will-change: transform, opacity;\n  position: relative;\n  z-index: 9997;\n  cursor: pointer;\n  padding: ", ";\n  background-color: ", ";\n\n  /* Thumbnails alignment */\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  /* Thumbnails aligned to the right */\n  ", ";\n\n  /* Thumbnails aligned to the left */\n  ", ";\n\n  /* if the body has a class of SRLIdle */\n  .SRLIdle & {\n    opacity: 0;\n  }\n\n  /* if the thumbnails are draggable */\n  &.SRLDraggable {\n    cursor: grabbing;\n  }\n\n  @media (max-width: 768px) {\n    justify-content: start;\n    overflow: auto !important;\n    flex-direction: row;\n    width: 100vw !important;\n    height: auto;\n    grid-column: auto;\n    grid-row: auto;\n  }\n"]);
  return xs = function xs() {
    return t;
  }, t;
}

function ws() {
  var t = k(["\n  flex-direction: column;\n  -ms-grid-column: 1;\n  grid-column-start: 1;\n  -ms-grid-row: 1;\n  grid-row-start: 1;\n  -ms-grid-row-span: 2;\n  grid-row-end: 3;\n  height: 100%;\n  width: auto;\n\n  /* SAFARI HACK */\n  @media not all and (min-resolution: 0.001dpcm) {\n    @media {\n      height: 100vh;\n    }\n  }\n\n  /* IE 11 HACK **/\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    height: 100vh;\n  }\n"]);
  return ws = function ws() {
    return t;
  }, t;
}

function Es() {
  var t = k(["\n  flex-direction: column;\n  -ms-grid-column: 2;\n  grid-column-start: 2;\n  -ms-grid-row: 1;\n  grid-row-start: 1;\n  -ms-grid-row-span: 2;\n  grid-row-end: 3;\n  height: 100%;\n  width: auto;\n\n  /* SAFARI HACK */\n  @media not all and (min-resolution: 0.001dpcm) {\n    @media {\n      height: 100vh;\n    }\n  }\n\n  /* IE 11 HACK **/\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    height: 100vh;\n  }\n"]);
  return Es = function Es() {
    return t;
  }, t;
}

var Ss = function (t) {
  return T(this, undefined), Lt(Es());
}.bind(void 0),
    Cs = function (t) {
  return T(this, undefined), Lt(ws());
}.bind(void 0),
    Ts = qt.div(xs(), function (t) {
  return T(this, undefined), t.thumbnailsContainerPadding ? t.thumbnailsContainerPadding : "0";
}.bind(void 0), function (t) {
  return T(this, undefined), t.thumbnailsContainerBackgroundColor ? t.thumbnailsContainerBackgroundColor : "transparent";
}.bind(void 0), function (t) {
  return T(this, undefined), "start" === t.thumbnailsAlignment && Lt(bs());
}.bind(void 0), function (t) {
  return T(this, undefined), "end" === t.thumbnailsAlignment && Lt(ys());
}.bind(void 0), function (t) {
  return T(this, undefined), "space-between" === t.thumbnailsAlignment && Lt(gs());
}.bind(void 0), function (t) {
  return T(this, undefined), "space-evenly" === t.thumbnailsAlignment && Lt(vs());
}.bind(void 0), function (t) {
  return T(this, undefined), "right" === t.thumbnailsPosition && Ss;
}.bind(void 0), function (t) {
  return T(this, undefined), "left" === t.thumbnailsPosition && Cs;
}.bind(void 0)),
    ks = qt.a(ms(), function (t) {
  return T(this, undefined), t.thumbnailsSize ? t.thumbnailsSize[0] : "80px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.thumbnailsSize ? t.thumbnailsSize[1] : "80px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.thumbnailsGap ? t.thumbnailsGap : "1px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.thumbnailsOpacity ? t.thumbnailsOpacity : "0.4";
}.bind(void 0)),
    Ls = function (n) {
  var e = this;
  T(this, undefined);
  var i = n.elements,
      a = n.currentId,
      s = n.handleCurrentElement,
      u = n.thumbnails,
      c = n.SRLThumbnailsRef,
      l = u.thumbnailsOpacity,
      d = u.thumbnailsSize,
      f = u.thumbnailsPosition,
      h = u.thumbnailsAlignment,
      p = u.thumbnailsContainerBackgroundColor,
      m = u.thumbnailsContainerPadding,
      v = u.thumbnailsGap,
      g = r(0),
      y = r(0),
      b = r(0),
      x = r(0),
      w = r(0),
      E = r();
  return o(function () {
    var t = this;
    T(this, e);
    var n = c.current,
        r = document.querySelector(".SRLThumb".concat(a));

    if (r) {
      var i = r.getBoundingClientRect();
      n.scrollWidth > n.offsetWidth || n.scrollHeight > n.offsetHeight ? n.style.justifyContent = "start" : n.style.justifyContent = h || "center", n.scrollWidth > n.offsetWidth ? "scrollBehavior" in document.documentElement.style ? n.scrollBy({
        top: 0,
        left: i.left,
        behavior: "smooth"
      }) : n.scrollLeft = 80 * parseInt(a) : n.scrollHeight > n.offsetHeight && ("scrollBehavior" in document.documentElement.style ? n.scrollBy({
        top: i.top,
        left: 0,
        behavior: "smooth"
      }) : n.scrollTop = i.top);
    }

    function o(t, e) {
      n.scrollWidth > n.offsetWidth ? (g.current = !0, y.current = t - n.offsetLeft, x.current = n.scrollLeft, n.classList.add("SRLDraggable")) : n.scrollHeight > n.offsetHeight && (g.current = !0, b.current = e - n.offsetTop, w.current = n.scrollTop, n.classList.add("SRLDraggable"));
    }

    function u() {
      g.current = !1, n.classList.remove("SRLDraggable");
    }

    function l(t, e) {
      if (g.current) if (n.scrollHeight > n.offsetHeight) {
        var r = e - n.offsetTop - b.current;
        n.scrollTop = w.current - r;
      } else {
        var i = t - n.offsetLeft - y.current;
        n.scrollLeft = x.current - i;
      }
    }

    return E.current = function (t, e, r) {
      (n.scrollWidth > n.offsetWidth || n.scrollHeight > n.offsetHeight) && t !== y.current && e !== b.current || s(r, a);
    }, n.addEventListener("mousedown", function (n) {
      return T(this, t), o(n.pageX, n.pageY);
    }.bind(this)), n.addEventListener("mouseleave", function () {
      return T(this, t), u();
    }.bind(this)), n.addEventListener("mouseup", function () {
      return T(this, t), u();
    }.bind(this)), n.addEventListener("mousemove", function (n) {
      return T(this, t), l(n.pageX, n.pageY);
    }.bind(this)), function () {
      var e = this;
      T(this, t), n.removeEventListener("mousedown", function (t) {
        return T(this, e), o(t.pageX);
      }.bind(this)), n.removeEventListener("mouseleave", function () {
        return T(this, e), u();
      }.bind(this)), n.removeEventListener("mouseup", function () {
        return T(this, e), u();
      }.bind(this)), n.removeEventListener("mousemove", function (t) {
        return T(this, e), l(t);
      }.bind(this));
    }.bind(this);
  }.bind(this), [a, s, c, h]), t.createElement(Ts, {
    ref: c,
    thumbnailsPosition: f,
    thumbnailsSize: d,
    thumbnailsAlignment: h,
    thumbnailsContainerBackgroundColor: p,
    thumbnailsContainerPadding: m,
    className: "SRLThumbnailsContainer"
  }, i.map(function (n) {
    var r = this;
    return T(this, e), t.createElement(ks, {
      onClick: function (t) {
        return T(this, r), E.current(t.pageX, t.pageY, n.id);
      }.bind(this),
      thumbnailsOpacity: l,
      thumbnailsSize: d,
      thumbnailsGap: v,
      key: n.id,
      id: n.id,
      className: "SRLThumb SRLThumb".concat(n.id, " ").concat(a === n.id ? "SRLThumbnailSelected" : ""),
      style: {
        backgroundImage: "url('".concat(n.thumbnail, "')")
      }
    });
  }.bind(this)));
}.bind(void 0);

Ls.propTypes = {
  elements: v.array,
  handleCurrentElement: v.func,
  currentId: v.string,
  SRLThumbnailsRef: v.object,
  thumbnails: v.shape({
    thumbnailsAlignment: v.string,
    thumbnailsContainerBackgroundColor: v.string,
    thumbnailsContainerPadding: v.string,
    thumbnailsGap: v.string,
    thumbnailsOpacity: v.number,
    thumbnailsPosition: v.string,
    thumbnailsSize: v.array
  })
};

function Ps() {
  var t = k(["\n      grid-column: 2/2;\n      -ms-grid-column: 2;\n      align-items: start;\n    "]);
  return Ps = function Ps() {
    return t;
  }, t;
}

function As() {
  var t = k(["\n      grid-column: 1/2;\n      -ms-grid-column: 1;\n      -ms-grid-column-span: 1;\n      align-items: start;\n    "]);
  return As = function As() {
    return t;
  }, t;
}

function Os() {
  var t = k(["\n  color: white;\n  font-family: inherit;\n  outline: none;\n  border: 0;\n  position: relative;\n  z-index: 9996;\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    width: 100vw;\n  }\n  width: 100%;\n  height: 100px;\n  display: flex;\n  justify-content: center;\n  align-content: ", ";\n  padding: ", ";\n\n  ", ";\n\n  /* Thumbnails aligned to the left */\n  ", ";\n\n  @media (max-width: 768px) {\n    grid-column: auto;\n  }\n\n  /* Paragraph inside the caption container */\n  p {\n    margin: 0;\n    text-align: center;\n    font-weight: ", ";\n    font-size: ", ";\n    font-family: ", ";\n    color: ", ";\n    font-style: ", ";\n    text-transform: ", ";\n\n    @media (max-width: 768px) {\n      font-size: 14px;\n      padding: 0 15px;\n    }\n  }\n"]);
  return Os = function Os() {
    return t;
  }, t;
}

var Bs = qt.div(Os(), function (t) {
  return T(this, undefined), t.captionAlignment;
}.bind(void 0), function (t) {
  return T(this, undefined), t.captionStyle.captionContainerPadding ? t.captionStyle.captionContainerPadding : "0";
}.bind(void 0), function (t) {
  return T(this, undefined), "right" === t.thumbnailsPosition && Lt(As());
}.bind(void 0), function (t) {
  return T(this, undefined), "left" === t.thumbnailsPosition && Lt(Ps());
}.bind(void 0), function (t) {
  return T(this, undefined), t.captionStyle.captionFontWeight ? t.captionStyle.captionFontWeight : "inherit";
}.bind(void 0), function (t) {
  return T(this, undefined), t.captionStyle.captionFontSize ? t.captionStyle.captionFontSize : "inherit";
}.bind(void 0), function (t) {
  return T(this, undefined), t.captionStyle.captionColor ? t.captionStyle.captionFontFamily : "inherit";
}.bind(void 0), function (t) {
  return T(this, undefined), t.captionStyle.captionColor ? t.captionStyle.captionColor : "white";
}.bind(void 0), function (t) {
  return T(this, undefined), t.captionStyle.captionFontStyle ? t.captionStyle.captionFontStyle : "inherit";
}.bind(void 0), function (t) {
  return T(this, undefined), t.captionStyle.captionTextTransform ? t.captionStyle.captionTextTransform : "inherit";
}.bind(void 0)),
    Rs = function (n) {
  T(this, undefined);
  var r = n.captionOptions,
      i = n.caption,
      o = n.thumbnailsPosition,
      a = n.SRLCaptionRef,
      s = e(R),
      u = s.selectedElement;
  var c = s.customCaptions.find(function (t) {
    return t.id === parseInt(u.id);
  });
  return t.createElement(Bs, {
    captionStyle: r,
    thumbnailsPosition: o,
    className: "SRLCaptionContainer",
    ref: a
  }, c ? t.createElement("div", {
    className: "SRLCustomCaption"
  }, c.caption) : t.createElement("p", {
    className: "SRLCaptionText"
  }, i));
}.bind(void 0);

function Ds() {
  return (Ds = Object.assign || function (t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];

      for (var r in e) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}

Rs.propTypes = {
  captionOptions: v.shape({
    showCaption: v.bool,
    captionColor: v.string,
    captionFontFamily: v.string,
    captionFontSize: v.string,
    captionFontStyle: v.string,
    captionFontWeight: v.oneOfType([v.number, v.string]),
    captionTextTransform: v.string
  }),
  SRLCaptionRef: v.object,
  thumbnailsPosition: v.string,
  caption: v.string
};
var Ns = {
  preventDefaultTouchmoveEvent: !1,
  delta: 10,
  rotationAngle: 0,
  trackMouse: !1,
  trackTouch: !0
},
    zs = {
  xy: [0, 0],
  swiping: !1,
  eventData: void 0,
  start: void 0
};

function Ms(t, n) {
  if (0 === n) return t;
  var e = Math.PI / 180 * n;
  return [t[0] * Math.cos(e) + t[1] * Math.sin(e), t[1] * Math.cos(e) - t[0] * Math.sin(e)];
}

function Is(t, n) {
  var e = function e(n) {
    n.touches && n.touches.length > 1 || t(function (t, e) {
      e.trackMouse && (document.addEventListener("mousemove", r), document.addEventListener("mouseup", a));
      var i = n.touches ? n.touches[0] : n,
          o = Ms([i.clientX, i.clientY], e.rotationAngle);
      return Ds({}, t, zs, {
        eventData: {
          initial: [].concat(o),
          first: !0
        },
        xy: o,
        start: n.timeStamp || 0
      });
    });
  },
      r = function r(n) {
    t(function (t, e) {
      if (!t.xy[0] || !t.xy[1] || n.touches && n.touches.length > 1) return t;
      var r = n.touches ? n.touches[0] : n,
          i = Ms([r.clientX, r.clientY], e.rotationAngle),
          o = i[0],
          a = i[1],
          s = t.xy[0] - o,
          u = t.xy[1] - a,
          c = Math.abs(s),
          l = Math.abs(u),
          d = (n.timeStamp || 0) - t.start,
          f = Math.sqrt(c * c + l * l) / (d || 1);
      if (c < e.delta && l < e.delta && !t.swiping) return t;

      var h = function (t, n, e, r) {
        return t > n ? e > 0 ? "Left" : "Right" : r > 0 ? "Up" : "Down";
      }(c, l, s, u),
          p = Ds({}, t.eventData, {
        event: n,
        absX: c,
        absY: l,
        deltaX: s,
        deltaY: u,
        velocity: f,
        dir: h
      });

      e.onSwiping && e.onSwiping(p);
      var m = !1;
      return (e.onSwiping || e.onSwiped || e["onSwiped" + h]) && (m = !0), m && e.preventDefaultTouchmoveEvent && e.trackTouch && n.cancelable && n.preventDefault(), Ds({}, t, {
        eventData: Ds({}, p, {
          first: !1
        }),
        swiping: !0
      });
    });
  },
      i = function i(n) {
    t(function (t, e) {
      var r;
      return t.swiping && (r = Ds({}, t.eventData, {
        event: n
      }), e.onSwiped && e.onSwiped(r), e["onSwiped" + r.dir] && e["onSwiped" + r.dir](r)), Ds({}, t, zs, {
        eventData: r
      });
    });
  },
      o = function o() {
    document.removeEventListener("mousemove", r), document.removeEventListener("mouseup", a);
  },
      a = function a(t) {
    o(), i(t);
  },
      s = function s(t) {
    if (t && t.addEventListener) {
      var n = [["touchstart", e], ["touchmove", r], ["touchend", i]];
      return n.forEach(function (n) {
        var e = n[0],
            r = n[1];
        return t.addEventListener(e, r);
      }), function () {
        return n.forEach(function (n) {
          var e = n[0],
              r = n[1];
          return t.removeEventListener(e, r);
        });
      };
    }
  },
      u = {
    ref: function ref(n) {
      null !== n && t(function (t, e) {
        if (t.el === n) return t;
        var r = {};
        return t.el && t.el !== n && t.cleanUpTouch && (t.cleanUpTouch(), r.cleanUpTouch = null), e.trackTouch && n && (r.cleanUpTouch = s(n)), Ds({}, t, {
          el: n
        }, r);
      });
    }
  };

  return n.trackMouse && (u.onMouseDown = e), [u, s];
}

function Vs(t, n, e) {
  var r = {};
  return !n.trackTouch && t.cleanUpTouch ? (t.cleanUpTouch(), r.cleanUpTouch = null) : n.trackTouch && !t.cleanUpTouch && t.el && (r.cleanUpTouch = e(t.el)), Ds({}, t, r);
}

var _s = function (n) {
  var e, r;

  function i(t) {
    var e;
    return (e = n.call(this, t) || this)._set = function (t) {
      e.transientState = t(e.transientState, e.props);
    }, e.transientState = Ds({}, zs, {
      type: "class"
    }), e;
  }

  return r = n, (e = i).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r, i.prototype.render = function () {
    var n = this.props,
        e = n.className,
        r = n.style,
        i = n.nodeName,
        o = void 0 === i ? "div" : i,
        a = n.innerRef,
        s = n.children,
        u = n.trackMouse,
        c = Is(this._set, {
      trackMouse: u
    }),
        l = c[0],
        d = c[1];
    this.transientState = Vs(this.transientState, this.props, d);
    var f = a ? function (t) {
      return a(t), l.ref(t);
    } : l.ref;
    return t.createElement(o, Ds({}, l, {
      className: e,
      style: r,
      ref: f
    }), s);
  }, i;
}(t.PureComponent);

function Fs(t, n, e) {
  void 0 === e && (e = {});
  var i = e.maxWait,
      a = r(null),
      s = r([]),
      u = e.leading,
      c = void 0 === e.trailing || e.trailing,
      l = r(!1),
      d = r(null),
      h = r(!1),
      p = r(t);
  p.current = t;
  var m = f(function () {
    clearTimeout(d.current), clearTimeout(a.current), a.current = null, s.current = [], d.current = null, l.current = !1;
  }, []);
  o(function () {
    return h.current = !1, function () {
      h.current = !0;
    };
  }, []);
  var v = f(function () {
    for (var t = [], e = 0; e < arguments.length; e++) {
      t[e] = arguments[e];
    }

    s.current = t, clearTimeout(d.current), l.current && (l.current = !1), d.current || !u || l.current || (p.current.apply(p, t), l.current = !0), d.current = setTimeout(function () {
      var n = !0;
      u && l.current && (n = !1), m(), !h.current && c && n && p.current.apply(p, t);
    }, n), i && !a.current && c && (a.current = setTimeout(function () {
      var t = s.current;
      m(), h.current || p.current.apply(null, t);
    }, i));
  }, [i, n, m, u, c]),
      g = f(function () {
    d.current && (p.current.apply(null, s.current), m());
  }, [m]);
  return [v, m, g];
}

_s.propTypes = {
  onSwiped: v.func,
  onSwiping: v.func,
  onSwipedUp: v.func,
  onSwipedRight: v.func,
  onSwipedDown: v.func,
  onSwipedLeft: v.func,
  delta: v.number,
  preventDefaultTouchmoveEvent: v.bool,
  nodeName: v.string,
  trackMouse: v.bool,
  trackTouch: v.bool,
  innerRef: v.func,
  rotationAngle: v.number
}, _s.defaultProps = Ns;
var js = z(function (t, n) {
  !function () {
    function n(t, n, e, r) {
      var i = "removeEventListener",
          o = function o() {
        t[i](n, e);
      };

      return t.addEventListener ? (t.addEventListener(n, e, r), o) : t.attachEvent ? (n = "on" + n, t.attachEvent(n, e), i = "detachEvent", o) : t.on ? (t.on(n, e), i = "off", o) : void 0;
    }

    n.define = function (t, n) {
      return function (e, r, i, o) {
        return e[t](r, i, o), function () {
          e[n](r, i);
        };
      };
    }, t.exports = n;
  }();
});

function Hs() {
  var t = this,
      n = e(R);
  return {
    openLightbox: function openLightbox() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
      n.dispatch({
        type: "OPEN_AT_INDEX",
        index: t
      });
    },
    closeLightbox: function () {
      T(this, t), n.dispatch({
        type: "CLOSE_LIGHTBOX"
      });
    }.bind(this)
  };
}

function Us(t, n, e) {
  var i = this,
      a = r();
  o(function () {
    T(this, i), a.current = t;
  }.bind(this), [t, e]), o(function () {
    var t = this;

    if (T(this, i), null !== n) {
      var e = setInterval(function () {
        a.current();
      }, n);
      return function () {
        return T(this, t), clearInterval(e);
      }.bind(this);
    }
  }.bind(this), [n, e]);
}

function Ws(t) {
  var n = this,
      e = L(i({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    scrollHeight: 0,
    scrollWidth: 0
  }), 2),
      r = e[0],
      a = e[1],
      s = "object" === ("undefined" == typeof window ? "undefined" : y(window));
  return o(function () {
    var e = this;
    if (T(this, n), t.current || s) return t.current && a(r()), window.addEventListener("resize", i), function () {
      return T(this, e), window.removeEventListener("resize", i);
    }.bind(this);

    function r() {
      var n = t.current.getBoundingClientRect(),
          e = n.x,
          r = n.y,
          i = n.width,
          o = n.height,
          a = n.top,
          s = n.left,
          u = n.bottom,
          c = n.right;
      return {
        width: i,
        height: o,
        scrollWidth: t.current.scrollWidth,
        scrollHeight: t.current.scrollHeight,
        x: e,
        y: r,
        top: a,
        left: s,
        bottom: u,
        right: c
      };
    }

    function i() {
      t.current && a(r());
    }
  }.bind(this), [t, s]), [r];
}

function qs() {
  var t = k(["\n      -ms-grid-rows: auto;\n      grid-template-rows: auto;\n    "]);
  return qs = function qs() {
    return t;
  }, t;
}

function Ys() {
  var t = k(["\n      -ms-grid-rows: 90% auto;\n      grid-template-rows: 90% auto;\n    "]);
  return Ys = function Ys() {
    return t;
  }, t;
}

function Xs() {
  var t = k(["\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  display: grid;\n  display: -ms-grid;\n  -ms-grid-rows: auto;\n  grid-template-rows: auto;\n  align-items: center;\n  justify-content: center;\n  justify-items: center;\n  width: 100vw;\n  height: 100vh;\n  height: calc(var(--vh, 1vh) * 100);\n\n  > *:nth-of-type(1) {\n    -ms-grid-row: 1;\n  }\n\n  > *:nth-of-type(2) {\n    -ms-grid-row: 2;\n  }\n\n  > *:nth-of-type(3) {\n    -ms-grid-row: 3;\n  }\n\n  /* Thumbnails aligned to the right */\n  ", ";\n\n  /* Thumbnails aligned to the left */\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  @media (max-width: 768px) {\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n  }\n"]);
  return Xs = function Xs() {
    return t;
  }, t;
}

function Gs() {
  var t = k(["\n  -ms-grid-columns: auto 1fr;\n  grid-template-columns: auto 1fr;\n  -ms-grid-rows: 90% auto;\n  grid-template-rows: 90% auto;\n\n  > *:nth-of-type(1) {\n    -ms-grid-row: 1;\n  }\n\n  > *:nth-of-type(2) {\n    -ms-grid-row: 2;\n  }\n\n  > *:nth-of-type(3) {\n    -ms-grid-row: 1;\n  }\n"]);
  return Gs = function Gs() {
    return t;
  }, t;
}

function Zs() {
  var t = k(["\n  -ms-grid-columns: 1fr auto;\n  grid-template-columns: 1fr auto;\n  -ms-grid-rows: 90% auto;\n  grid-template-rows: 90% auto;\n\n  > *:nth-of-type(1) {\n    -ms-grid-row: 1;\n  }\n\n  > *:nth-of-type(2) {\n    -ms-grid-row: 2;\n  }\n\n  > *:nth-of-type(3) {\n    -ms-grid-row: 1;\n  }\n"]);
  return Zs = function Zs() {
    return t;
  }, t;
}

var $s = Lt(Zs()),
    Ks = Lt(Gs()),
    Js = qt.div(Xs(), function (t) {
  return T(this, undefined), "right" === t.thumbnailsPosition && $s;
}.bind(void 0), function (t) {
  return T(this, undefined), "left" === t.thumbnailsPosition && Ks;
}.bind(void 0), function (t) {
  return T(this, undefined), t.hideThumbnails && Lt(Ys());
}.bind(void 0), function (t) {
  return T(this, undefined), !t.showCaption && Lt(qs());
}.bind(void 0));

function Qs() {
  var t = k(["\n  top: 0;\n  left: 0;\n  position: relative;\n  transform-origin: 50% 50% !important;\n  cursor: grab;\n  z-index: 9997;\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n"]);
  return Qs = function Qs() {
    return t;
  }, t;
}

function tu() {
  var t = k(["\n  background: transparent;\n  border: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  outline: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  transition: all 200ms ease;\n  opacity: 1;\n  margin: auto;\n  z-index: 9997;\n  cursor: ", ";\n"]);
  return tu = function tu() {
    return t;
  }, t;
}

function nu() {
  var t = k(["\n  width: 100%;\n  height: 90%;\n  position: absolute;\n  /* IE 11 HACK **/\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    top: 5%;\n    left: 0;\n  }\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  outline: none;\n  border: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n"]);
  return nu = function nu() {
    return t;
  }, t;
}

function eu() {
  var t = k(["\n      height: calc(100vh - ", "px);\n    "]);
  return eu = function eu() {
    return t;
  }, t;
}

function ru() {
  var t = k(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  outline: none;\n  width: 100vw;\n  height: ", ";\n\n  /* Thumbnails aligned to the right.\n  We need to exclude the height of the div containing the thumbnails this time */\n  ", ";\n\n  /* Thumbnails aligned to the left.\n    We need to exclude the height of the div containing the thumbnails this time */\n  ", ";\n  /* Thumbnails hidden */\n  ", ";\n\n  @media (max-width: 768px) {\n    grid-column: auto;\n    width: 100vw;\n    height: ", ";\n  }\n"]);
  return ru = function ru() {
    return t;
  }, t;
}

function iu() {
  var t = k(["\n  grid-column: 2/2;\n  -ms-grid-column: 2;\n  width: 100%;\n  height: calc(100vh - ", "px);\n"]);
  return iu = function iu() {
    return t;
  }, t;
}

function ou() {
  var t = k(["\n  grid-column: 1/2;\n  -ms-grid-column: 1;\n  -ms-grid-column-span: 1;\n  width: 100%;\n  height: calc(100vh - ", "px);\n"]);
  return ou = function ou() {
    return t;
  }, t;
}

var au = function (t) {
  return T(this, undefined), Lt(ou(), t.captionDivSizes.height);
}.bind(void 0),
    su = function (t) {
  return T(this, undefined), Lt(iu(), t.captionDivSizes.height);
}.bind(void 0),
    uu = qt.div(ru(), function (t) {
  return T(this, undefined), t ? "calc(100vh - ".concat(t.captionDivSizes.height + t.thumbnailsDivSizes.height, "px)") : "100%";
}.bind(void 0), function (t) {
  return T(this, undefined), "right" === t.thumbnailsPosition && au;
}.bind(void 0), function (t) {
  return T(this, undefined), "left" === t.thumbnailsPosition && su;
}.bind(void 0), function (t) {
  return T(this, undefined), t.hideThumbnails && "bottom" === t.thumbnailsPosition && Lt(eu(), t.thumbnailsDivSizes.height);
}.bind(void 0), function (t) {
  return T(this, undefined), t ? "calc((var(--vh, 1vh) * 100) - ".concat(t.captionDivSizes.height + t.thumbnailsDivSizes.height, "px)") : "100%";
}.bind(void 0)),
    cu = qt(Ja.div)(nu()),
    lu = qt.img(tu(), function (t) {
  return T(this, undefined), t.disablePanzoom ? "auto" : "zoom-in";
}.bind(void 0)),
    du = qt.img(Qs());

function fu(n) {
  var e = this,
      i = n.caption,
      a = n.direction,
      s = n.elements,
      u = n.handleCurrentElement,
      c = n.handleCloseLightbox,
      l = n.handleNextElement,
      d = n.handlePanzoom,
      f = n.handlePrevElement,
      h = n.height,
      p = n.hideThumbnails,
      m = n.id,
      v = n.options,
      g = n.panzoomEnabled,
      b = n.source,
      x = n.SRLPanzoomImageRef,
      w = n.SRLThumbnailsRef,
      S = n.SRLCaptionRef,
      C = n.width,
      k = v.settings,
      P = v.thumbnails,
      A = v.caption,
      O = L(Ws(S), 1)[0],
      B = L(Ws(w), 1)[0],
      R = r(),
      D = !!window.MSInputMethodContext && !!document.documentMode,
      N = D ? 1e3 : "100%",
      z = D ? -1e3 : "-100%",
      M = {
    slideIn: function (t) {
      return T(this, e), {
        x: void 0 === t ? 0 : "next" === t ? N : z,
        transition: {
          ease: k.slideTransitionTimingFunction
        }
      };
    }.bind(this),
    slideOut: function (t) {
      return T(this, e), {
        x: "previous" === t ? N : z,
        transition: {
          ease: k.slideTransitionTimingFunction
        }
      };
    }.bind(this),
    fadeIn: {
      opacity: 0,
      transition: {
        ease: k.slideTransitionTimingFunction
      }
    },
    fadeOut: {
      opacity: 0,
      transition: {
        ease: k.slideTransitionTimingFunction
      }
    },
    bothIn: function (t) {
      return T(this, e), {
        opacity: 1,
        x: void 0 === t ? "0" : "next" === t ? 1e3 : -1e3,
        transition: {
          ease: k.slideTransitionTimingFunction
        }
      };
    }.bind(this),
    bothOut: function (t) {
      return T(this, e), {
        opacity: 0,
        x: "previous" === t ? 1e3 : -1e3,
        transition: {
          ease: k.slideTransitionTimingFunction
        }
      };
    }.bind(this),
    center: {
      x: 0,
      opacity: 1
    }
  },
      I = function (n) {
    var e = n.trackMouse,
        r = t.useRef(Ds({}, zs, {
      type: "hook"
    })),
        i = t.useRef();
    i.current = Ds({}, Ns, n);
    var o = t.useMemo(function () {
      return Is(function (t) {
        return r.current = t(r.current, i.current);
      }, {
        trackMouse: e
      });
    }, [e]),
        a = o[0],
        s = o[1];
    return r.current = Vs(r.current, i.current, s), a;
  }({
    onSwipedLeft: function () {
      return T(this, e), l(m);
    }.bind(this),
    onSwipedRight: function () {
      return T(this, e), f(m);
    }.bind(this),
    delta: g ? 500 : 90,
    preventDefaultTouchmoveEvent: !0,
    trackTouch: !0,
    trackMouse: !1
  }),
      V = L(Fs(function (t) {
    T(this, e), t > 0 ? l(m) : t < 0 && f(m);
  }.bind(this), 150), 1)[0];

  o(function () {
    var t = this;

    if (T(this, e), !g && !k.disableWheelControls) {
      var n = js(document, "wheel", function (n) {
        return T(this, t), V(n.deltaY);
      }.bind(this));
      return function () {
        T(this, t), n();
      }.bind(this);
    }
  }.bind(this), [V, g, k.disableWheelControls]), function (t, n) {
    var e = this;
    o(function () {
      var r = this;
      T(this, e);

      var i = function (e) {
        T(this, r), !t.current || e.target.classList.contains("SRLImage") || e.target.classList.contains("SRLPanzoomImage") || e.target.classList.contains("SRLNextButton") || e.target.classList.contains("SRLPrevButton") || e.target.classList.contains("SRLCloseButton") || e.target.classList.contains("SRLAutoplayButton") || e.target.classList.contains("SRLExpandButton") || e.target.classList.contains("SRLZoomOutButton") || e.target.classList.contains("SRLDownloadButton") || e.target.classList.contains("SRLThumbnailsButton") || e.target.classList.contains("SRLCaptionContainer") || e.target.classList.contains("SRLCaptionText") || e.target.classList.contains("SRLCustomCaption") || e.target.classList.contains("SRLThumbnails") || e.target.classList.contains("SRLThumb") || e.target.classList.contains("SRLCaption") || "touchstart" === e.type || 0 !== e.button || n(e);
      }.bind(this);

      return "undefined" != typeof window && (document.addEventListener("mousedown", i), document.addEventListener("touchstart", i)), function () {
        T(this, r), "undefined" != typeof window && (document.removeEventListener("mousedown", i), document.removeEventListener("touchstart", i));
      }.bind(this);
    }.bind(this), [t, n]);
  }(R, function () {
    return T(this, e), c();
  }.bind(this));
  var _ = {
    captionAlignment: v.caption.captionAlignment,
    captionColor: v.caption.captionColor,
    captionContainerPadding: v.caption.captionContainerPadding,
    captionFontFamily: v.caption.captionFontFamily,
    captionFontSize: v.caption.captionFontSize,
    captionFontStyle: v.caption.captionFontStyle,
    captionFontWeight: v.caption.captionFontWeight,
    captionTextTransform: v.caption.captionTextTransform
  };
  return t.createElement(Js, {
    className: "SRLContainer",
    ref: R,
    thumbnailsPosition: P.thumbnailsPosition,
    showCaption: A.showCaption,
    hideThumbnails: p
  }, t.createElement(uu, E({
    thumbnailsPosition: P.thumbnailsPosition,
    showThumbnails: P.showThumbnails,
    hideThumbnails: p,
    showCaption: A.showCaption,
    className: "SRLElementContainer",
    captionDivSizes: O,
    thumbnailsDivSizes: B
  }, I), t.createElement(is, {
    className: "SRLAnimatePresence",
    custom: a
  }, t.createElement(cu, {
    variants: M,
    custom: a,
    initial: "slide" === k.slideAnimationType ? "slideIn" : "both" === k.slideAnimationType ? "bothIn" : "fadeIn",
    animate: "center",
    exit: "slide" === k.slideAnimationType ? "slideOut" : "both" === k.slideAnimationType ? "bothOut" : "fadeOut",
    className: "SRLElementWrapper",
    key: m,
    transition: {
      x: {
        type: "spring",
        stiffness: k.slideSpringValues[0],
        damping: k.slideSpringValues[1]
      },
      opacity: {
        duration: k.slideTransitionSpeed
      }
    }
  }, !g && t.createElement(lu, {
    className: "SRLImage",
    disablePanzoom: k.disablePanzoom,
    width: h,
    height: C,
    onClick: function () {
      return T(this, e), d(!0);
    }.bind(this),
    src: "object" === y(b) ? "Loading..." : b,
    alt: i
  })), g ? t.createElement(du, {
    className: "SRLPanzoomImage",
    ref: x,
    width: h,
    height: C,
    src: "object" === y(b) ? "Loading..." : b,
    alt: i
  }) : t.createElement(t.Fragment, null))), A.showCaption && t.createElement(Rs, {
    id: m,
    thumbnailsPosition: P.thumbnailsPosition,
    captionOptions: _,
    caption: i,
    SRLCaptionRef: S
  }), P.showThumbnails && !p && t.createElement(Ls, {
    handleCurrentElement: u,
    thumbnails: P,
    currentId: m,
    elements: s || [],
    SRLThumbnailsRef: w
  }));
}

fu.propTypes = {
  caption: v.string,
  direction: v.string,
  elements: v.array,
  handleCloseLightbox: v.func,
  handleCurrentElement: v.func,
  handleNextElement: v.func,
  handlePanzoom: v.func,
  handlePrevElement: v.func,
  height: v.oneOfType([v.number, v.string]),
  id: v.string,
  SRLPanzoomImageRef: v.object,
  SRLCaptionRef: v.object,
  SRLThumbnailsRef: v.object,
  hideThumbnails: v.bool,
  options: v.shape({
    settings: v.shape({
      disablePanzoom: v.bool,
      disableWheelControls: v.bool,
      slideAnimationType: v.string,
      slideSpringValues: v.array,
      slideTransitionSpeed: v.number,
      slideTransitionTimingFunction: v.oneOfType([v.string, v.array])
    }),
    caption: v.shape({
      captionAlignment: v.string,
      captionColor: v.string,
      captionFontFamily: v.string,
      captionFontSize: v.string,
      captionFontStyle: v.string,
      captionFontWeight: v.oneOfType([v.number, v.string]),
      captionContainerPadding: v.string,
      captionTextTransform: v.string,
      showCaption: v.bool
    }),
    thumbnails: v.shape({
      showThumbnails: v.bool,
      thumbnailsOpacity: v.number,
      thumbnailsPosition: v.string,
      thumbnailsSize: v.array
    })
  }),
  panzoomEnabled: v.bool,
  source: v.oneOfType([v.string, v.object]),
  SRLLightboxPanzoomImageRef: v.object,
  thumbnailsOpacity: v.number,
  width: v.oneOfType([v.number, v.string])
};

function hu() {
  var t = k(["\n      left: 5px;\n      left: calc(env(safe-area-inset-right) + 5px);\n    "]);
  return hu = function hu() {
    return t;
  }, t;
}

function pu() {
  var t = k(["\n      left: ", "px;\n      left: calc(\n        env(safe-area-inset-right) + ", "px\n      );\n    "]);
  return pu = function pu() {
    return t;
  }, t;
}

function mu() {
  var t = k(["\n  top: calc(50% - 50px);\n  left: 5px;\n  left: calc(env(safe-area-inset-left) + 5px);\n  transition: 0.3s ease;\n  will-change: left;\n\n  /* Offset the thumbnails with the width of the div of the thumbnails */\n  ", ";\n\n  /* Thumbnails on left are closed so we need to reset the position */\n  ", ";\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"]);
  return mu = function mu() {
    return t;
  }, t;
}

function vu() {
  var t = k(["\n      right: 5px;\n      right: calc(env(safe-area-inset-right) + 5px);\n    "]);
  return vu = function vu() {
    return t;
  }, t;
}

function gu() {
  var t = k(["\n      right: ", "px;\n      right: calc(\n        env(safe-area-inset-right) + ", "px\n      );\n    "]);
  return gu = function gu() {
    return t;
  }, t;
}

function yu() {
  var t = k(["\n  top: calc(50% - 50px);\n  right: 5px;\n  right: calc(env(safe-area-inset-right) + 5px);\n  transition: 0.3s ease;\n  will-change: right;\n\n  /* Offset the thumbnails with the width of the div of the thumbnails */\n  ", ";\n\n  /* Thumbnails on right are closed so we need to reset the position */\n  ", ";\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"]);
  return yu = function yu() {
    return t;
  }, t;
}

function bu() {
  var t = k(["\n  position: relative;\n  margin-right: 5px;\n"]);
  return bu = function bu() {
    return t;
  }, t;
}

function xu() {
  var t = k(["\n      svg {\n        transform: rotate(90deg);\n      }\n    "]);
  return xu = function xu() {
    return t;
  }, t;
}

function wu() {
  var t = k(["\n      svg {\n        transform: rotate(-90deg);\n      }\n    "]);
  return wu = function wu() {
    return t;
  }, t;
}

function Eu() {
  var t = k(["\n  position: relative;\n  margin-right: 5px;\n\n  ", "\n\n  ", "\n\n  @media (max-width: 768px) {\n    svg {\n      transform: rotate(0) !important;\n    }\n  }\n"]);
  return Eu = function Eu() {
    return t;
  }, t;
}

function Su() {
  var t = k(["\n  position: relative;\n  margin-right: 5px;\n  display: ", ";\n"]);
  return Su = function Su() {
    return t;
  }, t;
}

function Cu() {
  var t = k(["\n  position: relative;\n  margin-right: 5px;\n"]);
  return Cu = function Cu() {
    return t;
  }, t;
}

function Tu() {
  var t = k(["\n  position: relative;\n  margin-right: 5px;\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n"]);
  return Tu = function Tu() {
    return t;
  }, t;
}

function ku() {
  var t = k(["\n  position: relative;\n"]);
  return ku = function ku() {
    return t;
  }, t;
}

function Lu() {
  var t = k(["\n      right: 5px;\n      right: calc(env(safe-area-inset-right) + 5px);\n    "]);
  return Lu = function Lu() {
    return t;
  }, t;
}

function Pu() {
  var t = k(["\n      right: ", "px;\n      right: calc(\n        env(safe-area-inset-top) + ", "px\n      );\n    "]);
  return Pu = function Pu() {
    return t;
  }, t;
}

function Au() {
  var t = k(["\n      top: ", "px;\n      top: calc(\n        env(safe-area-inset-top) +\n          ", "px\n      );\n    "]);
  return Au = function Au() {
    return t;
  }, t;
}

function Ou() {
  var t = k(['\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  top: calc(env(safe-area-inset-top) + 5px);\n  right: calc(env(safe-area-inset-right) + 5px);\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  transition: 0.3s ease;\n  will-change: right;\n\n  /* Offset the buttons if the progress bar is active and the autoplay is "playing" */\n  ', ";\n\n  /* Offset the buttons if the thumbnails are on the right */\n  ", ";\n\n  /* Thumbnails on right are closed so we need to reset the position */\n  ", ";\n\n  @media (max-width: 768px) {\n    right: 5px;\n    right: calc(env(safe-area-inset-right) + 5px) !important;\n  }\n"]);
  return Ou = function Ou() {
    return t;
  }, t;
}

function Bu() {
  var t = k(["\n  position: absolute;\n  height: ", ";\n  width: ", ";\n  transition: color 0.3s ease;\n  background-color: ", ";\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  visibility: inherit;\n  z-index: 9998;\n  opacity: 1;\n  transition: opacity 0.3s ease;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n\n  .SRLIdle & {\n    opacity: 0;\n\n    @media (max-width: 768px) {\n      opacity: 1;\n    }\n\n    @media (max-width: 360px) {\n      opacity: 1;\n    }\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  @media (max-width: 768px) {\n    height: ", ";\n    width: ", ";\n  }\n\n  @media (max-width: 360px) {\n    height: ", ";\n    width: ", ";\n\n    .SRLIdle & {\n      opacity: 1;\n    }\n  }\n\n  div {\n    display: flex;\n    justify-content: center;\n    height: ", ";\n    width: ", ";\n    padding: ", ";\n    box-sizing: border-box;\n\n    @media (max-width: 768px) {\n      height: ", ";\n      width: ", ";\n    }\n\n    @media (max-width: 360px) {\n      height: ", ";\n      width: ", ";\n\n      .SRLIdle & {\n        opacity: 1;\n      }\n    }\n\n    svg {\n      display: block;\n      height: 100%;\n      width: auto;\n      overflow: visible;\n      position: relative;\n      path {\n        transition: fill 0.3s ease;\n        fill: ", ";\n      }\n    }\n    &:hover {\n      svg path {\n        fill: ", ";\n      }\n    }\n  }\n"]);
  return Bu = function Bu() {
    return t;
  }, t;
}

var Ru = qt.button(Bu(), function (t) {
  return T(this, undefined), t.buttonsSize ? t.buttonsSize : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsSize ? t.buttonsSize : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsBackgroundColor ? t.buttonsBackgroundColor : "rgba(30, 30, 36, 0.8)";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsSize ? Math.round(parseInt(t.buttonsSize, 10) / 1) + "px" : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsSize ? Math.round(parseInt(t.buttonsSize, 10) / 1) + "px" : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsSize ? Math.round(parseInt(t.buttonsSize, 10) / 1.2) + "px" : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsSize ? Math.round(parseInt(t.buttonsSize, 10) / 1.2) + "px" : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsSize ? t.buttonsSize : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsSize ? t.buttonsSize : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsIconPadding ? t.buttonsIconPadding : "5px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsSize ? Math.round(parseInt(t.buttonsSize, 10) / 1) + "px" : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsSize ? Math.round(parseInt(t.buttonsSize, 10) / 1) + "px" : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsSize ? Math.round(parseInt(t.buttonsSize, 10) / 1.2) + "px" : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsSize ? Math.round(parseInt(t.buttonsSize, 10) / 1.2) + "px" : "30px";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsIconColor ? t.buttonsIconColor : "rgba(255, 255, 255, 0.8)";
}.bind(void 0), function (t) {
  return T(this, undefined), t.buttonsIconColor && t.buttonsIconColor.replace(/[\d\.]+\)$/g, "1)");
}.bind(void 0)),
    Du = qt.div(Ou(), function (t) {
  return T(this, undefined), t.showProgressBar && t.autoplay && Lt(Au(), 2 * Math.round(parseInt(t.buttonsOffsetFromProgressBar, 10)), 2 * Math.round(parseInt(t.buttonsOffsetFromProgressBar, 10)));
}.bind(void 0), function (t) {
  return T(this, undefined), "right" === t.thumbnailsPosition && Lt(Pu(), t.thumbnailsDivSizes.width + 5, t.thumbnailsDivSizes.width + 5);
}.bind(void 0), function (t) {
  return T(this, undefined), t.hideThumbnails && "right" === t.thumbnailsPosition && Lt(Lu());
}.bind(void 0)),
    Nu = qt(Ru)(ku()),
    zu = qt(Ru)(Tu()),
    Mu = qt(Ru)(Cu()),
    Iu = qt(Ru)(Su(), function (t) {
  return T(this, undefined), 0 === t.autoplaySpeed ? "none" : "flex";
}.bind(void 0)),
    Vu = qt(Ru)(Eu(), function (t) {
  return T(this, undefined), "right" === t.thumbnailsPosition && Lt(wu());
}.bind(void 0), function (t) {
  return T(this, undefined), "left" === t.thumbnailsPosition && Lt(xu());
}.bind(void 0)),
    _u = qt(Ru)(bu()),
    Fu = qt(Ru)(yu(), function (t) {
  return T(this, undefined), "right" === t.thumbnailsPosition && Lt(gu(), t.thumbnailsDivSizes.width + 5, t.thumbnailsDivSizes.width + 5);
}.bind(void 0), function (t) {
  return T(this, undefined), t.hideThumbnails && "right" === t.thumbnailsPosition && Lt(vu());
}.bind(void 0)),
    ju = qt(Ru)(mu(), function (t) {
  return T(this, undefined), "left" === t.thumbnailsPosition && Lt(pu(), t.thumbnailsDivSizes.width + 5, t.thumbnailsDivSizes.width + 5);
}.bind(void 0), function (t) {
  return T(this, undefined), t.hideThumbnails && "left" === t.thumbnailsPosition && Lt(hu());
}.bind(void 0)),
    Hu = function (n) {
  var e = this;
  T(this, undefined);
  var r = n.autoplay,
      i = n.buttons,
      o = n.buttonsOffsetFromProgressBar,
      a = n.currentElementID,
      s = n.handleCloseLightbox,
      u = n.handleFullScreen,
      c = n.handleImageDownload,
      l = n.handleNextElement,
      d = n.handlePanzoom,
      f = n.handlePrevElement,
      h = n.handleThumbnails,
      p = n.hideThumbnails,
      m = n.panzoomEnabled,
      v = n.setAutoplay,
      g = n.settings,
      y = n.showProgressBar,
      b = n.showThumbnails,
      x = n.SRLThumbnailsRef,
      w = n.thumbnailsPosition,
      E = n.thumbnailsSize,
      S = n.translations,
      C = L(Ws(x), 1)[0];
  return t.createElement(t.Fragment, null, t.createElement(Du, {
    className: "SRLControls",
    autoplay: r,
    showProgressBar: y,
    buttonsOffsetFromProgressBar: o,
    thumbnailsPosition: w,
    thumbnailsDivSizes: C,
    thumbnailsSize: E,
    hideThumbnails: p
  }, i.showAutoplayButton && t.createElement(Iu, {
    buttonsBackgroundColor: i.backgroundColor,
    buttonsIconColor: i.iconColor,
    buttonsSize: i.size,
    buttonsIconPadding: i.iconPadding,
    autoplaySpeed: g.autoplaySpeed,
    title: r ? S.pauseText : S.autoplayText,
    className: "SRLAutoplayButton",
    onClick: function () {
      return T(this, e), v(!r);
    }.bind(this)
  }, t.createElement("div", {
    className: "SRLAutoplayButton"
  }, r ? t.createElement("svg", {
    className: "SRLAutoplayButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, t.createElement("path", {
    className: "SRLAutoplayButton",
    d: "M14.2 38.7h5.9c1.6 0 2.9-1.3 2.9-2.9V14.2c0-1.6-1.3-2.9-2.9-2.9h-5.9c-1.6 0-2.9 1.3-2.9 2.9v21.6c0 1.6 1.3 2.9 2.9 2.9zm-1-24.5c0-.5.4-1 1-1h5.9c.5 0 1 .4 1 1v21.6c0 .5-.4 1-1 1h-5.9c-.5 0-1-.4-1-1V14.2zm16.7 24.5h5.9c1.6 0 2.9-1.3 2.9-2.9V14.2c0-1.6-1.3-2.9-2.9-2.9h-5.9c-1.6 0-2.9 1.3-2.9 2.9v21.6c0 1.6 1.3 2.9 2.9 2.9zm-1-24.5c0-.5.4-1 1-1h5.9c.5 0 1 .4 1 1v21.6c0 .5-.4 1-1 1h-5.9c-.5 0-1-.4-1-1V14.2z"
  })) : t.createElement("svg", {
    className: "SRLAutoplayButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, t.createElement("path", {
    className: "SRLAutoplayButton",
    d: "M35.7 22.8L16.9 11.6c-1.5-.9-3.9 0-3.9 2.2v22.3c0 2 2.2 3.2 3.9 2.2l18.9-11.1c1.6-1 1.6-3.4-.1-4.4zm-.8 2.9L16 36.9c-.6.3-1.3-.1-1.3-.7V13.8c0-.9.9-1 1.3-.7l18.9 11.1c.5.4.5 1.2 0 1.5z"
  })))), i.showThumbnailsButton && b && t.createElement(Vu, {
    buttonsBackgroundColor: i.backgroundColor,
    buttonsIconColor: i.iconColor,
    buttonsSize: i.size,
    buttonsIconPadding: i.iconPadding,
    thumbnailsPosition: w,
    onClick: h,
    title: S.thumbnailsText,
    className: "SRLThumbnailsButton"
  }, t.createElement("div", {
    className: "SRLThumbnailsButton"
  }, t.createElement("svg", {
    className: "SRLThumbnailsButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, t.createElement("g", {
    fill: "#fff",
    className: "SRLThumbnailsButton"
  }, t.createElement("path", {
    className: "SRLThumbnailsButton",
    d: "M15.4 27.4h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4zm12 0h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4zm12 0h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4z",
    opacity: ".4"
  }), t.createElement("path", {
    className: "SRLThumbnailsButton",
    d: "M39.4 13h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4zm-24 0h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4zm12 0h-4.8c-1.3 0-2.4 1.1-2.4 2.4v4.8c0 1.3 1.1 2.4 2.4 2.4h4.8c1.3 0 2.4-1.1 2.4-2.4v-4.8c0-1.3-1.1-2.4-2.4-2.4z"
  }))))), i.showDownloadButton && t.createElement(_u, {
    buttonsBackgroundColor: i.backgroundColor,
    buttonsIconColor: i.iconColor,
    buttonsSize: i.size,
    buttonsIconPadding: i.iconPadding,
    title: S.downloadText,
    className: "SRLDownloadButton",
    onClick: c
  }, t.createElement("div", {
    className: "SRLDownloadButton"
  }, t.createElement("svg", {
    className: "SRLDownloadButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, t.createElement("path", {
    className: "SRLDownloadButton",
    d: "M35.7 34.1c0 .6-.5 1-1.1 1-.6 0-1.1-.5-1.1-1s.5-1 1.1-1c.6 0 1.1.5 1.1 1zm-4.6-1c-.6 0-1.1.5-1.1 1s.5 1 1.1 1c.6 0 1.1-.5 1.1-1s-.5-1-1.1-1zm7.8-2.5V36c0 1.3-1.1 2.3-2.4 2.3h-23c-1.3 0-2.4-1-2.4-2.3v-5.4c0-1.3 1.1-2.3 2.4-2.3h5.4l-3.1-2.9c-1.4-1.3-.4-3.5 1.5-3.5h2.9v-8.1c0-1.1 1-2.1 2.2-2.1h5.2c1.2 0 2.2.9 2.2 2.1v8.1h2.9c1.9 0 2.9 2.2 1.5 3.5l-3.1 2.9h5.4c1.3 0 2.4 1 2.4 2.3zm-14.2.9c.2.2.4.2.6 0l7.6-7.3c.3-.3.1-.7-.3-.7H28v-9.7c0-.2-.2-.4-.4-.4h-5.2c-.2 0-.4.2-.4.4v9.7h-4.6c-.4 0-.6.4-.3.7l7.6 7.3zm12.5-.9c0-.3-.3-.6-.7-.6h-7.1l-2.8 2.7c-.8.8-2.2.8-3.1 0L20.6 30h-7.1c-.4 0-.7.3-.7.6V36c0 .3.3.6.7.6h23c.4 0 .7-.3.7-.6v-5.4z"
  })))), m ? t.createElement(Mu, {
    buttonsBackgroundColor: i.backgroundColor,
    buttonsIconColor: i.iconColor,
    buttonsSize: i.size,
    buttonsIconPadding: i.iconPadding,
    title: S.zoomOutText,
    className: "SRLZoomOutButton",
    onClick: function () {
      return T(this, e), d(!1);
    }.bind(this)
  }, t.createElement("div", {
    className: "SRLZoomOutButton"
  }, t.createElement("svg", {
    className: "SRLZoomOutButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, t.createElement("path", {
    className: "SRLZoomOutButton",
    d: "M27.9 21.6v1.3c0 .4-.3.7-.7.7h-10c-.4 0-.7-.3-.7-.7v-1.3c0-.4.3-.7.7-.7h10c.4 0 .7.3.7.7zm10.7 15.8l-1.2 1.2c-.3.3-.7.3-.9 0L29.9 32c-.1-.1-.2-.3-.2-.5v-.7c-2 1.7-4.6 2.8-7.4 2.8C16 33.6 11 28.5 11 22.3s5-11.4 11.3-11.4S33.6 16 33.6 22.3c0 2.8-1 5.4-2.8 7.4h.7c.2 0 .3.1.5.2l6.6 6.6c.3.2.3.6 0 .9zM31 22.3c0-4.8-3.9-8.7-8.7-8.7s-8.7 3.9-8.7 8.7 3.9 8.7 8.7 8.7 8.7-3.9 8.7-8.7z"
  })))) : "", i.showFullscreenButton && t.createElement(zu, {
    buttonsBackgroundColor: i.backgroundColor,
    buttonsIconColor: i.iconColor,
    buttonsSize: i.size,
    buttonsIconPadding: i.iconPadding,
    title: S.fullscreenText,
    className: "SRLExpandButton",
    onClick: function () {
      return T(this, e), u();
    }.bind(this)
  }, t.createElement("div", {
    className: "SRLExpandButton"
  }, t.createElement("svg", {
    className: "SRLExpandButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, t.createElement("path", {
    className: "SRLExpandButton",
    d: "M11.22 20.66v-7.91a1.52 1.52 0 011.53-1.53h7.91a.76.76 0 01.76.76v1.53a.77.77 0 01-.76.77h-6.38v6.38a.77.77 0 01-.77.76H12a.76.76 0 01-.78-.76zM29.58 12v1.53a.78.78 0 00.77.77h6.38v6.38a.76.76 0 00.76.76H39a.77.77 0 00.77-.76v-7.93a1.52 1.52 0 00-1.53-1.53h-7.89a.77.77 0 00-.77.78zM39 29.58h-1.51a.77.77 0 00-.76.77v6.38h-6.38a.77.77 0 00-.77.76V39a.78.78 0 00.77.77h7.91a1.52 1.52 0 001.53-1.53v-7.89a.78.78 0 00-.79-.77zM21.42 39v-1.51a.76.76 0 00-.76-.76h-6.38v-6.38a.78.78 0 00-.77-.77H12a.77.77 0 00-.76.77v7.91a1.52 1.52 0 001.53 1.53h7.91a.77.77 0 00.74-.79z"
  })))), i.showCloseButton && t.createElement(Nu, {
    buttonsBackgroundColor: i.backgroundColor,
    buttonsIconColor: i.iconColor,
    buttonsSize: i.size,
    buttonsIconPadding: i.iconPadding,
    title: S.closeText,
    className: "SRLCloseButton",
    onClick: function () {
      return T(this, e), s();
    }.bind(this)
  }, t.createElement("div", {
    className: "SRLCloseButton"
  }, t.createElement("svg", {
    className: "SRLCloseButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, t.createElement("path", {
    className: "SRLCloseButton",
    d: "M27.92 25l8.84-8.84 1.82-1.82c.27-.27.27-.71 0-.97l-1.95-1.95a.682.682 0 0 0-.97 0L25 22.08 14.34 11.42a.682.682 0 0 0-.97 0l-1.95 1.95c-.27.27-.27.71 0 .97L22.08 25 11.42 35.66c-.27.27-.27.71 0 .97l1.95 1.95c.27.27.71.27.97 0L25 27.92l8.84 8.84 1.82 1.82c.27.27.71.27.97 0l1.95-1.95c.27-.27.27-.71 0-.97L27.92 25z"
  }))))), i.showNextButton && t.createElement(Fu, {
    buttonsBackgroundColor: i.backgroundColor,
    buttonsIconColor: i.iconColor,
    buttonsSize: i.size,
    buttonsIconPadding: i.iconPadding,
    thumbnailsPosition: w,
    thumbnailsDivSizes: C,
    thumbnailsSize: E,
    hideThumbnails: p,
    title: S.nextText,
    className: "SRLNextButton",
    onClick: function () {
      return T(this, e), l(a);
    }.bind(this)
  }, t.createElement("div", {
    className: "SRLNextButton"
  }, t.createElement("svg", {
    className: "SRLNextButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, t.createElement("path", {
    className: "SRLPrevButton",
    d: "M24.53 11.36l-.44.44c-.29.29-.29.76 0 1.05l11.09 11.09H11.83c-.41 0-.75.33-.75.75v.62c0 .41.33.75.75.75h23.35L24.09 37.14c-.29.29-.29.76 0 1.05l.44.44c.29.29.76.29 1.05 0l13.11-13.11c.29-.29.29-.76 0-1.05l-13.1-13.11a.754.754 0 0 0-1.06 0z"
  })))), i.showPrevButton && t.createElement(ju, {
    buttonsBackgroundColor: i.backgroundColor,
    buttonsIconColor: i.iconColor,
    buttonsSize: i.size,
    buttonsIconPadding: i.iconPadding,
    title: S.previousText,
    className: "SRLPrevButton",
    thumbnailsPosition: w,
    thumbnailsDivSizes: C,
    thumbnailsSize: E,
    hideThumbnails: p,
    onClick: function () {
      return T(this, e), f(a);
    }.bind(this)
  }, t.createElement("div", {
    className: "SRLPrevButton"
  }, t.createElement("svg", {
    className: "SRLPrevButton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, t.createElement("path", {
    className: "SRLPrevButton",
    d: "M25.47 38.64l.44-.44c.29-.29.29-.76 0-1.05L14.82 26.06h23.35c.41 0 .75-.33.75-.75v-.62c0-.41-.33-.75-.75-.75H14.82l11.09-11.09c.29-.29.29-.76 0-1.05l-.44-.44a.742.742 0 0 0-1.05 0L11.31 24.47c-.29.29-.29.76 0 1.05l13.11 13.11c.29.3.76.3 1.05.01z"
  })))));
}.bind(void 0);

Hu.propTypes = {
  autoplay: v.bool,
  buttons: v.shape({
    backgroundColor: v.string,
    iconColor: v.string,
    iconPadding: v.string,
    showAutoplayButton: v.bool,
    showCloseButton: v.bool,
    showDownloadButton: v.bool,
    showFullscreenButton: v.bool,
    showNextButton: v.bool,
    showPrevButton: v.bool,
    showThumbnailsButton: v.bool,
    size: v.string
  }),
  hideThumbnails: v.bool,
  buttonsOffsetFromProgressBar: v.string,
  currentElementID: v.string,
  handleCloseLightbox: v.func,
  handleFullScreen: v.func,
  handleImageDownload: v.func,
  handleNextElement: v.func,
  handlePanzoom: v.func,
  handlePrevElement: v.func,
  handleThumbnails: v.func,
  panzoomEnabled: v.bool,
  setAutoplay: v.func,
  settings: v.shape({
    autoplaySpeed: v.number
  }),
  showProgressBar: v.bool,
  showThumbnails: v.bool,
  thumbnailsPosition: v.string,
  SRLThumbnailsRef: v.object,
  thumbnailsSize: v.array,
  translations: v.shape({
    autoplayText: v.string,
    closeText: v.string,
    downloadText: v.string,
    fullscreenText: v.string,
    nextText: v.string,
    pauseText: v.string,
    previousText: v.string,
    thumbnailsText: v.string,
    zoomOutText: v.string
  })
};

function Uu() {
  var t = k(["\n  height: ", ";\n  width: 100%;\n  background-color: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: scaleX(0);\n  transform-origin: 0;\n"]);
  return Uu = function Uu() {
    return t;
  }, t;
}

function Wu() {
  var t = k(["\n  width: 100%;\n  height: ", ";\n  background-color: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n"]);
  return Wu = function Wu() {
    return t;
  }, t;
}

var qu = qt.div(Wu(), function (t) {
  return T(this, undefined), t.barHeight;
}.bind(void 0), function (t) {
  return T(this, undefined), t.backgroundColor;
}.bind(void 0)),
    Yu = qt.div(Uu(), function (t) {
  return T(this, undefined), t.barHeight;
}.bind(void 0), function (t) {
  return T(this, undefined), t.fillColor;
}.bind(void 0)),
    Xu = function (n) {
  var e = this;
  T(this, undefined);
  var r = n.autoplay,
      a = n.autoplaySpeed,
      s = n.progressBar,
      u = n.currentElementID,
      c = L(i(!1), 2),
      l = c[0],
      d = c[1];
  return o(function () {
    T(this, e), d(!1);
  }.bind(this), [u]), Us(function () {
    T(this, e), d(!0);
  }.bind(this), r ? a / 100 : null, u), t.createElement(qu, {
    barHeight: s.height,
    backgroundColor: s.backgroundColor,
    className: "SRLProgressBar"
  }, t.createElement(Yu, {
    barHeight: s.height,
    fillColor: s.fillColor,
    style: {
      transform: "scaleX(".concat(l ? 1 : 0, ")"),
      transitionDuration: "".concat(l ? a + "ms" : "0ms")
    }
  }));
}.bind(void 0);

Xu.propTypes = {
  autoplay: v.bool,
  autoplaySpeed: v.number,
  currentElementID: v.string,
  progressBar: v.shape({
    backgroundColor: v.string,
    fillColor: v.string,
    height: v.string
  })
};

var Gu = Ku,
    Zu = Ku,
    $u = function $u(t, n, e) {
  t.removeEventListener("wheel", n, e);
};

function Ku(t, n, e) {
  t.addEventListener("wheel", n, e);
}

Gu.addWheelListener = Zu, Gu.removeWheelListener = $u;
var Ju = "function" == typeof Float32Array;

function Qu(t, n) {
  return 1 - 3 * n + 3 * t;
}

function tc(t, n) {
  return 3 * n - 6 * t;
}

function nc(t) {
  return 3 * t;
}

function ec(t, n, e) {
  return ((Qu(n, e) * t + tc(n, e)) * t + nc(n)) * t;
}

function rc(t, n, e) {
  return 3 * Qu(n, e) * t * t + 2 * tc(n, e) * t + nc(n);
}

function ic(t) {
  return t;
}

var oc = function oc(t, n, e, r) {
  if (!(0 <= t && t <= 1 && 0 <= e && e <= 1)) throw new Error("bezier x values must be in [0, 1] range");
  if (t === n && e === r) return ic;

  for (var i = Ju ? new Float32Array(11) : new Array(11), o = 0; o < 11; ++o) {
    i[o] = ec(.1 * o, t, e);
  }

  function a(n) {
    for (var r = 0, o = 1; 10 !== o && i[o] <= n; ++o) {
      r += .1;
    }

    --o;
    var a = r + .1 * ((n - i[o]) / (i[o + 1] - i[o])),
        s = rc(a, t, e);
    return s >= .001 ? function (t, n, e, r) {
      for (var i = 0; i < 4; ++i) {
        var o = rc(n, e, r);
        if (0 === o) return n;
        n -= (ec(n, e, r) - t) / o;
      }

      return n;
    }(n, a, t, e) : 0 === s ? a : function (t, n, e, r, i) {
      var o,
          a,
          s = 0;

      do {
        (o = ec(a = n + (e - n) / 2, r, i) - t) > 0 ? e = a : n = a;
      } while (Math.abs(o) > 1e-7 && ++s < 10);

      return a;
    }(n, r, r + .1, t, e);
  }

  return function (t) {
    return 0 === t ? 0 : 1 === t ? 1 : ec(a(t), n, r);
  };
},
    ac = {
  ease: oc(.25, .1, .25, 1),
  easeIn: oc(.42, 0, 1, 1),
  easeOut: oc(0, 0, .58, 1),
  easeInOut: oc(.42, 0, .58, 1),
  linear: oc(0, 0, 1, 1)
},
    sc = function sc(t, n, e) {
  var r = Object.create(null),
      i = Object.create(null),
      o = "function" == typeof (e = e || {}).easing ? e.easing : ac[e.easing];
  o || (e.easing && console.warn("Unknown easing function in amator: " + e.easing), o = ac.ease);

  var a = "function" == typeof e.step ? e.step : lc,
      s = "function" == typeof e.done ? e.done : lc,
      u = function (t) {
    if (!t) {
      return "undefined" != typeof window && window.requestAnimationFrame ? {
        next: window.requestAnimationFrame.bind(window),
        cancel: window.cancelAnimationFrame.bind(window)
      } : {
        next: function next(t) {
          return setTimeout(t, 1e3 / 60);
        },
        cancel: function cancel(t) {
          return clearTimeout(t);
        }
      };
    }

    if ("function" != typeof t.next) throw new Error("Scheduler is supposed to have next(cb) function");
    if ("function" != typeof t.cancel) throw new Error("Scheduler is supposed to have cancel(handle) function");
    return t;
  }(e.scheduler),
      c = Object.keys(n);

  c.forEach(function (e) {
    r[e] = t[e], i[e] = n[e] - t[e];
  });
  var l,
      d = "number" == typeof e.duration ? e.duration : 400,
      f = Math.max(1, .06 * d),
      h = 0;
  return l = u.next(p), {
    cancel: function cancel() {
      u.cancel(l), l = 0;
    }
  };

  function p() {
    var n = o(h / f);
    h += 1, function (n) {
      c.forEach(function (e) {
        t[e] = i[e] * n + r[e];
      });
    }(n), h <= f ? (l = u.next(p), a(t)) : (l = 0, setTimeout(function () {
      s(t);
    }, 0));
  }
},
    uc = dc,
    cc = dc();

function lc() {}

function dc() {
  var t = new Set(),
      n = new Set(),
      e = 0;
  return {
    next: r,
    cancel: r,
    clearAll: function clearAll() {
      t.clear(), n.clear(), cancelAnimationFrame(e), e = 0;
    }
  };

  function r(t) {
    n.add(t), e || (e = requestAnimationFrame(i));
  }

  function i() {
    e = 0;
    var r = n;
    n = t, (t = r).forEach(function (t) {
      t();
    }), t.clear();
  }
}

sc.makeAggregateRaf = uc, sc.sharedScheduler = cc;

var fc = function fc(t) {
  !function (t) {
    if (!t) throw new Error("Eventify cannot use falsy object as events subject");

    for (var n = ["on", "fire", "off"], e = 0; e < n.length; ++e) {
      if (t.hasOwnProperty(n[e])) throw new Error("Subject cannot be eventified, since it already has property '" + n[e] + "'");
    }
  }(t);

  var n = function (t) {
    var n = Object.create(null);
    return {
      on: function on(e, r, i) {
        if ("function" != typeof r) throw new Error("callback is expected to be a function");
        var o = n[e];
        return o || (o = n[e] = []), o.push({
          callback: r,
          ctx: i
        }), t;
      },
      off: function off(e, r) {
        if (void 0 === e) return n = Object.create(null), t;
        if (n[e]) if ("function" != typeof r) delete n[e];else for (var i = n[e], o = 0; o < i.length; ++o) {
          i[o].callback === r && i.splice(o, 1);
        }
        return t;
      },
      fire: function fire(e) {
        var r,
            i = n[e];
        if (!i) return t;
        arguments.length > 1 && (r = Array.prototype.splice.call(arguments, 1));

        for (var o = 0; o < i.length; ++o) {
          var a = i[o];
          a.callback.apply(a.ctx, r);
        }

        return t;
      }
    };
  }(t);

  return t.on = n.on, t.off = n.off, t.fire = n.fire, t;
};

var hc = function hc(t, n, e) {
  "object" != typeof e && (e = {});
  var r,
      i,
      o,
      a,
      s,
      u,
      c,
      l,
      d,
      f,
      h = "number" == typeof e.minVelocity ? e.minVelocity : 5,
      p = "number" == typeof e.amplitude ? e.amplitude : .25,
      m = "function" == typeof e.cancelAnimationFrame ? e.cancelAnimationFrame : pc(),
      v = "function" == typeof e.requestAnimationFrame ? e.requestAnimationFrame : mc();
  return {
    start: function start() {
      r = t(), u = d = a = c = 0, i = new Date(), m(o), m(f), o = v(g);
    },
    stop: function stop() {
      m(o), m(f);
      var n = t();
      s = n.x, l = n.y, i = Date.now(), (a < -h || a > h) && (s += u = p * a);
      (c < -h || c > h) && (l += d = p * c);
      f = v(y);
    },
    cancel: function cancel() {
      m(o), m(f);
    }
  };

  function g() {
    var n = Date.now(),
        e = n - i;
    i = n;
    var s = t(),
        u = s.x - r.x,
        l = s.y - r.y;
    r = s;
    var d = 1e3 / (1 + e);
    a = .8 * u * d + .2 * a, c = .8 * l * d + .2 * c, o = v(g);
  }

  function y() {
    var t = Date.now() - i,
        e = !1,
        r = 0,
        o = 0;
    u && ((r = -u * Math.exp(-t / 342)) > .5 || r < -.5 ? e = !0 : r = u = 0), d && ((o = -d * Math.exp(-t / 342)) > .5 || o < -.5 ? e = !0 : o = d = 0), e && (n(s + r, l + o), f = v(y));
  }
};

function pc() {
  return "function" == typeof cancelAnimationFrame ? cancelAnimationFrame : clearTimeout;
}

function mc() {
  return "function" == typeof requestAnimationFrame ? requestAnimationFrame : function (t) {
    return setTimeout(t, 16);
  };
}

var vc = function vc(t) {
  if (t) return {
    capture: yc,
    release: yc
  };
  var n,
      e,
      r,
      i = !1;
  return {
    capture: function capture(t) {
      i = !0, e = window.document.onselectstart, r = window.document.ondragstart, window.document.onselectstart = gc, (n = t).ondragstart = gc;
    },
    release: function release() {
      if (!i) return;
      i = !1, window.document.onselectstart = e, n && (n.ondragstart = r);
    }
  };
};

function gc(t) {
  return t.stopPropagation(), !1;
}

function yc() {}

var bc = function bc() {
  this.x = 0, this.y = 0, this.scale = 1;
};

var xc = function xc(t, n) {
  if (!Ec(t)) throw new Error("svg element is required for svg.panzoom to work");
  var e = t.ownerSVGElement;
  if (!e) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
  n.disableKeyboardInteraction || e.setAttribute("tabindex", 0);
  return {
    getBBox: function getBBox() {
      var n = t.getBBox();
      return {
        left: n.x,
        top: n.y,
        width: n.width,
        height: n.height
      };
    },
    getScreenCTM: function getScreenCTM() {
      var t = e.getCTM();
      if (!t) return e.getScreenCTM();
      return t;
    },
    getOwner: function getOwner() {
      return e;
    },
    applyTransform: function applyTransform(n) {
      t.setAttribute("transform", "matrix(" + n.scale + " 0 0 " + n.scale + " " + n.x + " " + n.y + ")");
    },
    initTransform: function initTransform(n) {
      var r = t.getCTM();
      null === r && (r = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix());
      n.x = r.e, n.y = r.f, n.scale = r.a, e.removeAttributeNS(null, "viewBox");
    }
  };
},
    wc = Ec;

function Ec(t) {
  return t && t.ownerSVGElement && t.getCTM;
}

xc.canAttach = wc;

var Sc = function Sc(t, n) {
  if (!Tc(t)) throw new Error("panzoom requires DOM element to be attached to the DOM tree");
  var e = t.parentElement;
  t.scrollTop = 0, n.disableKeyboardInteraction || e.setAttribute("tabindex", 0);
  return {
    getBBox: function getBBox() {
      return {
        left: 0,
        top: 0,
        width: t.clientWidth,
        height: t.clientHeight
      };
    },
    getOwner: function getOwner() {
      return e;
    },
    applyTransform: function applyTransform(n) {
      t.style.transformOrigin = "0 0 0", t.style.transform = "matrix(" + n.scale + ", 0, 0, " + n.scale + ", " + n.x + ", " + n.y + ")";
    }
  };
},
    Cc = Tc;

function Tc(t) {
  return t && t.parentElement && t.style;
}

Sc.canAttach = Cc;
var kc = vc(),
    Lc = vc(!0),
    Pc = Ac;

function Ac(t, n) {
  var e = (n = n || {}).controller;
  if (e || (xc.canAttach(t) ? e = xc(t, n) : Sc.canAttach(t) && (e = Sc(t, n))), !e) throw new Error("Cannot create panzoom for the current type of dom element");
  var r = e.getOwner(),
      i = {
    x: 0,
    y: 0
  },
      o = !1,
      a = new bc();
  e.initTransform && e.initTransform(a);
  var s,
      u = "function" == typeof n.filterKey ? n.filterKey : Rc,
      c = "number" == typeof n.pinchSpeed ? n.pinchSpeed : 1,
      l = n.bounds,
      d = "number" == typeof n.maxZoom ? n.maxZoom : Number.POSITIVE_INFINITY,
      f = "number" == typeof n.minZoom ? n.minZoom : 0,
      h = "number" == typeof n.boundsPadding ? n.boundsPadding : .05,
      p = "number" == typeof n.zoomDoubleClickSpeed ? n.zoomDoubleClickSpeed : 1.75,
      m = n.beforeWheel || Rc,
      v = n.beforeMouseDown || Rc,
      g = "number" == typeof n.zoomSpeed ? n.zoomSpeed : 1,
      y = Oc(n.transformOrigin),
      b = n.enableTextSelection ? Lc : kc;
  !function (t) {
    var n = typeof t;
    if ("undefined" === n || "boolean" === n) return;
    if (!(Dc(t.left) && Dc(t.top) && Dc(t.bottom) && Dc(t.right))) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
  }(l), n.autocenter && function () {
    var t,
        n,
        i = 0,
        o = 0,
        s = I();
    if (s) i = s.left, o = s.top, t = s.right - s.left, n = s.bottom - s.top;else {
      var u = r.getBoundingClientRect();
      t = u.width, n = u.height;
    }
    var c = e.getBBox();
    if (0 === c.width || 0 === c.height) return;
    var l = n / c.height,
        d = t / c.width,
        f = Math.min(d, l);
    a.x = -(c.left + c.width / 2) * f + t / 2 + i, a.y = -(c.top + c.height / 2) * f + n / 2 + o, a.scale = f;
  }();
  var x,
      w,
      E,
      S,
      C,
      T,
      k,
      L,
      P = 0,
      A = !1,
      O = !1;
  C = "smoothScroll" in n && !n.smoothScroll ? {
    start: Rc,
    stop: Rc,
    cancel: Rc
  } : hc(function () {
    return {
      x: a.x,
      y: a.y
    };
  }, function (t, n) {
    ut(), N(t, n);
  }, n.smoothScroll);
  var B = !1;
  H();
  var R = {
    dispose: function dispose() {
      U();
    },
    moveBy: j,
    moveTo: N,
    centerOn: function centerOn(t) {
      var n = t.ownerSVGElement;
      if (!n) throw new Error("ui element is required to be within the scene");
      var e = t.getBoundingClientRect(),
          r = e.left + e.width / 2,
          i = e.top + e.height / 2,
          o = n.getBoundingClientRect(),
          a = o.width / 2 - r,
          s = o.height / 2 - i;
      j(a, s, !0);
    },
    zoomTo: st,
    zoomAbs: F,
    smoothZoom: ot,
    smoothZoomAbs: function smoothZoomAbs(t, n, e) {
      var r = {
        scale: a.scale
      },
          i = {
        scale: e
      };
      C.cancel(), ut(), k = sc(r, i, {
        step: function step(e) {
          F(t, n, e.scale);
        }
      });
    },
    showRectangle: function showRectangle(t) {
      var n = r.getBoundingClientRect(),
          e = D(n.width, n.height),
          i = t.right - t.left,
          o = t.bottom - t.top;
      if (!Number.isFinite(i) || !Number.isFinite(o)) throw new Error("Invalid rectangle");
      var s = e.x / i,
          u = e.y / o,
          c = Math.min(s, u);
      a.x = -(t.left + i / 2) * c + e.x / 2, a.y = -(t.top + o / 2) * c + e.y / 2, a.scale = c;
    },
    pause: function pause() {
      U(), B = !0;
    },
    resume: function resume() {
      B && (H(), B = !1);
    },
    isPaused: function isPaused() {
      return B;
    },
    getTransform: function getTransform() {
      return a;
    },
    getMinZoom: function getMinZoom() {
      return f;
    },
    setMinZoom: function setMinZoom(t) {
      f = t;
    },
    getMaxZoom: function getMaxZoom() {
      return d;
    },
    setMaxZoom: function setMaxZoom(t) {
      d = t;
    },
    getTransformOrigin: function getTransformOrigin() {
      return y;
    },
    setTransformOrigin: function setTransformOrigin(t) {
      y = Oc(t);
    },
    getZoomSpeed: function getZoomSpeed() {
      return g;
    },
    setZoomSpeed: function setZoomSpeed(t) {
      if (!Number.isFinite(t)) throw new Error("Zoom speed should be a number");
      g = t;
    }
  };
  return fc(R), R;

  function D(t, n) {
    if (e.getScreenCTM) {
      var r = e.getScreenCTM(),
          o = r.a,
          a = r.d,
          s = r.e,
          u = r.f;
      i.x = t * o - s, i.y = n * a - u;
    } else i.x = t, i.y = n;

    return i;
  }

  function N(t, n) {
    a.x = t, a.y = n, M(), ht("pan"), V();
  }

  function z(t, n) {
    N(a.x + t, a.y + n);
  }

  function M() {
    var t = I();

    if (t) {
      var n,
          r,
          i,
          o,
          s = !1,
          u = (n = e.getBBox(), i = n.left, o = n.top, {
        left: (r = {
          x: i * a.scale + a.x,
          y: o * a.scale + a.y
        }).x,
        top: r.y,
        right: n.width * a.scale + r.x,
        bottom: n.height * a.scale + r.y
      }),
          c = t.left - u.right;
      return c > 0 && (a.x += c, s = !0), (c = t.right - u.left) < 0 && (a.x += c, s = !0), (c = t.top - u.bottom) > 0 && (a.y += c, s = !0), (c = t.bottom - u.top) < 0 && (a.y += c, s = !0), s;
    }
  }

  function I() {
    if (l) {
      if ("boolean" == typeof l) {
        var t = r.getBoundingClientRect(),
            n = t.width,
            e = t.height;
        return {
          left: n * h,
          top: e * h,
          right: n * (1 - h),
          bottom: e * (1 - h)
        };
      }

      return l;
    }
  }

  function V() {
    o = !0, s = window.requestAnimationFrame(W);
  }

  function _(t, n, e) {
    if (Nc(t) || Nc(n) || Nc(e)) throw new Error("zoom requires valid numbers");
    var r = a.scale * e;

    if (r < f) {
      if (a.scale === f) return;
      e = f / a.scale;
    }

    if (r > d) {
      if (a.scale === d) return;
      e = d / a.scale;
    }

    var i = D(t, n);
    (a.x = i.x - e * (i.x - a.x), a.y = i.y - e * (i.y - a.y), l && 1 === h && 1 === f) ? (a.scale *= e, M()) : M() || (a.scale *= e);
    ht("zoom"), V();
  }

  function F(t, n, e) {
    _(t, n, e / a.scale);
  }

  function j(t, n, e) {
    if (!e) return z(t, n);
    T && T.cancel();
    var r = 0,
        i = 0;
    T = sc({
      x: 0,
      y: 0
    }, {
      x: t,
      y: n
    }, {
      step: function step(t) {
        z(t.x - r, t.y - i), r = t.x, i = t.y;
      }
    });
  }

  function H() {
    r.addEventListener("mousedown", J, {
      passive: !1
    }), r.addEventListener("dblclick", K, {
      passive: !1
    }), r.addEventListener("touchstart", Y, {
      passive: !1
    }), r.addEventListener("keydown", q, {
      passive: !1
    }), Gu.addWheelListener(r, rt, {
      passive: !1
    }), V();
  }

  function U() {
    Gu.removeWheelListener(r, rt), r.removeEventListener("mousedown", J), r.removeEventListener("keydown", q), r.removeEventListener("dblclick", K), r.removeEventListener("touchstart", Y), s && (window.cancelAnimationFrame(s), s = 0), C.cancel(), nt(), et(), b.release(), dt();
  }

  function W() {
    o && (o = !1, e.applyTransform(a), ht("transform"), s = 0);
  }

  function q(t) {
    var n = 0,
        e = 0,
        i = 0;

    if (38 === t.keyCode ? e = 1 : 40 === t.keyCode ? e = -1 : 37 === t.keyCode ? n = 1 : 39 === t.keyCode ? n = -1 : 189 === t.keyCode || 109 === t.keyCode ? i = 1 : 187 !== t.keyCode && 107 !== t.keyCode || (i = -1), !u(t, n, e, i)) {
      if (n || e) {
        t.preventDefault(), t.stopPropagation();
        var o = r.getBoundingClientRect();
        j(.05 * (a = Math.min(o.width, o.height)) * n, .05 * a * e);
      }

      if (i) {
        var a,
            s = ct(100 * i);
        st((a = y ? at() : {
          x: (c = r.getBoundingClientRect()).width / 2,
          y: c.height / 2
        }).x, a.y, s);
      }

      var c;
    }
  }

  function Y(t) {
    if (function (t) {
      if (n.onTouch && !n.onTouch(t)) return;
      t.stopPropagation(), t.preventDefault();
    }(t), 1 === t.touches.length) return function (t) {
      var n = it(t.touches[0]);
      x = n;
      var e = D(n.x, n.y);
      w = e.x, E = e.y, C.cancel(), X();
    }(t, t.touches[0]);
    2 === t.touches.length && (S = $(t.touches[0], t.touches[1]), L = !0, X());
  }

  function X() {
    A || (A = !0, document.addEventListener("touchmove", G), document.addEventListener("touchend", Z), document.addEventListener("touchcancel", Z));
  }

  function G(t) {
    if (1 === t.touches.length) {
      t.stopPropagation();
      var n = D((d = it(t.touches[0])).x, d.y),
          e = n.x - w,
          r = n.y - E;
      0 !== e && 0 !== r && lt(), w = n.x, E = n.y, j(e, r);
    } else if (2 === t.touches.length) {
      L = !0;
      var i = t.touches[0],
          o = t.touches[1],
          a = $(i, o),
          s = 1 + (a / S - 1) * c,
          u = it(i),
          l = it(o);

      if (w = (u.x + l.x) / 2, E = (u.y + l.y) / 2, y) {
        var d = at();
        w = d.x, E = d.y;
      }

      st(w, E, s), S = a, t.stopPropagation(), t.preventDefault();
    }
  }

  function Z(t) {
    if (t.touches.length > 0) {
      var n = D((e = it(t.touches[0])).x, e.y);
      w = n.x, E = n.y;
    } else {
      var e,
          r = new Date();
      if (r - P < 300) if (y) ot((e = at()).x, e.y, p);else ot(x.x, x.y, p);
      P = r, dt(), et();
    }
  }

  function $(t, n) {
    var e = t.clientX - n.clientX,
        r = t.clientY - n.clientY;
    return Math.sqrt(e * e + r * r);
  }

  function K(t) {
    !function (t) {
      n.onDoubleClick && !n.onDoubleClick(t) || (t.preventDefault(), t.stopPropagation());
    }(t);
    var e = it(t);
    y && (e = at()), ot(e.x, e.y, p);
  }

  function J(t) {
    if (!v(t)) {
      if (A) return t.stopPropagation(), !1;

      if (1 === t.button && null !== window.event || 0 === t.button) {
        C.cancel();
        var n = it(t),
            e = D(n.x, n.y);
        return w = e.x, E = e.y, document.addEventListener("mousemove", Q), document.addEventListener("mouseup", tt), b.capture(t.target || t.srcElement), !1;
      }
    }
  }

  function Q(t) {
    if (!A) {
      lt();
      var n = it(t),
          e = D(n.x, n.y),
          r = e.x - w,
          i = e.y - E;
      w = e.x, E = e.y, j(r, i);
    }
  }

  function tt() {
    b.release(), dt(), nt();
  }

  function nt() {
    document.removeEventListener("mousemove", Q), document.removeEventListener("mouseup", tt), O = !1;
  }

  function et() {
    document.removeEventListener("touchmove", G), document.removeEventListener("touchend", Z), document.removeEventListener("touchcancel", Z), O = !1, L = !1, A = !1;
  }

  function rt(t) {
    if (!m(t)) {
      C.cancel();
      var n = t.deltaY;
      t.deltaMode > 0 && (n *= 100);
      var e = ct(n);

      if (1 !== e) {
        var r = y ? at() : it(t);
        st(r.x, r.y, e), t.preventDefault();
      }
    }
  }

  function it(t) {
    var n = r.getBoundingClientRect();
    return {
      x: t.clientX - n.left,
      y: t.clientY - n.top
    };
  }

  function ot(t, n, e) {
    var r = a.scale,
        i = {
      scale: r
    },
        o = {
      scale: e * r
    };
    C.cancel(), ut(), k = sc(i, o, {
      step: function step(e) {
        F(t, n, e.scale);
      },
      done: ft
    });
  }

  function at() {
    var t = r.getBoundingClientRect();
    return {
      x: t.width * y.x,
      y: t.height * y.y
    };
  }

  function st(t, n, e) {
    return C.cancel(), ut(), _(t, n, e);
  }

  function ut() {
    k && (k.cancel(), k = null);
  }

  function ct(t) {
    return 1 - Math.sign(t) * Math.min(.25, Math.abs(g * t / 128));
  }

  function lt() {
    O || (ht("panstart"), O = !0, C.start());
  }

  function dt() {
    O && (L || C.stop(), ht("panend"));
  }

  function ft() {
    ht("zoomend");
  }

  function ht(t) {
    R.fire(t, R);
  }
}

function Oc(t) {
  if (t) return "object" == typeof t ? (Dc(t.x) && Dc(t.y) || Bc(t), t) : void Bc();
}

function Bc(t) {
  throw console.error(t), new Error(["Cannot parse transform origin.", "Some good examples:", '  "center center" can be achieved with {x: 0.5, y: 0.5}', '  "top center" can be achieved with {x: 0.5, y: 0}', '  "bottom right" can be achieved with {x: 1, y: 1}'].join("\n"));
}

function Rc() {}

function Dc(t) {
  return Number.isFinite(t);
}

function Nc(t) {
  return Number.isNaN ? Number.isNaN(t) : t != t;
}

!function () {
  if ("undefined" != typeof document) {
    var t = document.getElementsByTagName("script");

    if (t) {
      for (var n, e = 0; e < t.length; ++e) {
        var r = t[e];

        if (r.src && r.src.match(/\bpanzoom(\.min)?\.js/)) {
          n = r;
          break;
        }
      }

      if (n) {
        var i = n.getAttribute("query");

        if (i) {
          var o = n.getAttribute("name") || "pz",
              a = Date.now();
          !function t() {
            var e = document.querySelector(i);

            if (!e) {
              return Date.now() - a < 2e3 ? void setTimeout(t, 100) : void console.error("Cannot find the panzoom element", o);
            }

            var r = function (t) {
              for (var n = t.attributes, e = {}, r = 0; r < n.length; ++r) {
                var i = s(n[r]);
                i && (e[i.name] = i.value);
              }

              return e;
            }(n);

            console.log(r), window[o] = Ac(e, r);
          }();
        }
      }
    }
  }

  function s(t) {
    if (t.name && "p" === t.name[0] && "z" === t.name[1] && "-" === t.name[2]) return {
      name: t.name.substr(3),
      value: JSON.parse(t.value)
    };
  }
}();

var zc = function zc(t) {
  for (var n = [], e = 1; e < arguments.length; e++) {
    n[e - 1] = arguments[e];
  }

  return t.addEventListener.apply(t, n);
},
    Mc = function Mc(t) {
  for (var n = [], e = 1; e < arguments.length; e++) {
    n[e - 1] = arguments[e];
  }

  return t.removeEventListener.apply(t, n);
};

var Ic = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"],
    Vc = function Vc(t, n, e) {
  void 0 === t && (t = 6e4), void 0 === n && (n = !1), void 0 === e && (e = Ic);
  var r = i(n),
      a = r[0],
      s = r[1];
  return o(function () {
    for (var n, r = !0, i = a, o = function o(t) {
      r && (i = t, s(t));
    }, u = function (t, n, e, r) {
      var i,
          o = !1,
          a = 0;

      function s() {
        i && clearTimeout(i);
      }

      function u() {
        for (var u = arguments.length, c = new Array(u), l = 0; l < u; l++) {
          c[l] = arguments[l];
        }

        var d = this,
            f = Date.now() - a;

        function h() {
          a = Date.now(), e.apply(d, c);
        }

        function p() {
          i = void 0;
        }

        o || (r && !i && h(), s(), void 0 === r && f > t ? h() : !0 !== n && (i = setTimeout(r ? p : h, void 0 === r ? t - f : t)));
      }

      return "boolean" != typeof n && (r = e, e = n, n = void 0), u.cancel = function () {
        s(), o = !0;
      }, u;
    }(50, function () {
      i && o(!1), clearTimeout(n), n = setTimeout(function () {
        return o(!0);
      }, t);
    }), c = function c() {
      document.hidden || u();
    }, l = 0; l < e.length; l++) {
      zc(window, e[l], u);
    }

    return zc(document, "visibilitychange", c), n = setTimeout(function () {
      return o(!0);
    }, t), function () {
      r = !1;

      for (var t = 0; t < e.length; t++) {
        Mc(window, e[t], u);
      }

      Mc(document, "visibilitychange", c);
    };
  }, [t, e]), a;
},
    _c = require("lodash/findIndex"),
    Fc = function (n) {
  var a = this;
  T(this, undefined);
  var s = n.options,
      u = n.callbacks,
      c = n.selectedElement,
      l = n.elements,
      d = n.dispatch,
      h = e(R),
      p = r(),
      m = r(),
      v = r(),
      g = r(),
      b = r(),
      w = r(),
      S = s.buttons,
      C = s.settings,
      k = s.progressBar,
      P = s.thumbnails,
      A = u.onCountSlides,
      O = u.onSlideChange,
      B = u.onLightboxClosed,
      D = u.onLightboxOpened,
      N = f(function (t) {
    if (T(this, a), "function" == typeof O) return h.callbacks.onSlideChange(t);
    console.error('Simple React Lightbox error: you are not passing a function in your "onSlideChange" callback! You are passing a '.concat(y(O), "."));
  }.bind(this), [h.callbacks, O]),
      z = f(function (t) {
    T(this, a), "function" == typeof D ? h.callbacks.onLightboxOpened(t) : console.error('Simple React Lightbox error: you are not passing a function in your "onLightboxOpened" callback! You are passing a '.concat(y(D), "."));
  }.bind(this), [h.callbacks, D]),
      M = f(function (t) {
    T(this, a), "function" == typeof B ? h.callbacks.onLightboxClosed(t) : console.error('Simple React Lightbox error: you are not passing a function in your "onLightboxClosed" callback! You are passing a '.concat(y(B), "."));
  }.bind(this), [h.callbacks, B]),
      I = f(function (t) {
    T(this, a), "function" == typeof A ? h.callbacks.onCountSlides(t) : console.error('Simple React Lightbox error: you are not passing a function in your "onCountSlides" callback! You are passing a '.concat(y(A), "."));
  }.bind(this), [h.callbacks, A]),
      V = L(i(!1), 2),
      _ = V[0],
      F = V[1],
      j = L(i(!1), 2),
      H = j[0],
      U = j[1],
      W = L(i(!1), 2),
      q = W[0],
      Y = W[1],
      X = L(i(), 2),
      G = X[0],
      Z = X[1],
      $ = L(i(!1), 2),
      K = $[0],
      J = $[1],
      Q = Vc(C.hideControlsAfter < 1e3 ? 9999999 : C.hideControlsAfter),
      tt = f(function (t) {
    return T(this, a), _c(l, function (n) {
      return n.id === t;
    });
  }.bind(this), [l]),
      nt = f(function (t, n, e) {
    T(this, a), Z(e ? "next" === e ? "next" : "previous" === e ? "previous" : void 0 : t > n ? "next" : t < n ? "previous" : void 0);
  }.bind(this), []),
      et = f(function () {
    T(this, a), J(!K);
  }.bind(this), [K]),
      rt = f(function (t) {
    T(this, a), C.disablePanzoom || (U(t), Y(!1)), H && b.current.dispose();
  }.bind(this), [C.disablePanzoom, H]),
      it = f(function (t, n, e, r) {
    T(this, a), rt(!1), nt(t, n, r), d({
      type: "HANDLE_ELEMENT",
      element: e
    });
  }.bind(this), [nt, rt, d]);

  function ot(t) {
    var n = this;
    return fetch(t).then(function (t) {
      return T(this, n), t.blob();
    }.bind(this)).then(function (t) {
      return T(this, n), URL.createObjectURL(t);
    }.bind(this));
  }

  function at() {
    return (at = x(_regeneratorRuntime.mark(function t() {
      var n;
      return _regeneratorRuntime.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return n = document.createElement("a"), t.next = 3, ot(c.source);

            case 3:
              n.href = t.sent, n.download = "", document.body.appendChild(n), n.click(), document.body.removeChild(n);

            case 8:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))).apply(this, arguments);
  }

  var st = f(function (t, n) {
    T(this, a);
    var e = tt(t),
        r = l[e];
    it(t, n, r), N({
      action: "selected",
      slides: {
        previous: l[e - 1],
        current: r,
        next: l[e + 1]
      },
      index: e
    });
  }.bind(this), [l, tt, N, it]),
      ut = f(function (t) {
    T(this, a);
    var n = tt(t),
        e = l[n - 1] || l[l.length - 1];
    it(t, null, e, "previous");
    var r = n - 1 == -1 ? l.length - 1 : n - 1;
    N({
      action: "left",
      slides: {
        previous: l[r - 1],
        current: e,
        next: l[r + 1]
      },
      index: r
    });
  }.bind(this), [l, tt, N, it]),
      ct = f(function (t) {
    T(this, a);
    var n = tt(t),
        e = l[n + 1] || l[0];
    it(t, null, e, "next");
    var r = n + 1 === l.length ? 0 : n + 1;
    N({
      action: "right",
      slides: {
        previous: l[r - 1],
        current: e,
        next: l[r + 1]
      },
      index: r
    });
  }.bind(this), [l, tt, N, it]),
      lt = f(function () {
    T(this, a), d({
      type: "CLOSE_LIGHTBOX"
    }), M({
      opened: !1,
      currentSlide: h.selectedElement
    });
  }.bind(this), [d, M, h.selectedElement]);
  Us(function () {
    return T(this, a), ct(c.id);
  }.bind(this), _ ? C.autoplaySpeed : null, c.id);
  var dt = L(Fs(function (t) {
    T(this, a), "ArrowRight" !== t && "ArrowUp" !== t || ct(c.id), "ArrowLeft" !== t && "ArrowDown" !== t || ut(c.id), "Escape" === t && lt();
  }.bind(this), 300), 1)[0];
  o(function () {
    var t = this;
    return T(this, a), z({
      opened: !0,
      currentSlide: h.selectedElement
    }), I({
      totalSlide: h.elements.length
    }), "undefined" != typeof window && (document.body.classList.add("SRLOpened"), document.body.style.overflow = "hidden"), function () {
      T(this, t), document.body.classList.remove("SRLOpened"), document.body.style.overflow = "";
    }.bind(this);
  }.bind(this), []), o(function () {
    var t = this;

    if (T(this, a), 0 === C.hideControlsAfter && C.hideControlsAfter || (Q ? null !== g.current && void 0 !== g.current && g.current.classList.add("SRLIdle") : null !== g.current && void 0 !== g.current && g.current.classList.contains("SRLIdle") && g.current.classList.remove("SRLIdle")), !C.disablePanzoom && !q && H) {
      var n = p.current;
      b.current = Pc(n, {
        bounds: !0,
        maxZoom: 3,
        minZoom: .9
      }), void 0 === n && null === n || (b.current.zoomAbs(0, 0, 1.5), b.current.moveTo(0, 0), Y(!0));
    }

    return void 0 === c.id && d({
      type: "HANDLE_ELEMENT",
      element: {
        source: l[0].source,
        caption: l[0].caption,
        id: l[0].id,
        width: l[0].width,
        height: l[0].height
      }
    }), C.disableKeyboardControls || (w.current = js(document, "keydown", function (n) {
      return T(this, t), dt(n.key);
    }.bind(this), !1)), function () {
      T(this, t), C.disableKeyboardControls || w.current();
    }.bind(this);
  }.bind(this), [c.id, l, C.disablePanzoom, C.disableKeyboardControls, H, q, C.hideControlsAfter, Q, dt, G, h, d, c]);
  var ft = {
    autoplay: _,
    buttons: S,
    currentElementID: c.id,
    direction: G,
    handleCloseLightbox: lt,
    handleCurrentElement: st,
    handleFullScreen: function handleFullScreen() {
      var t = this,
          n = "";
      "undefined" != typeof window && (n = document.querySelector("#SRLLightbox")), document.fullscreenElement ? document.exitFullscreen() : (F(!1), null !== n && n.requestFullscreen().then({}).catch(function (n) {
        T(this, t), console.log("An error occurred while trying to switch into full-screen mode: ".concat(n.message, " (").concat(n.name, ")"));
      }.bind(this)));
    },
    handleImageDownload: function handleImageDownload() {
      return at.apply(this, arguments);
    },
    handleNextElement: ct,
    handlePanzoom: rt,
    handlePrevElement: ut,
    handleThumbnails: et,
    hideThumbnails: K,
    panzoomEnabled: H,
    setAutoplay: F,
    settings: C,
    SRLPanzoomImageRef: p,
    SRLThumbnailsRef: m,
    SRLCaptionRef: v
  },
      ht = {
    buttonsBackgroundColor: S.backgroundColor,
    buttonsIconColor: S.iconColor,
    buttonsSize: S.size,
    buttonsIconPadding: S.iconPadding,
    buttonsOffsetFromProgressBar: k.height,
    showProgressBar: k.showProgressBar,
    translations: h.options.translations
  };
  return t.createElement("div", {
    ref: g,
    className: "SRLStage"
  }, k.showProgressBar && _ && t.createElement(Xu, {
    autoplay: _,
    autoplaySpeed: C.autoplaySpeed,
    progressBar: k,
    currentElementID: c.id
  }), t.createElement(Hu, E({}, ht, ft, {
    thumbnailsPosition: P.thumbnailsPosition,
    thumbnailsSize: P.thumbnailsSize,
    thumbnailsContainerPadding: P.thumbnailsContainerPadding,
    showThumbnails: P.showThumbnails,
    SRLThumbnailsRef: m
  })), t.createElement(fu, E({}, c, ft, {
    elements: l,
    options: s
  })));
}.bind(void 0);

function jc() {
  var n = this,
      i = e(R),
      a = i.isOpened,
      s = r();
  return o(function () {
    var t = this;

    function e() {
      s.current = .01 * window.innerHeight, document.documentElement.style.setProperty("--vh", "".concat(s.current, "px"));
    }

    return T(this, n), e(), window.addEventListener("resize", e), function () {
      return T(this, t), window.removeEventListener("resize", e);
    }.bind(this);
  }.bind(this), []), t.createElement(is, null, a && t.createElement(ps, {
    selector: "SRLLightbox",
    isOpened: a
  }, t.createElement(Fc, i)));
}

Fc.propTypes = {
  callbacks: v.object,
  elements: v.array,
  isOpened: v.bool,
  dispatch: v.func,
  selectedElement: v.object,
  SRLPanzoomImageRef: v.object,
  options: v.shape({
    thumbnails: v.shape({
      thumbnailsContainerPadding: v.string,
      thumbnailsPosition: v.string,
      thumbnailsSize: v.array,
      showThumbnails: v.bool
    }),
    settings: v.shape({
      overlayColor: v.string,
      autoplaySpeed: v.number,
      disableKeyboardControls: v.bool,
      disablePanzoom: v.bool,
      hideControlsAfter: v.oneOfType([v.number, v.bool])
    }),
    buttons: v.shape({
      backgroundColor: v.string,
      iconColor: v.string,
      iconPadding: v.string,
      size: v.string
    }),
    progressBar: v.shape({
      showProgressBar: v.bool,
      background: v.string,
      height: v.string
    })
  })
}, jc.propTypes = {
  context: v.object
};

var Hc = function (n) {
  T(this, undefined);
  var e = n.children;
  return t.createElement(D, null, e, t.createElement(jc, null));
}.bind(void 0);

Hc.propTypes = {
  children: v.oneOfType([v.arrayOf(v.node), v.node]).isRequired
};
export default Hc;
export { F as SRLWrapper, Hs as useLightbox };